export default {
  staffBot: {
    title: "Personel botu",
    subtitle: "Belgeleri Telegram üzerinden yükleyin ve görev bildirimleri alın",
    connected: "Bot bağlandı",
    error: "Hata",
    disconnect: "Bağlantıyı kes",
    disconnectConfirm: "Bot bağlantısı kesilsin mi? Çalışanların yeniden bağlanması gerekecek.",
    youLinked: "Telegram hesabınız bağlı",
    howToLink: "Botu açın, /start'a basın ve telefon numaranızı paylaşın — sistemdeki numaranıza göre bağlanır.",
    featureDocs: "Fotoğraf veya PDF + açıklamada müşteri numarası (#123) — dosya anlaşmanın ilgili belge alanına gider",
    featureCard: "Müşteri numarasını yazın — anlaşmaları, aşaması ve borcu",
    featureTasks: "Yeni görevler «Tamamlandı» butonuyla gelir, /tasks — bugünün görevleri",
    connectHint: "@BotFather'da bot oluşturun (/newbot) ve tokenini buraya yapıştırın. Bu bot müşteriler için değil, yalnızca çalışanlar içindir.",
    connect: "Bağla",
    notConnected: "Bot henüz bağlanmadı. Yöneticinize başvurun.",
  },
  dealFinance: {
    tab: "Ödemeler",
    title: "Ödemeler",
    agreed: "Anlaşılan tutar",
    extra: "Ek satışlar",
    paid: "Ödenen",
    debt: "Borç",
    addPayment: "Ödeme ekle",
    addCharge: "Ek satış",
    extraSale: "ek satış",
    delete: "Sil",
    deleteConfirm: "Silinsin mi? Borç yeniden hesaplanacak",
    error: "Hata",
    paymentAdded: "Ödeme eklendi",
    chargeAdded: "Ek satış eklendi",
    cancel: "İptal",
    save: "Kaydet",
    amount: "Tutar",
    date: "Tarih",
    methodLabel: "Ödeme şekli",
    method: {
      cash: "Nakit",
      transfer: "Havale",
      card: "Kart",
    },
    note: "Not",
    chargeHint: "Anlaşılan tutar değişmez — ek hizmet tutarı borca eklenir.",
    chargeTitle: "Hizmet",
    valueLocked: "Anlaşılan tutarı yalnızca yönetici değiştirebilir",
    payments: "Tahsilatlar",
    debts: "Borçlular",
    from: "Başlangıç",
    to: "Bitiş",
    allMethods: "Tüm yöntemler",
    allFunnels: "Tüm hunilar",
    received: "Toplam tahsilat",
    noPayments: "Bu dönemde ödeme yok",
    export: "Excel (CSV)",
    totalDebt: "Toplam borç",
    debtors: "Borçlular",
    noDebts: "Borçlu yok",
    lastPayment: "son ödeme",
    client: "Müşteri",
    deal: "Anlaşma",
    stage: "Aşama",
    acceptedBy: "Teslim alan",
    phone: "Telefon",
  },
  stageRules: {
    title: "Aşama kuralları",
    requiredCount: "{n} zorunlu alan",
    autoTaskOn: "otomatik görev",
    requiredFields: "Geçiş için zorunlu alanlar",
    requiredHint: "Anlaşma bu aşamaya yalnızca bu alanlar doldurulduğunda geçebilir. Dosya alanları için belge yüklenmiş olmalıdır.",
    noFields: "Henüz anlaşma alanı yok",
    valueField: "Tutar",
    autoTask: "Anlaşma girince görev oluştur",
    taskTitle: "Görev metni, ör. Video yorum çekmek",
    toDealOwner: "Anlaşma sorumlusu",
    dueIn: "Süre:",
    days: "gün sonra",
    modalTitle: "Önce doldurun",
    modalHint: "Anlaşmayı bu aşamaya taşımak için gerekli:",
    chooseFile: "Dosya seç",
    removeFile: "Dosyayı kaldır",
    uploadFailed: "Dosya yüklenemedi",
    yes: "Evet",
    select: "Seçin",
    cancel: "İptal",
    saveAndMove: "Kaydet ve taşı",
    bulkBlocked: "{n} anlaşma taşınmadı — zorunlu alanlar boş",
    fromEnterDay: "aşamaya girdiği günden",
    fromField: "«{name}» tarihinden",
    leadStage: "İlk aşama — potansiyel müşteriler",
    leadStageHint: "Yeni başvurular buraya düşer, kartlarda «Lid» etiketi görünür. Başka bir huniden anlaşma devralan hizmet hunilerinde kapatın.",
    renewalTitle: "Süre bitimine göre otomatik anlaşma",
    renewalHint: "Kazanılan bir anlaşmadaki tarih yaklaştığında (ör. izin bitişi) müşteri için seçilen hunide yeni anlaşma açılır ve sorumluya görev verilir. Her tarih için bir kez.",
    renewalEnabled: "Açık",
    renewalDateField: "Tarih alanı",
    renewalDays: "Kaç gün önce",
    renewalFunnel: "Huni",
    renewalStage: "Aşama",
    renewalTask: "Görev metni",
    renewalTaskPlaceholder: "Ör. Uzatma teklif etmek",
    save: "Kaydet",
  },
  notif: {
    title: "Bildirimler",
    subtitle: "Kim, ne zaman, ne yaptı",
    markAll: "Tümünü okundu yap",
    empty: "Bildirim yok",
    seeAll: "Tümünü gör",
    loadError: "Yükleme hatası",
  },
  common: {
    selectPlaceholder: "Seçin...",
    searchPlaceholder: "Ara...",
    noResults: "Sonuç yok",
  },
  proc: {
    title: "Süreçlerim",
    subtitle: "Yürütülecek süreçler",
    empty: "Süreç yok",
    emptyHint: "Size atanan süreçler burada görünecek",
    filesTitle: "Eskiz / dosyalar",
    archiveTitle: "Arşiv",
    backToWork: "İşe geri dön",
    archiveEmpty: "Arşiv boş",
    archiveEmptyHint: "Tamamladığınız işler burada saklanır",
    proposalTag: "Teklif",
    tabWork: "İşlerim",
    tabRequests: "Para talebi",
    tabArchive: "Arşiv",
    countSuffix: "süreç",
    logout: "Çıkış",
    refresh: "Yenile",
    saved: "Kaydedildi",
    loadError: "Yükleme hatası",
    problemTitle: "Sorun nedir?",
    problemPlaceholder: "Sorunu kısaca açıklayın…",
    problemSubmit: "Gönder",
    problemRequired: "Sorunu açıklayın",
    cancel: "İptal",
  },
  snab: {
    title: "Taleplerim",
    subtitle: "Tedarik edilecek belgeler",
    empty: "Talep yok",
    emptyHint: "Size atanan açık talepler burada görünecek",
    createReceipt: "Giriş belgesi oluştur",
    tabProducts: "Ürünler",
    tabSuppliers: "Tedarikçiler",
    suppliersEmpty: "Tedarikçi yok",
    needQty: "Gerekli",
    buy: "Satın al",
    zoom: "Büyüt",
    tabRequests: "Para talebi",
    needBy: "Son tarih:",
    noItems: "Kalem yok",
    logout: "Çıkış",
    refresh: "Yenile",
    loadError: "Yükleme hatası",
  },
  roles: {
    title: "Roller",
    subtitle: "Özel roller — modül görünürlüğü, işlemler ve verileri yönetin",
    addRole: "Rol ekle",
    editRole: "Rolü düzenle",
    name: "Rol adı",
    namePlaceholder: "ör. Satış danışmanı, Depocu...",
    nameRequired: "Rol adı zorunludur",
    modulesSection: "Modüller ve işlemler",
    module: "Modül",
    actionView: "Görüntüle",
    actionCreate: "Yeni",
    actionEdit: "Düzenle",
    actionDelete: "Sil",
    dataFlagsSection: "Gizli veriler",
    dataFlagsHint: "İşaretlenen veriler bu rolden gizlenir (telefon, e-posta, anlaşma tutarı...)",
    ownSection: "Yalnızca kendi kayıtlarını göster",
    ownHint: "İşaretlenen bölümlerde kullanıcı yalnızca kendi oluşturduğu belgeleri görür (başkalarınınkini görmez).",
    save: "Kaydet",
    cancel: "İptal",
    delete: "Sil",
    deleteTitle: "Rolü sil",
    deleteText: "rolü silinecek. Bu roldeki kullanıcılar tam erişime döner.",
    added: "Rol eklendi",
    updated: "Rol güncellendi",
    deleted: "Rol silindi",
    loadError: "Yükleme hatası",
    genericError: "Bir hata oluştu",
    empty: "Rol yok",
    modulesCount: "modül",
    hiddenCount: "gizli",
    restricted: "Bu veri sizden gizlendi",
    prodSubActionsLabel: "Üretim: ayrı giriş yetkileri",
    prodEditOutputs: "Mamul ürün partilerini girme",
    prodEditComponents: "Hammadde tüketimini girme",
    flags: {
      contacts_phone: "Kişi telefon numarası",
      contacts_email: "Kişi e-postası",
      deals_value: "Anlaşma tutarı",
      products_costPrice: "Maliyet fiyatı (alış)",
      products_avgCost: "Ortalama maliyet",
      products_margin: "Marj / kâr oranı",
      inventory_stockValue: "Stok değeri",
      sklad_valuation: "Depo değeri (toplam maliyet)",
      sklad_unitCost: "Birim maliyet",
      finance_pnl: "Kâr ve zarar (P&L)",
      finance_companyBalance: "Şirket bakiyesi",
      finance_cashboxBalance: "Kasa bakiyeleri",
      finance_netProfit: "Net kâr",
      finance_cogs: "Satılan malın maliyeti (COGS)",
      finance_debtsTotals: "Borç toplamları",
      cashbox_balance: "Kasa bakiyesi",
      cashbox_turnover: "Kasa hareketleri",
      jobOrder_summary: "Sipariş tutarları (istatistik + anlaşılan/ödenen/borç)",
      jobOrder_profit: "Sipariş kârı",
      jobOrder_totalCost: "Sipariş maliyeti",
      jobOrder_laborCost: "İşçilik maliyeti",
      jobOrder_materialCost: "Malzeme maliyeti",
      jobOrder_lockBasic: "Temel bilgileri düzenlemeyi kilitle",
      jobOrder_lockProcesses: "Süreçleri düzenlemeyi kilitle",
      jobOrder_lockMaterials: "Giderleri düzenlemeyi kilitle",
      jobOrder_lockFiles: "Dosyaları düzenlemeyi kilitle",
      jobOrder_lockDelete: "Siparişi silmeyi kilitle",
      jobOrder_otherExpenses: "Diğer giderler bölümünü gizle",
      jobOrder_otherExpensesEdit: "Diğer gider eklemeyi kilitle",
      jobOrder_otherExpensesDelete: "Diğer giderleri silmeyi kilitle",
      jobOrder_lockConfirm: "Siparişi onaylamayı kilitle",
      jobOrder_lockStart: "İşleme almayı kilitle",
      jobOrder_lockComplete: "Siparişi tamamlamayı kilitle",
      proposal_cost: "Teklif maliyeti",
      proposal_margin: "Teklif marjı",
      reports_inventoryValue: "Rapor: stok değeri",
      reports_profitColumns: "Rapor: kâr sütunları",
    },
  },
  dtp: {
    now: "Şimdi",
    done: "Tamam",
  },
  picker: {
    placeholder: "Ürün...",
    search: "Ara...",
    notFound: "Bulunamadı",
  },
  catPicker: {
    all: "Tümü",
    back: "Geri",
    empty: "Boş",
    count: "{n} öğe",
  },
  update: {
    title: "Yeni sürüm mevcut",
    subtitle: "Lütfen yenileyin",
    action: "Güncelle",
    dismiss: "Kapat",
  },
  production: {
    loadError: "Yükleme hatası",
    error: "Hata",
    cancel: "İptal",
    save: "Kaydet",
    saved: "Güncellendi",
    added: "Eklendi",
    deleted: "Silindi",
    movedToTrash: "Çöp kutusuna taşındı",
    toTrash: "Çöp kutusuna",
    delete: "Sil",
    back: "Geri",
    selectPlaceholder: "Seçin...",
    row: "Satır",
    addRow: "Satır ekle",
    print: "Yazdır",
    printTitle: "Yazdır",
    unitSuffix: "adet",
    prodLabel: "Üretim",
    prodSubtitle: "Hammaddeden mamul ürüne",
    pkgLabel: "Paketleme",
    pkgSubtitle: "Mamul ürünlerin paketlenmesi",
    searchPlaceholder: "Numara veya ürün...",
    new: "Yeni",
    notFound: "Belge bulunamadı",
    notFoundHint: "Yeni belge oluştur",
    newBlank: "Boş oluştur",
    newFromRecipe: "Reçeteden",
    recipe: "Reçete",
    norma: "Norm (kaç kat)",
    normaHint: "Reçete bu sayıyla çarpılır (1 norm = 1 reçete) — malzemeler ve çıktı buna göre yazılır.",
    noRecipes: "Reçete yok. Önce Reçeteler (BOM) bölümünden ekleyin.",
    recipePickFirst: "Reçete seçin",
    thNumber: "Numara",
    thDate: "Tarih",
    thOutput: "Mamul ürün",
    thOut: "Çıktı",
    thCost: "Maliyet",
    thUnit: "Birim",
    thStatus: "Durum",
    thActions: "İşlemler",
    outLabel: "Çıktı:",
    trashTitle: "Çöp kutusuna taşı",
    trashText1: "belgesi çöp kutusuna taşınacak. Hammadde ve mamul stokları geri yüklenecek (30 gün içinde geri alınabilir).",
    docLoadError: "Belge yüklenmedi",
    bomSelectProductFirst: "Önce mamul ürünü seçin",
    bomQtyFirst: "Çıktı miktarını girin",
    bomNotFound: "Bu ürün için reçete bulunamadı",
    bomLoaded: "Reçete yüklendi",
    whRequired: "Depolar zorunludur",
    outProductRequired: "Mamul ürün zorunludur",
    outQtyInvalid: "Geçersiz çıktı miktarı",
    minOneComponent: "En az bir hammadde girin",
    costShare: "Maliyet payı",
    costShareAuto: "otomatik",
    costShareHint: "Toplam maliyeti çıktı miktarına göre otomatik bölmek için payı boş bırakın. Bu ağırlıklara göre bölmek için pay girin.",
    outAllocCost: "Maliyet",
    outputsCount: "ürün",
    removeRow: "Satırı kaldır",
    lotLabel: "Parti:",
    lotCol: "Parti",
    lotAuto: "Otomatik (en eski)",
    lotNoLabel: "Parti yok",
    lotLeft: "kaldı",
    uomRequired: "Birim seçin",
    compProductRequired: "Hammaddeyi seçin",
    compQtyRequired: "Hammadde miktarını girin",
    addGroup: "Grup",
    newGroup: "Yeni grup",
    groupNamePlaceholder: "Grup adı",
    removeGroup: "Grubu kaldır",
    moveTo: "Taşı",
    moveToUngrouped: "Grupsuzlara",
    fromWh: "Hammadde deposu (kaynak)",
    toWh: "Mamul deposu (hedef)",
    outputCard: "Mamul ürün",
    applyBomTitle: "Seçilen ürünün reçetesinden hammaddeleri yükle",
    applyBom: "Reçeteden yükle",
    product: "Ürün",
    outProductPlaceholder: "Mamul ürün...",
    qty: "Miktar",
    uom: "Birim",
    uomPlaceholder: "adet, kg...",
    batchNo: "Parti №",
    batchPlaceholder: "(isteğe bağlı)",
    expiry: "Son kullanma tarihi",
    addBatch: "Parti ekle",
    batchTime: "Saat",
    batchTotal: "Toplam",
    grandTotalLabel: "Toplam çıktı:",
    normaTitle: "Norm",
    normaPerUnit: "hammadde /",
    normaAdd: "Hammadde ekle",
    componentsTitle: "Hammaddeler (tüketim)",
    noComponents: "Hammadde satırı yok",
    colProduct: "Ürün",
    colQty: "Miktar",
    colUom: "Birim",
    colEstCost: "Tahmini maliyet",
    uomPlaceholder2: "birim",
    costInline: "Maliyet:",
    stockInStock: "Stok:",
    overheadTitle: "Ek giderler (isteğe bağlı)",
    noOverhead: "Satır yok (maaş, elektrik, amortisman vb.)",
    colCategory: "Kategori (kasadan)",
    colName: "Ad",
    colAmount: "Tutar",
    catManual: "— (manuel)",
    overheadNamePlaceholder: "Maaş, Elektrik...",
    amountPlaceholder: "Tutar",
    overheadHint: "Kategori seçerseniz Ödemeler'deki gider kategorisine bağlanır (raporlarda birleşik gösterilir). Kategoriyi Finans → Ödemeler'de oluşturursunuz.",
    colCashbox: "Kasa (nakit)",
    overheadNoCash: "— (yalnızca maliyet)",
    overheadCashHint: "Kasa seçilirse bu gider ondan nakit ödenir ve kasa kartında görünür. Yine de maliyete eklenir; Ödemeler/P&L'de ayrıca kaydedilmez (çift sayım olmaz).",
    costTitle: "Maliyet (tahmini)",
    costMaterials: "Hammaddeler",
    costOverhead: "Ek giderler",
    costTotal: "Toplam maliyet",
    costUnit: "Birim maliyet",
    costNote: "Kaydederken gerçek maliyet FIFO/ortalama yöntemiyle belirlenir ve mamul ürünün avgCost değeri buna göre güncellenir.",
    note: "Not",
    optional: "İsteğe bağlı...",
    trashText2: "Belge çöp kutusuna taşınacak. Hammadde ve mamul stokları geri yüklenecek (30 gün içinde geri alınabilir).",
    bomMahsulotRequired: "Ürün zorunludur",
    bomMinOneComponent: "En az bir bileşim satırı",
    bomOutQtyInvalid: "Geçersiz çıktı miktarı",
    bomEditTitle: "Reçeteyi düzenle",
    bomNewTitle: "Yeni reçete (BOM)",
    bomKind: "Tür",
    bomOutProduct: "Mamul ürün",
    bomOutQty: "Çıktı miktarı",
    bomOutQtyHint: "Bu reçete belirtilen miktarda mamul ürün içindir",
    bomUom: "Birim",
    bomComponents: "Hammaddeler",
    bomNoRows: "Satır yok",
    bomColUom: "Birim",
    bomColNote: "Not",
    bomColCategory: "Kategori",
    bomOverheadHint: "Kategori seçerseniz Ödemeler'deki gider kategorisine bağlanır (raporlarda birleşik gösterilir).",
    bomTitle: "Reçeteler (BOM)",
    bomNavShort: "Reçeteler",
    recipeSaveBtn: "Reçete olarak kaydet",
    recipeSaveTitle: "Mevcut formu reçete olarak kaydet",
    recipeSaveHint: "Mevcut mamul ürünler, malzemeler ve giderler reçete olarak kaydedilir. Sonra 'Reçeteden' + norm ile otomatik doldurulur.",
    recipeName: "Reçete adı",
    recipeNamePlaceholder: "Ör. Ekmek (standart)",
    recipeNameRequired: "Reçete adını girin",
    recipeSaved: "Reçete kaydedildi",
    bomSubtitle: "Mamul ürünler için hammadde reçeteleri",
    all: "Tümü",
    bomSearchPlaceholder: "Ürün...",
    bomNewBtn: "Reçete",
    bomEmpty: "Reçete yok",
    bomThProduct: "Ürün",
    bomThKind: "Tür",
    bomThOut: "Çıktı",
    bomThComposition: "Bileşim",
    bomThOverhead: "Ek gid.",
    componentsCount: "hammadde",
    overheadShort: "Ek gid.:",
    bomDeleteTitle: "Reçeteyi sil",
    bomDeleteText: "reçetesi kalıcı olarak silinecek.",
    ppProdTitle: "ÜRETİM BELGESİ",
    ppPkgTitle: "PAKETLEME BELGESİ",
    ppDate: "Tarih:",
    ppRawWh: "Hammadde deposu:",
    ppFinishedWh: "Mamul deposu:",
    ppFinished: "Mamul ürün:",
    ppBatch: "Parti №:",
    ppExpiry: "Son kullanma:",
    ppComponents: "Hammaddeler",
    ppColNum: "№",
    ppColName: "Ad",
    ppColQty: "Miktar",
    ppColUom: "Birim",
    ppColUnitCost: "Birim maliyet",
    ppColSum: "Toplam",
    ppMaterialsTotal: "Hammadde toplamı:",
    ppOverhead: "Ek giderler",
    ppOverheadTotal: "Ek toplam:",
    ppTotalCost: "Toplam maliyet:",
    ppUnitCost: "Birim maliyet:",
    ppNote: "Not:",
    ppSignMaker: "Üreten (imza)",
    ppSignReceiver: "Teslim alan (imza)",
  },
  scheduled: {
    title: "Planlı ödemeler",
    subtitle: "Her ay ödemeniz gereken aylık ödeme şablonları.",
    new: "Yeni ödeme",
    add: "Ekle",
    edit: "Düzenle",
    delete: "Sil",
    name: "Ad",
    namePlaceholder: "Ofis kirası, Elektrik...",
    amount: "Tutar",
    dayOfMonth: "Ayın günü",
    dayHint: "(1–28)",
    cashbox: "Hesap",
    category: "Kategori",
    counterparty: "Cari hesap",
    note: "Not",
    optional: "isteğe bağlı",
    statusPaid: "Ödendi",
    statusPending: "Bekliyor",
    statusOverdue: "Gecikmiş",
    lastPaid: "Son ödeme",
    payBtn: "Gider oluştur",
    payTitle: "Ödeme oluştur",
    payDate: "Tarih",
    payConfirm: "Ödeme oluştur",
    paySuccess: "Ödeme oluşturuldu",
    payError: "Bir hata oluştu",
    deleteConfirm: "Şablon silinsin mi?",
    deleted: "Silindi",
    saved: "Kaydedildi",
    loadError: "Yüklenemedi",
    empty: "Planlı ödeme yok",
    emptyHint: "Tekrarlanan aylık giderleri ekleyin",
    active: "Aktif",
    inactive: "Pasif",
    toggleActive: "Durumu değiştir",
    every: "Her ayın",
    dayLabel: ". günü",
    totalMonth: "Planlı ödemeler toplamı",
    totalPaid: "Ödendi",
    totalRemain: "Kalan",
    itemsCount: "kalem",
  },
  payReq: {
    title: "Talepler",
    subtitle: "Çalışanların para talepleri.",
    new: "Talep",
    newTitle: "Yeni talep",
    send: "Gönder",
    sent: "Talep gönderildi",
    cancel: "İptal",
    amount: "Tutar",
    amountInvalid: "Geçersiz tutar",
    note: "Not",
    notePlaceholder: "Ne için...",
    paymentMethod: "Ödeme yöntemi",
    paymentMethodPlaceholder: "Nakit / Kart / Havale...",
    pmCash: "Nakit",
    pmCard: "Kart",
    pmTransfer: "Havale",
    jobOrder: "Sipariş",
    optional: "isteğe bağlı",
    searchPlaceholder: "Numara veya müşteri...",
    notFound: "Bulunamadı",
    noteRequired: "Not zorunludur",
    loadError: "Yükleme hatası",
    error: "Hata",
    empty: "Talep yok",
    emptyHint: "Yeni talep ekleyin",
    byFinance: "Finans:",
    reason: "Neden:",
    approve: "Onayla",
    approved: "Onaylandı",
    markPaid: "Ödendi olarak işaretle",
    approveTitle: "Talebi onayla",
    approveHint: "Onaylanan tutarı girin. Bu henüz ödeme değildir.",
    approvedAmount: "Onaylanan tutar",
    requested: "Talep edilen",
    statTotal: "Toplam talepler",
    statApproved: "Onaylanan",
    statPaid: "Ödenen",
    statRejected: "Reddedilen",
    reject: "Reddet",
    rejectTitle: "Talebi reddet",
    rejectReasonLabel: "Ret nedeni (isteğe bağlı):",
    rejectReasonPlaceholder: "Neden...",
    rejected: "Reddedildi",
    delete: "Sil",
    deleteConfirm: "Talep silinsin mi?",
    deleted: "Silindi",
    tabs: {
      pending: "Bekliyor",
      approved: "Onaylandı",
      paid: "Ödendi",
      rejected: "Reddedildi",
      all: "Tümü",
    },
    status: {
      pending: "Bekleyen",
      approved: "Onaylanan",
      paid: "Ödenen",
      rejected: "Reddedilen",
    },
  },
  integrations: {
    back: "Geri",
    title: "Entegrasyonlar",
    subtitle: "Diğer hizmetlerle entegrasyonları açın.",
    saved: "Kaydedildi",
    error: "Hata",
    on: "Açık",
    enable: "Aç",
    disable: "Kapat",
    activeSuffix: "aktif",
    off: "Kapalı",
    soon: "Yakında",
    configure: "Ayarla",
    eskizConn: "Bağlantı",
    eskizOk: "Bağlı",
    eskizEmail: "Email",
    eskizPassword: "Şifre",
    eskizPassKeep: "Değiştirmemek için boş bırakın",
    eskizFrom: "Gönderici (nick)",
    eskizFromHint: "Test için 4546. Gerçek nick Eskiz'de onaylanmalıdır.",
    eskizSave: "Kaydet ve bağlan",
    eskizTest: "Test SMS",
    eskizPhone: "Telefon",
    eskizMessage: "Mesaj",
    eskizSendTest: "Test gönder",
    eskizTestHint: "Varsayılan «Это тест от Eskiz» metni onaylıdır. Kendi metniniz için my.eskiz.uz → SMS → My texts bölümünden moderasyona gönderin.",
    eskizEmailReq: "E-posta girin",
    eskizPhoneReq: "Telefon numarası girin",
    eskizConnected: "Eskiz bağlandı",
    eskizSent: "SMS gönderildi",
    smsRulesTitle: "SMS bildirimleri",
    smsRulesHint: "Olay gerçekleştiğinde müşteriye otomatik SMS gönderilir (metin Eskiz'de onaylanmış olmalıdır).",
    smsPlaceholders: "Yer tutucular",
    smsTplPlaceholder: "ör. Sayın {customer}, {number} numaralı siparişiniz alındı.",
    smsRulesSave: "Bildirimleri kaydet",
    tabSettings: "Ayarlar",
    tabHistory: "Geçmiş",
    balTitle: "SMS bakiyesi",
    balTotal: "Toplam bakiye",
    balPrice: "SMS başına fiyat",
    balSave: "Bakiyeyi kaydet",
    balLow: "Düşük bakiye!",
    balLowHint: "Bakiye bir SMS fiyatının altında. Yükleme yapın.",
    histEmpty: "Henüz SMS gönderilmedi",
    evtJoCreated: "Sipariş oluşturulduğunda",
    evtJoDelivered: "Sipariş tamamlandığında",
    evtSaleCreated: "Satış (fatura) oluşturulduğunda",
    evtPayIncoming: "Ödeme alındığında",
    cat: {
      sms: "SMS",
      hr: "İK",
    },
    svc: {
      "hr-line": "İK yönetimi (HR Line)",
      "sms-eskiz": "SMS gönder (eskiz.uz)",
      "sms-playmobile": "SMS ağ geçidi (Play Mobile)",
      "hr-attendance": "Personel devam takibi",
      "hr-payroll": "Bordro",
    },
  },
  finance: {
    total: "Toplam",
    loadError: "Yükleme hatası",
    cancel: "İptal",
    save: "Kaydet",
    add: "Ekle",
    saved: "Güncellendi",
    added: "Eklendi",
    deleted: "Silindi",
    error: "Hata",
    delete: "Sil",
    deleteTitle: "Silmeyi onayla",
    nameRequired: "Ad zorunludur",
    search: "Ara...",
    notFound: "Bulunamadı",
    selectCp: "Cari hesap seçin...",
    loadMore: "Daha fazla yükle",
    clearSelection: "Seçimi temizle",
    edit: "Düzenle",
    back: "Geri",
    kirim: "Gelen",
    chiqim: "Giden",
    insufficient: "Kasada yetersiz bakiye",
    thName: "Ad",
    thCurrency: "Para birimi",
    thBranch: "Şube",
    thBalance: "Bakiye",
    thActions: "İşlemler",
    thNumber: "Numara",
    thDate: "Tarih",
    thType: "Tür",
    thCp: "Cari hesap",
    thCashbox: "Kasa",
    thCategory: "Kategori",
    thAmount: "Tutar",
    thStatus: "Durum",
    thDesc: "Açıklama",
    thDirection: "Yön",
    debtsTitle: "Borçlar",
    debtsSubtitle: "Borçlular ve alacaklılar (cari hesap bakiyeleri)",
    none: "Yok",
    debtors: "Borçlular",
    debtorsHint: "Bize borçlu",
    creditors: "Alacaklılar",
    creditorsHint: "Biz borçluyuz",
    cbReportLoadError: "Rapor yükleme hatası",
    cbBase: "Temel",
    cbTitle: "Şirket bakiyesi",
    cbSubtitle: "Para birimine göre net değer",
    noData: "Veri yok",
    cbGrandTotal: "Toplam net değer ({base} cinsinden)",
    cbConvertedNote: "Diğer para birimleri kurum kurlarıyla hesaplanır",
    cbRatesLabel: "Kur",
    cbInventory: "Stok bakiyeleri (maliyet fiyatı)",
    cbInventoryHint: "Hammadde ve mamul ürünler",
    cbReceivables: "Cari hesaplardan alacaklar",
    cbReceivablesHint: "Cari hesapların ödeyeceği para",
    cbCash: "Kasalardaki nakit",
    cbCashHint: "Bu para birimindeki kasalar",
    cbPayables: "Cari hesaplara borç",
    cbPayablesHint: "Cari hesaplara ödenecek borç",
    cbFormula: "Formül: Stok maliyeti + Alacaklar + Kasalardaki nakit − Cari hesaplara borç. Stok maliyeti yalnızca temel para biriminde ({base}) tutulur.",
    pnlTitle: "P&L (Kâr ve zarar)",
    pnlSubtitle: "Gelir → Maliyet → Brüt kâr → Giderler → Net kâr (temel para biriminde)",
    pnlReport: "Kâr ve zarar tablosu",
    pnlRevenue: "Gelir (satışlar)",
    pnlCogs: "− Maliyet",
    pnlGross: "= Brüt kâr",
    pnlOpex: "− Faaliyet giderleri",
    pnlOperating: "= Faaliyet kârı",
    pnlFinancial: "− Finansal giderler (faiz/banka)",
    pnlSecLabel: "P&L bölümü",
    pnlSecHint: "Faaliyet — normal gider; Finansal — banka faizi/krediler; Hariç — tedarikçi/borç ödemeleri.",
    pnlSec_operating: "Faaliyet",
    pnlSec_financial: "Finansal",
    pnlSec_excluded: "Hariç",
    pnlNet: "≡ Net kâr",
    pnlNote: "Not: Maliyet mevcut maliyet fiyatına dayanır (yaklaşık). Vergiler ve krediler dahil değildir.",
    pnlExpenseDetail: "Faaliyet giderleri dökümü",
    pnlNoExpense: "Gider ödemesi yok",
    pnlCashFlow: "Nakit akışı (ek)",
    pnlCashFlowHint: "Kasa hareketi, P&L'yi etkilemez",
    pnlNetFlow: "Net akış",
    cbxCurrencyRequired: "Para birimi zorunludur",
    cbxEditTitle: "Kasayı düzenle",
    cbxNewTitle: "Yeni kasa",
    cbxNameLabel: "Ad *",
    cbxNamePlaceholder: "Kasa adı",
    cbxCurrencyLabel: "Para birimi *",
    cbxBranchLabel: "Şube",
    cbxBranchNone: "— Seçilmedi —",
    cbxBranchHint: "Şubeler Ayarlar → Şirket bölümünden eklenir.",
    cbxTitle: "Kasalar",
    cbxSubtitle: "Kasa listesi",
    cbxAdd: "Kasa ekle",
    cbxNotFound: "Kasa bulunamadı",
    cbxNotFoundHint: "Yeni kasa ekleyin",
    cbxDeleteText: "kasası silinecek.",
    ccTitle: "Kasa kartı",
    ccNotFound: "Kasa bulunamadı",
    ccBackToList: "Listeye dön",
    ccConversion: "Döviz çevirme",
    ccReceipt: "Nakit giriş (alış)",
    ccOverhead: "Üretim gideri",
    ccConvOut: "(çıkış)",
    ccConvIn: "(giriş)",
    ccCurrentBalance: "Mevcut bakiye",
    ccJournal: "Hareket defteri",
    ccNoMovements: "Hareket yok",
    convCashboxesRequired: "Kasalar zorunludur",
    convSameCashbox: "Aynı kasa seçilemez",
    convSameCurrency: "Aynı para birimine çevrilemez",
    convTransferMode: "Transfer (kur yok, 1:1)",
    convTransferTitle: "Kasadan kasaya transfer",
    convTransferBtn: "Transfer",
    convTransferTag: "Transfer",
    convFromAmountInvalid: "Verilecek tutar geçersiz",
    convRateRequired: "Kuru girin",
    convDone: "Çevirme yapıldı",
    convEditTitle: "Çevirmeyi düzenle",
    convNewTitle: "Yeni döviz çevirme",
    convFrom: "Kaynak kasa",
    convSelect: "Seçin...",
    convBalance: "Bakiye:",
    convGive: "Verilen (tutar)",
    convTo: "Hedef kasa",
    convRate: "Kur",
    convReverse: "Ters çevir",
    convReceive: "Alınan",
    convAuto: "(otomatik)",
    convDoBtn: "Uygula",
    convTitle: "Döviz çevirme",
    convSubtitle: "Kasadan kasaya döviz çevirme",
    convNewBtn: "Döviz çevirme",
    convNotFound: "Çevirme bulunamadı",
    convNotFoundHint: "Yeni döviz çevirme oluşturun",
    convThGive: "Verilen",
    convThReceive: "Alınan",
    convDeleteText: "çevirmesi silinecek. Kasa bakiyeleri geri yüklenecek.",
    convVerifyBtn: "Onayla",
    convVerified: "Çevirme onaylandı",
    convVerifiedBadge: "Onaylandı",
    convDraftBadge: "Onaylanmadı",
    convVerifiedAt: "Onaylandı",
    convLockedHint: "Onaylanmış belge düzenlenemez",
    payTitle: "Ödemeler",
    paySubtitle: "Gelen ve giden para",
    paySearch: "Numara veya cari hesap...",
    payFilterCp: "Cari hesap",
    payFilterCashbox: "Tüm kasalar",
    payFilterCategory: "Tüm kategoriler",
    payIncoming: "Para girişi",
    payOutgoing: "Para çıkışı",
    payNotFound: "Ödeme bulunamadı",
    payNotFoundHint: "Para girişi veya çıkışı oluşturun",
    payDeleteText: "ödemesi silinecek. Cari hesap bakiyesi geri yüklenecek.",
    pfIncomingTitle: "Gelen ödeme",
    pfOutgoingTitle: "Giden ödeme",
    pfJoSelect: "Sipariş seçin...",
    pfClearSelection: "— Seçimi temizle —",
    pfJoSearch: "Numara veya müşteri...",
    pfNewCp: "Yeni cari hesap",
    cpAdded: "Cari hesap eklendi",
    pfPhone: "Telefon",
    pfPhonePlaceholder: "+998 ...",
    smTitle: "Durumları yönet",
    smNew: "Yeni durum",
    smNamePlaceholder: "Durum adı...",
    catIncomingTitle: "Gelir kategorileri",
    catOutgoingTitle: "Gider kategorileri",
    catNew: "Yeni kategori",
    catNamePlaceholder: "Kategori adı...",
    pfDocLoadError: "Belge yüklenmedi",
    pfCpRequired: "Cari hesap zorunludur",
    pfCashboxRequired: "Kasa zorunludur",
    pfAmountInvalid: "Geçersiz tutar",
    pfDateInvalid: "Geçersiz tarih (GG/AA/YYYY SS:DD)",
    pfHeaderTitle: "Ödemeler",
    pfFromRequest: "Bu gider şu talepten oluşturuluyor:",
    pfPrint: "Yazdır",
    pfPrintTitle: "Yazdır",
    pfAddAnother: "Bir giriş daha ekle",
    pfAddAnotherTitle: "Bu sipariş için bir giriş daha ekle (başka kasadan)",
    pfJoRemainTitle: "Siparişte kalan borç var",
    pfJoRemainHint: "Ödeme kaydedildi. Müşteri başka bir kasaya da ödemek isterse «Bir giriş daha ekle»ye tıklayın.",
    pfDateLabel: "Tarih:",
    pfStatusless: "Durum yok",
    pfCpLabel: "Cari hesap *",
    pfNewCpTitle: "Yeni cari hesap ekle",
    pfCashboxLabel: "Kasa *",
    pfCashboxSelect: "Kasa seçin...",
    pfBalance: "Bakiye:",
    pfAmountLabel: "Tutar *",
    pfCategoryLabel: "Kategori",
    pfManage: "Yönet",
    pfCategoryless: "Kategori yok",
    pfJobOrder: "Sipariş",
    pfJobOrderHint: "Seçilirse ödeme bu siparişin bakiyesine bağlanır. Boş bırakılırsa — normal giriş.",
    pfProcess: "Süreç (işçilik)",
    pfProcessHint: "Tutar bu sürecin işçiliği olarak kaydedilir.",
    pfProcessRequired: "Lütfen bir süreç seçin",
    pfProcessCurrencyMismatch: "Ödeme para birimi sipariş para birimiyle aynı olmalıdır",
    pfOptional: "isteğe bağlı",
    pfNote: "Not",
    pfNotePlaceholder: "Not (isteğe bağlı)...",
    pfJoTotal: "Sipariş toplamı",
    pfJoPaid: "Ödenen",
    pfJoRemaining: "Kalan",
    pfJoHistory: "Ödeme geçmişi",
    pfJoNoPayments: "Henüz ödeme yok",
    pfJoLoading: "Yükleniyor...",
    pfDeleteText: "Ödeme silinecek ve cari hesap bakiyesi geri yüklenecek.",
    pfNameLabel: "Ad *",
    pfNamePlaceholder: "Ad",
    pfCommissionAdd: "Komisyon ekle",
    pfCommission: "Komisyon (2. gider)",
    pfCommissionPct: "Yüzde",
    pfSecondAdd: "2. kasaya böl",
    pfSecondTitle: "2. kasa girişi (nakit + kart)",
    pfSecondCashboxLabel: "2. kasa",
    pfSecondAmountLabel: "2. tutar",
    pfSecondRemove: "Kaldır",
    pfSecondCashboxRequired: "2. kasa zorunludur",
    pfSecondSameCashbox: "2. kasa farklı olmalıdır",
    pfSecondInvalid: "Geçersiz 2. kasa tutarı",
    pfCommissionInvalid: "Geçersiz komisyon tutarı",
    pfCommissionEmpty: "Komisyon kategorisi ayarlanmadı — «Yönet» ile seçin.",
    pfCommissionMgrTitle: "Komisyon kategorileri",
    pfCommissionMgrHint: "İşaretlenen gider kategorileri komisyon seçicide görünür.",
    ppIncomingTitle: "TAHSİLAT MAKBUZU",
    ppOutgoingTitle: "TEDİYE MAKBUZU",
    ppDate: "Tarih:",
    ppReceivedFrom: "Kimden alındı",
    ppGivenTo: "Kime verildi",
    ppCashbox: "Kasa:",
    ppCategory: "Kategori:",
    ppAmount: "Tutar:",
    ppNote: "Not:",
    ppSignedIncomingLeft: "Teslim eden (imza)",
    ppSignedOutgoingLeft: "Veren (imza)",
    ppSignedIncomingRight: "Teslim alan (imza)",
    ppSignedOutgoingRight: "Alan (imza)",
  },
  contracts: {
    optional: "isteğe bağlı",
    legalNamePlaceholder: "Tüzel unvan",
    managerLabel: "Sorumlu (kim çalışıyor)",
    managerNone: "Seçilmedi",
    selectCp: "Cari hesap seçin...",
    search: "Ara...",
    notFound: "Bulunamadı",
    editTitle: "Sözleşmeyi düzenle",
    newTitle: "Yeni sözleşme",
    number: "Numara",
    date: "Tarih",
    cpLabel: "Cari hesap *",
    legalName: "Tüzel unvan",
    inn: "VKN",
    legalMissing: "Cari hesap kartında tüzel unvan/VKN doldurulmamış.",
    amount: "Tutar *",
    currency: "Para birimi",
    description: "Açıklama",
    descPlaceholder: "Sözleşme konusu...",
    note: "Not",
    notePlaceholder: "İsteğe bağlı...",
    filesLabel: "Dosyalar (PDF, taramalar)",
    cancel: "İptal",
    save: "Kaydet",
    add: "Ekle",
    cpRequired: "Cari hesap zorunludur",
    amountInvalid: "Geçersiz tutar",
    saved: "Güncellendi",
    added: "Eklendi",
    error: "Hata",
    loadError: "Yükleme hatası",
    deleted: "Silindi",
    title: "Sözleşmeler",
    subtitle: "Sözleşme kaydı — her sözleşmeye otomatik numara verilir",
    searchPlaceholder: "Numara, cari hesap...",
    newBtn: "Sözleşme",
    empty: "Sözleşme yok",
    emptyHint: "Yeni sözleşme ekleyin",
    thCp: "Cari hesap",
    thAmount: "Tutar",
    thCreatedBy: "Oluşturan",
    thActions: "İşlemler",
    deleteTitle: "Silmeyi onayla",
    deleteText: "sözleşmesi silinecek.",
    delete: "Sil",
  },
  aktSverka: {
    tabCustomer: "Müşteriyle",
    tabSupplier: "Tedarikçiyle",
    selectCp: "Cari hesap seçin...",
    search: "Ara...",
    notFound: "Bulunamadı",
    cpRequired: "Cari hesap zorunludur",
    error: "Hata",
    copied: "Kopyalandı",
    regenConfirm: "Eski bağlantı iptal edilip yenisi oluşturulacak. Devam edilsin mi?",
    urlUpdated: "Bağlantı güncellendi",
    title: "Mutabakat tutanağı",
    subtitle: "Cari hesapla karşılıklı hesaplaşma belgesi",
    cpLabel: "Cari hesap",
    fromDate: "Başlangıç tarihi",
    toDate: "Bitiş tarihi",
    generate: "Oluştur",
    print: "Yazdır / PDF",
    permUrlTitle: "Cari hesap için kalıcı bağlantı",
    permUrlHint: "Bu bağlantı kalıcıdır — cari hesap kaydedip hesaplaşmalarını istediği zaman görebilir. Dönemler herkese açık sayfada seçilir.",
    copyTitle: "Kopyala",
    copy: "Kopyala",
    regenTitle: "Yeni bağlantı (eskisi iptal edilir)",
    regen: "Yenile",
    loadError: "Yükleme hatası",
    linkError: "Bağlantı açılamadı",
    printShort: "Yazdır / PDF",
    docTitle: "MUTABAKAT TUTANAĞI",
    docSubtitle: "Cari hesaplar arası karşılıklı hesaplaşma",
    ourOrg: "Kurumumuz",
    tel: "Tel",
    period: "Dönem",
    noTx: "Bu dönemde işlem yok",
    currencyLabel: "Para birimi",
    thDate: "Tarih",
    thDoc: "Belge",
    thDebit: "Borç",
    thCredit: "Alacak",
    thBalance: "Bakiye",
    openingBalance: "Açılış bakiyesi",
    totalRow: "Toplam",
    theyOweA: " bize borçlu",
    theyOweB: ".",
    weOwePre: "Biz borçluyuz",
    weOweMid: " ",
    weOweSuf: ".",
    noDebtPre: "Bu dönemde",
    noDebt: "borç yok (bakiye 0)",
    signOur: "Kurumumuz adına:",
    signCp: "Cari hesap adına:",
    signLine: "(Ad soyad, unvan, imza, tarih)",
  },
  sklad: {
    allCategories: "Tüm kategoriler",
    lowOnly: "Düşük stok",
    totalValue: "Toplam stok değeri",
    thCategory: "Kategori",
    thValue: "Değer",
    loadError: "Yükleme hatası",
    cancel: "İptal",
    save: "Kaydet",
    add: "Ekle",
    saved: "Güncellendi",
    added: "Eklendi",
    deleted: "Silindi",
    error: "Hata",
    delete: "Sil",
    deleteTitle: "Silmeyi onayla",
    nameRequired: "Ad zorunludur",
    total: "Toplam",
    thName: "Ad",
    thProduct: "Ürün",
    thUom: "Birim",
    sku: "Stok kodu",
    sbTitle: "Stok bakiyeleri",
    sbSubtitle: "Depolara göre ürün stoku",
    sbSearch: "Ürün ara...",
    sbNotFound: "Ürün bulunamadı",
    sbNotFoundHint: "Stok giriş belgeleriyle oluşur",
    rTitle: "Toplam maliyet",
    rSubtitle: "Stok ve maliyet fiyatına göre depo değeri",
    rKpi: "Toplam depo değeri (maliyet)",
    rEmpty: "Stok yok",
    rStock: "Stok",
    rCost: "Maliyet",
    rValue: "Değer",
    tTitle: "Transferler",
    tSubtitle: "Depolar arası mal transferi",
    tNew: "Transfer",
    tSearch: "Numaraya göre ara...",
    tNotFound: "Transfer bulunamadı",
    tNotFoundHint: "Yeni transfer belgesi oluşturun",
    tNumber: "Numara",
    tDate: "Tarih",
    tDirection: "Yön",
    tProducts: "Ürünler",
    itemCountSuffix: "ürün",
    whEditTitle: "Depoyu düzenle",
    whNewTitle: "Yeni depo",
    whNameLabel: "Ad *",
    whNamePlaceholder: "Depo adı",
    whTitle: "Depolar",
    whSubtitle: "Depo listesi",
    whAdd: "Depo ekle",
    whNotFound: "Depo bulunamadı",
    whNotFoundHint: "Yeni depo ekleyin",
    thActions: "İşlemler",
    whDeleteText: "deposu silinecek.",
    lsTitle: "Düşük stoklu ürünler",
    lsSubtitleSearch: "Bir ürün bulun ve minimum stoku ayarlayın",
    lsSubtitle: "Stoku ayarlanan minimumun altındaki ürünler",
    lsAlerts: "Uyarılar",
    lsEmpty: "Düşük stoklu ürün yok",
    lsEmptyHint: "Minimum stoku ayarlamak için ürün arayın",
    lsLow: "Düşük",
    lsEnough: "Yeterli",
    lsCurrentStock: "Mevcut stok",
    lsMinStock: "Minimum stok",
    lsStatus: "Durum",
    tfNotFound: "Bulunamadı",
    tfCatalogEmpty: "Katalog boş",
    tfTypeProduct: "Ürün adını yazın...",
    tfDocLoadError: "Belge yüklenmedi",
    tfFromRequired: "Kaynak depo zorunludur",
    tfToRequired: "Hedef depo zorunludur",
    tfSameWarehouse: "Aynı depo seçilemez",
    tfDateInvalid: "Geçersiz tarih (GG/AA/YYYY SS:DD)",
    tfMinOneProduct: "En az bir ürün girin",
    tfMoved: "Transfer edildi",
    back: "Geri",
    tfHeaderTitle: "Depolar arası transfer",
    tfDocTitle: "Transfer belgesi",
    tfFrom: "Kaynak *",
    tfTo: "Hedef *",
    tfSelectWarehouse: "Depo seçin...",
    tfThAvailFrom: "Mevcut (kaynak)",
    tfQty: "Miktar",
    tfAvailable: "Mevcut",
    tfNote: "Not",
    tfNotePlaceholder: "Not...",
    tfDeleteText: "transfer belgesi silinecek. Stok geri alınacak.",
  },
  cpCard: {
    kind: {
      purchaseOrder: "Satın alma siparişi",
      purchaseReceipt: "Giriş",
      purchaseReturn: "Alış iadesi",
      salesOrder: "Satış siparişi",
      salesInvoice: "Satış",
      salesReturn: "Satış iadesi",
    },
    payIn: "Ödeme (giriş)",
    payOut: "Ödeme (çıkış)",
    weOwe: "Biz borçluyuz",
    theyOwe: "Bize borçlular",
    tabs: {
      documents: "Belgeler",
      payments: "Ödemeler",
      ledger: "Bakiye geçmişi",
      products: "Ürünler",
      prices: "Fiyatlar",
    },
    loadError: "Yükleme hatası",
    cardTitle: "Cari hesap kartı",
    back: "Geri",
    notFound: "Cari hesap bulunamadı",
    backToList: "Listeye dön",
    debtTitle: "Borç",
    thKind: "Tür",
    thNumber: "Numara",
    thDate: "Tarih",
    thStatus: "Durum",
    thSum: "Tutar",
    thCashbox: "Kasa",
    thCategory: "Kategori",
    thDoc: "Belge",
    thChange: "Değişim",
    thBalance: "Bakiye",
    noDocuments: "Belge yok",
    noPayments: "Ödeme yok",
    ledgerEmpty: "Bakiye geçmişi boş",
  },
  counterparties: {
    addBtn: "Ekle",
    statTotal: "Toplam",
    statCustomers: "Müşteriler",
    statSuppliers: "Tedarikçiler",
    folderNamePlaceholder: "Klasör adı...",
    cancel: "İptal",
    error: "Hata",
    subFolderTitle: "Alt klasör ekle",
    folders: "Klasörler",
    statusMgrTitle: "Durumları yönet",
    editLabel: "Düzenle",
    newStatus: "Yeni durum",
    statusNamePlaceholder: "Durum adı...",
    save: "Kaydet",
    add: "Ekle",
    all: "Tümü",
    statusless: "Durum yok",
    status: "Durum",
    loadError: "Yükleme hatası",
    saved: "Güncellendi",
    added: "Eklendi",
    deleted: "Silindi",
    title: "Cari hesaplar",
    subtitle: "Müşteriler ve tedarikçiler",
    allFolders: "Tüm klasörler",
    searchPlaceholder: "Ara...",
    notFound: "Cari hesap bulunamadı",
    createHint: "Yeni cari hesap ekleyin",
    weOwe: "Biz borçluyuz",
    theyOwe: "Bize borçlular",
    thName: "Ad",
    thPhone: "Telefon",
    thContacts: "Kişiler",
    thDebt: "Borç",
    thActions: "İşlemler",
    contactsSuffix: "kişi",
    editTitle: "Düzenle",
    newTitle: "Cari hesap ekle",
    nameLabel: "Ad",
    namePlaceholder: "Şirket veya kişi adı",
    folderLabel: "Klasör",
    noFolder: "Klasör yok",
    configure: "Ayarla",
    phone: "Telefon",
    phonePlaceholder: "+998 90 000 00 00",
    email: "Email",
    emailPlaceholder: "ornek@mail.com",
    comment: "Yorum",
    commentPlaceholder: "Not...",
    contactsTitle: "İletişim kişileri",
    addContact: "Ekle",
    noContacts: "Kişi eklenmedi",
    cName: "Ad",
    cNamePlaceholder: "Ad Soyad",
    cRole: "Unvan",
    cRolePlaceholder: "Müdür, Yönetici...",
    cPhone: "Numara",
    requisitesTitle: "Firma bilgileri",
    inn: "VKN",
    innPlaceholder: "123456789",
    legalName: "Tüzel unvan",
    legalNamePlaceholder: "«Şirket» Ltd. Şti.",
    legalAddr: "Yasal adres",
    legalAddrPlaceholder: "Taşkent, Çilonzor ilçesi, ...",
    bankAccount: "Banka hesabı",
    bankPlaceholder: "2020 8000 0000 0000 0000",
    update: "Güncelle",
    location: "Adres / Konum",
    locationPlaceholder: "Şehir, sokak, bina...",
    deleteTitle: "Silmeyi onayla",
    deleteText: "silinecek.",
    delete: "Sil",
  },
  uomNames: {
    pcs: "Adet",
    kg: "Kilogram",
    g: "Gram",
    t: "Ton",
    l: "Litre",
    ml: "Mililitre",
    m: "Metre",
    cm: "Santimetre",
    mm: "Milimetre",
    "m²": "Metrekare",
    "m³": "Metreküp",
    km: "Kilometre",
    pair: "Çift",
    roll: "Rulo",
    box: "Kutu",
    pack: "Paket",
    bag: "Torba",
    set: "Takım",
    bottle: "Şişe",
    can: "Teneke",
    cyl: "Silindir",
    coil: "Bobin",
    spool: "Makara",
    sheet: "Levha",
    bunch: "Demet",
    hr: "Saat",
    min: "Dakika",
    day: "Gün",
    week: "Hafta",
    month: "Ay",
    year: "Yıl",
    visit: "Ziyaret",
    session: "Seans",
    project: "Proje",
    page: "Sayfa",
    word: "Kelime",
    trip: "Sefer",
  },
  productForm: {
    variantsTitle: "Varyantlar",
    variantsHint: "Renk, beden gibi özelliklere göre varyantlar",
    attributesTitle: "Özellikler",
    attrNamePlaceholder: "Özellik adı (ör. Renk)",
    attrValuePlaceholder: "Değer ekle + Enter",
    addAttribute: "Özellik ekle",
    generateVariants: "Varyant oluştur",
    variantsListTitle: "Varyantlar",
    totalStock: "Toplam stok",
    variantCol: "Varyant",
    imageCol: "Görsel",
    skuCol: "Stok kodu",
    priceCol: "Fiyat",
    costCol: "Maliyet",
    stockCol: "Stok",
    stockHint: "Her varyant için açılış stokunu girin; ürün stoku = varyantların toplamı",
    ptTitle: "Satış fiyatı türleri",
    ptHint: "Ekleyin, düzenleyin veya silin",
    ptPlaceholder: "ör. Toptan, Perakende...",
    ptAdd: "Fiyat türü ekle",
    added: "Eklendi",
    deleted: "Silindi",
    error: "Hata",
    images: "Görseller",
    imagesHint: "adet • ilki kapak",
    setCover: "Kapak yap",
    uploading: "Yükleniyor...",
    imageDrop: "Bir görsel seçin veya buraya bırakın",
    imageError: "Görsel yükleme hatası",
    dimsTitle: "Ölçüler",
    dimsHint: "— birim başına",
    length: "Uzunluk",
    width: "Genişlik",
    height: "Yükseklik",
    pkgTitle: "Ambalaj birimleri",
    pkgBase: "Temel:",
    pkgNoBase: "Önce «Bilgi» bölümünde temel ölçü birimini seçin",
    pkgUnit: "Ambalaj birimi",
    pkgQty: "Miktar",
    pkgUomSelect: "Birim...",
    pkgAdd: "Ambalaj ekle",
    editTitle: "Düzenle",
    newProduct: "Yeni ürün",
    newService: "Yeni hizmet",
    saved: "Güncellendi",
    saveError: "Bir hata oluştu",
    saving: "Kaydediliyor...",
    update: "Güncelle",
    save: "Kaydet",
    cancel: "İptal",
    nameLabel: "Ad",
    productNamePlaceholder: "Ürün adı",
    serviceNamePlaceholder: "Hizmet adı",
    infoTitle: "Bilgi",
    descLabel: "Açıklama",
    descPlaceholder: "Kısa açıklama...",
    folderLabel: "Klasör",
    noFolder: "Klasör yok",
    select: "Seçin...",
    skuLabel: "Stok kodu",
    skuPlaceholder: "ör. PRD-001",
    pricesTitle: "Fiyatlar",
    buyPrice: "Alış fiyatı",
    salePricesTitle: "Satış fiyatları",
    statusTitle: "Durum",
    back: "Geri",
    uomLabel: "Ölçü birimi",
    minStockLabel: "Min. stok",
    minStockHint: "Stok bu değere veya altına düşerse «Düşük stok» bölümünde görünür (0 = takip yok)",
    configure: "Ayarla",
    active: "Aktif",
    activeBadge: "Aktif",
    isManufacturedLabel: "Üretilen",
    prodNormaTitle: "Üretim normu",
    prodNormaHint: "Bu ürünün 1 birimi için tüketilen hammaddeler",
    prodNormaAdd: "Ekle",
    prodNormaProduct: "Hammadde",
    prodNormaQty: "Mkt",
    prodNormaUom: "Birim",
    prodNormaFooter: "Üretimde bu ürün seçildiğinde norm otomatik yüklenir",
    manufacturingUomLabel: "Üretim ölçü birimi",
    manufacturingUomHint: "Bu ürün seçildiğinde üretim formunda otomatik ayarlanır ve değiştirilemez.",
    manufacturingUomNone: "Ayarlanmadı (herhangi)",
    mkixCodeLabel: "MKIX kodu",
    mkixCodePlaceholder: "ör. 3926909709",
    nameRequired: "Ürün adı zorunludur",
    uomRequired: "Ölçü birimi zorunludur",
  },
  products: {
    variantTag: "varyant",
    typeAll: "Tümü",
    product: "Ürün",
    service: "Hizmet",
    cols: {
      category: "Klasör",
      uom: "Birim",
      sku: "Stok kodu",
      costPrice: "Maliyet",
      avgCost: "Ort. maliyet",
      salePrice: "Satış fiyatı",
      stock: "Stok",
      description: "Açıklama",
      createdAt: "Oluşturuldu",
      updatedAt: "Güncellendi",
      isActive: "Durum",
    },
    active: "Aktif",
    inactive: "Pasif",
    searchPlaceholder: "Ara...",
    colsMenuTitle: "Sütunları ayarla",
    colsMenu: "Sütunlar",
    colsAll: "Tümü",
    colsDefault: "Varsayılan",
    folders: "Klasörler",
    newFolder: "Yeni klasör",
    allFolders: "Tümü",
    noFolders: "Klasör yok",
    mobileAllFolders: "Tümü (klasör)",
    resizeHint: "Boyutlandırmak için sürükleyin (sıfırlamak için çift tıklayın)",
    thName: "Ad",
    notFound: "Ürün bulunamadı",
    createHint: "İlk ürün veya hizmetinizi ekleyin",
    inactiveBadge: "Pasif",
    stockLabel: "Stok",
    uomRequired: "Bir ölçü birimi seçin",
    editTitle: "Düzenle —",
    newProductTitle: "+ Yeni ürün",
    newServiceTitle: "+ Yeni hizmet",
    nameLabel: "Ad",
    productNamePlaceholder: "Ürün adı",
    serviceNamePlaceholder: "Hizmet adı",
    skuLabel: "Stok kodu / Kod",
    uomLabel: "Ölçü birimi",
    select: "Seçin...",
    folderLabel: "Klasör",
    noFolder: "Klasör yok",
    salePrice: "Satış fiyatı",
    costPriceLabel: "Maliyet fiyatı",
    descLabel: "Açıklama",
    optional: "İsteğe bağlı...",
    activeCheck: "Aktif",
    cancel: "İptal",
    save: "Kaydet",
    add: "Ekle",
    saving: "Kaydediliyor...",
    folderEditTitle: "Klasörü düzenle",
    folderNamePlaceholder: "Klasör adı",
    parentFolder: "Üst klasör",
    rootFolder: "Kök klasör",
    deleteTitle: "Silmeyi onayla",
    deleteText: " — silinsin mi? Bu işlem geri alınamaz.",
    delete: "Sil",
    deleting: "Siliniyor...",
    saved: "Güncellendi",
    added: "Eklendi",
    folderSaved: "Klasör güncellendi",
    folderAdded: "Klasör eklendi",
    deleted: "Silindi",
    folderDeleted: "Klasör silindi",
    error: "Bir hata oluştu",
  },
  files: {
    empty: "Henüz dosya yüklenmedi",
    fileName: "Dosya",
    uploading: "Yükleniyor...",
    upload: "Dosya yükle",
    hint: "PDF, görsel, Word, Excel — en fazla 15MB",
    uploaded: "Yüklendi",
    uploadError: "Yükleme hatası",
  },
  smeta: {
    title: "Keşif",
    save: "Kaydet",
    companyName: "Şirket adı",
    companyNamePh: "Şirket adını girin",
    directorName: "Müdürün adı soyadı",
    directorNamePh: "Soyad Ad Baba adı",
    colName: "İş tanımı",
    colCountry: "Ülke",
    colUom: "Birim",
    colQty: "Mkt",
    colPrice: "Fiyat",
    colDeliveryCost: "Teslim bedeli",
    colVat: "KDV %",
    colTotal: "KDV dahil toplam",
    total: "Toplam",
    addRow: "Satır ekle",
    comment: "Yorum",
    commentPh: "Ek notlar...",
    validUntil: "Teklif geçerlilik tarihi",
    validUntilLabel: "Geçerlilik:",
    positions: "Mal ve hizmetler",
    preview: "Önizleme",
    close: "Kapat",
    download: "PDF indir",
    printPdf: "Yazdır / PDF",
    orderNum: "Sipariş №",
    delivery: "Teslim bedeli",
    vat: "KDV",
    grandTotal: "KDV dahil toplam",
    shareLink: "Paylaş",
    linkCopied: "Kopyalandı!",
    linkError: "Bağlantı geçersiz",
  },
  jobOrderForm: {
    dimW: "Genişlik",
    dimL: "Uzunluk",
    back: "Geri",
    title: "Sipariş",
    procStatus: {
      waiting: "Başlamadı",
      "in-progress": "Devam ediyor",
      paused: "Duraklatıldı",
      done: "Tamamlandı",
      problem: "Sorun",
    },
    durMin: "dk",
    durHour: "sa",
    distFromInstall: "Kurulum noktasına uzaklık",
    select: "Seçin...",
    search: "Ara...",
    clearSelection: "— Seçimi temizle —",
    notFound: "Bulunamadı",
    nameRequired: "Ad zorunludur",
    customerAdded: "Müşteri eklendi",
    error: "Hata",
    newCustomer: "Yeni müşteri",
    nameLabel: "Ad",
    customerNamePlaceholder: "Müşteri adı",
    phone: "Telefon",
    cancel: "İptal",
    add: "Ekle",
    docLoadError: "Belge yüklenemedi",
    cashboxRequired: "Bir kasa seçin",
    amountInvalid: "Geçersiz tutar",
    paymentReceived: "Ödeme alındı",
    movedToTrash: "Çöp kutusuna taşındı",
    customerRequired: "Müşteri zorunludur",
    warehouseRequired: "Depo zorunludur",
    agreedInvalid: "Geçersiz anlaşılan tutar",
    deadlineRequired: "Teslim tarihi zorunludur",
    managerRequired: "Proje yöneticisi seçilmelidir",
    agreedRequired: "Anlaşılan tutar zorunludur",
    descriptionRequired: "Açıklama zorunludur",
    savedToast: "Kaydedildi",
    createdToast: "Oluşturuldu",
    saveFirst: "Önce siparişi kaydedin",
    delivered: "Teslim edildi",
    reverted: "Geri alındı",
    modalTitle: "Yeni sipariş",
    modalCreate: "Oluştur ve devam et",
    modalHint: "Kaydettikten sonra süreçleri, giderleri ve toplamları ekleyeceksiniz.",
    fManager: "Proje yöneticisi",
    managerNone: "— Seçilmedi —",
    fSketch: "Eskiz (görsel/PDF)",
    sketchUpload: "Eskiz yükle",
    basicInfo: "Temel bilgiler",
    moveLeft: "Sola taşı",
    moveRight: "Sağa taşı",
    toTrash: "Çöp kutusuna",
    print: "Yazdır",
    printTitle: "Yazdır",
    deliver: "Tamamlandı",
    revertDelivery: "Tamamlamayı geri al",
    confirmAction: "Onayla",
    startAction: "İşleme al",
    completeAction: "Tamamla",
    statusChanged: "Durum değişti",
    startNeedProcess: "Önce bir süreç (aşama) ekleyin",
    startNeedResponsible: "Her sürece bir sorumlu atayın",
    save: "Kaydet",
    deliveredLockTitle: "Teslim edilmiş siparişi düzenlemek için önce teslimi geri alın",
    deliveredBanner: "Teslim edildi. Düzenlemek için önce teslimi geri alın.",
    invoiceTitle: "Fatura gönderilmeli",
    invoiceText1: "Bu siparişteki iş tamamlandı. Fatura şuraya gönderilmeli:",
    invoiceText2: " —",
    invoiceText3: " sözleşmesi kapsamında.",
    contractAmount: "Sözleşme tutarı:",
    fNumber: "Numara",
    fDate: "Tarih",
    fCustomer: "Müşteri",
    customerPlaceholder: "Müşteri...",
    newCustomerTitle: "Yeni müşteri ekle",
    fContract: "Sözleşme",
    noContract: "— Sözleşme yok —",
    fAgreedPrice: "Anlaşılan tutar",
    fCurrency: "Para birimi",
    fDeadline: "Son tarih",
    fWarehouse: "Depo (malzemeler)",
    fFolder: "Klasör",
    noFolder: "— Klasör yok —",
    fDescription: "Açıklama (ne yapılıyor)",
    fShortName: "Kısa ad",
    shortNamePlaceholder: "ör. Mutfak mobilyası",
    shortNameRequired: "Kısa ad zorunludur",
    sketchRequired: "Eskiz yüklemek zorunludur",
    descPlaceholder: "Masa, mutfak mobilyası...",
    fLocation: "Kurulum yeri",
    fLocationHint: "— müşteri bağlantısı (Google Maps, Yandex)",
    openLink: "Bağlantıyı aç",
    copyLink: "Kopyala",
    copied: "Kopyalandı",
    createdBy: "Oluşturan:",
    priceLabel: "Fiyat:",
    paidLabel: "Ödenen:",
    debtLabel: "Borç:",
    workedLabel: "Çalışılan:",
    receivePayment: "Ödeme al",
    processes: "Süreçler",
    addProcess: "Süreç",
    noProcesses: "Süreç yok. «+ Süreç»e tıklayın.",
    addProcessTitle: "Yeni süreç",
    editProcessTitle: "Süreci düzenle",
    addProcessHint: "Bir departman ve sorumlu seçin",
    deptRequired: "Departman zorunludur",
    pDept: "Departman",
    pResponsible: "Sorumlu",
    pStatus: "Durum",
    pLabor: "İşçilik",
    pAllocated: "Ayrılan tutar",
    pNote: "Not",
    pNotePlaceholder: "Not / özel talimat...",
    workedShort: "Çalışılan:",
    historyTitle: "Zaman geçmişi",
    calLoad: "sipariş",
    calBusy: "meşgul",
    historyEmpty: "Henüz işlem yok",
    fromProposal: "Bu sipariş şu tekliften oluşturuldu:",
    viewProposal: "Teklifi görüntüle",
    proposalTitle: "Teklif",
    prDate: "Tarih",
    prCustomer: "Müşteri",
    prAssignee: "Atanan çalışan",
    prCreatedBy: "Oluşturan",
    prDescription: "Açıklama",
    prNote: "Not",
    prFiles: "Dosyalar",
    trackStart: "Başlat",
    trackPause: "Duraklat",
    trackDone: "Bitir",
    trackProblem: "Sorun",
    trackResume: "Devam et",
    materials: "Giderler (malzemeler)",
    addRow: "Satır",
    noMaterials: "Gider yok. «Satır»a tıklayın.",
    mProduct: "Ürün",
    mQty: "Mkt",
    mUom: "Birim",
    mCost: "Maliyet",
    mSum: "Toplam",
    mProcess: "Süreç",
    stockLeft: "Stokta",
    selectVariant: "Varyant seçin",
    uomPlaceholder: "adet",
    costFromProductTitle: "Maliyet ürün kartından alındı",
    costOwnTitle: "Bu siparişin maliyeti",
    totalExpense: "Toplam gider",
    files: "Dosyalar ve projeler",
    totalsTitle: "Son hesap",
    tAgreed: "Anlaşılan tutar",
    tMaterials: "Malzemeler",
    tLabor: "İşçilik",
    tTotalCost: "Toplam maliyet",
    tOtherExpenses: "Diğer giderler",
    otherExpenses: "Diğer giderler",
    addExpense: "Gider ekle",
    noExpenses: "Gider yok",
    expCashbox: "Kasa",
    expCashboxHint: "Yalnızca sipariş para birimindeki kasalar ({cur})",
    expCashboxRequired: "Bir kasa seçin",
    expAmount: "Tutar",
    expAmountRequired: "Tutarı girin",
    expNote: "Not",
    expNotePlaceholder: "Gider açıklaması…",
    expAdded: "Gider eklendi",
    expDeleted: "Gider silindi",
    tProfit: "Kâr",
    totalsHint: "Kaydettikten sonra gerçek maliyet (FIFO/ortalama) kaydedilir ve kâr kesinleşir.",
    freezeAction: "Dondur",
    unfreezeAction: "Devam et",
    freezeTitle: "Siparişi dondur (duraklat)",
    freezeHint: "Dondurma son tarihi ileri kaydırır. Geçen süre devam ettirildiğinde geri verilmez.",
    freezeUntilLabel: "Devam tarihi",
    freezeExtendInfo: "Son tarih {days} gün uzatılacak.",
    freezeConfirm: "Dondur",
    freezeDateRequired: "Lütfen devam tarihini girin",
    freezeSuccess: "Sipariş donduruldu",
    unfreezeSuccess: "Sipariş devam ettirildi",
    frozenBanner: "Donduruldu (duraklatıldı)",
    frozenFrom: "başlangıç:",
    frozenUntil: "bitiş:",
    deleteTitle: "Çöp kutusuna taşı",
    deleteText: "Sipariş çöp kutusuna taşınacak. Hammadde stoku geri yüklenir.",
    deleteTextInvoice: " Otomatik fatura da silinir ve müşteri bakiyesi geri yüklenir.",
    payTitle: "Ödeme al",
    remainingDebt: "Kalan borç:",
    cashbox: "Kasa",
    noCashbox: "bu para biriminde kasa bulunamadı",
    amount: "Tutar",
    payNote: "Not",
    optional: "İsteğe bağlı...",
    receive: "Al",
  },
  proposals: {
    title: "Ticari teklif",
    countSuffix: "adet",
    new: "Teklif",
    newTitle: "Yeni teklif",
    editTitle: "Teklifi düzenle",
    colNumber: "Numara",
    colDate: "Tarih",
    colCustomer: "Müşteri",
    colDescription: "Açıklama",
    colAmount: "Tutar",
    colAssignee: "Çalışan",
    colCreatedBy: "Oluşturan",
    searchPlaceholder: "Numara, müşteri, açıklama...",
    notFound: "Teklif bulunamadı",
    loadError: "Yükleme hatası",
    resizeHint: "Boyutlandırmak için sürükleyin",
    backToList: "Listeye dön",
    emptyTitle: "Teklif seçilmedi",
    emptyHint: "Soldan seçin veya yeni oluşturun",
    wonToast: "Sipariş oluşturuldu! Siparişler bölümünde görüntüleyebilirsiniz.",
    tabs: {
      open: "Açık",
      won: "Kazanıldı",
      lost: "Kaybedildi",
    },
    statWon: "kazanıldı",
    statLost: "kaybedildi",
    statOpen: "açık",
    status: {
      new: "Yeni",
      "in-discussion": "Görüşülüyor",
      won: "Kazanıldı (sipariş)",
      lost: "Reddedildi",
    },
    customerSelect: "Müşteri seçin...",
    search: "Ara...",
    searchEmpty: "Bulunamadı",
    clearSelection: "Seçimi temizle",
    fAssignee: "Atanan çalışan",
    assigneePlaceholder: "Çalışan seçin...",
    assigneeHint: "Atanan çalışan kendi sayfasında (İşlerim) başlat/bitir'e basar",
    fManager: "Yönetici (Sözleşme)",
    managerPlaceholder: "Yönetici veya proje yöneticisi...",
    managerHint: "Sözleşme bu kullanıcıya bağlıdır",
    workStatus: {
      waiting: "Başlamadı",
      "in-progress": "Devam ediyor",
      done: "Tamamlandı",
    },
    docLoadError: "Belge yüklenemedi",
    customerRequired: "Müşteri zorunludur",
    savedToast: "Kaydedildi",
    createdToast: "Oluşturuldu",
    error: "Hata",
    warehouseRequired: "Önce bir depo seçin",
    orderCreated: "Sipariş oluşturuldu!",
    markedLost: "Reddedildi olarak işaretlendi",
    deleteConfirm: "Bu teklif silinsin mi?",
    deletedToast: "Silindi",
    wonBannerTitle: "Sipariş oluşturuldu",
    wonBannerText1: "Bu teklif kazanıldı olarak işaretlendi ve şu siparişe dönüştürüldü: №",
    wonBannerText2: ".",
    openOrder: "Siparişi aç",
    lostBannerTitle: "Reddedilen teklif",
    reasonLabel: "Neden:",
    delete: "Sil",
    rejected: "Reddedildi",
    convertToOrder: "Siparişe dönüştür",
    cancel: "İptal",
    save: "Kaydet",
    fNumber: "Numara",
    fDate: "Tarih",
    fStatus: "Durum",
    fCurrency: "Para birimi",
    fCustomer: "Müşteri",
    fAgreedPrice: "Anlaşılan tutar",
    fWarehouse: "Depo (sipariş için)",
    notSelected: "— Seçilmedi —",
    fDescription: "Açıklama (ne yapılıyor)",
    descPlaceholder: "Müşteri tasarımı / proje açıklaması...",
    fAdvance: "Avans (kapora) tutarı",
    advancePaid: "Avans ödendi",
    fNote: "Not",
    optional: "İsteğe bağlı...",
    fFiles: "Dosyalar (eskiz/fotoğraf/belge)",
    createdBy: "Oluşturan:",
    lostModalTitle: "Teklifi reddet",
    lostReasonLabel: "Neden (isteğe bağlı):",
    lostReasonPlaceholder: "Müşteri karar verdi...",
    winModalTitle: "Siparişe dönüştür",
    winModalText: "Yeni bir sipariş (JobOrder) oluşturulup bu teklife bağlanacak. Süreçler ve malzemeler siparişin içinde eklenir.",
    warehouseRequiredLabel: "Depo *",
    selectPlaceholder: "Seçin...",
    createOrder: "Sipariş oluştur",
  },
  jobOrders: {
    colsReorderHint: "Sıralamak için sürükleyin",
    title: "Siparişler",
    subtitle: "Müşteri siparişi: üretim → teslimat",
    searchPlaceholder: "Numara, müşteri, açıklama...",
    newOrder: "Sipariş",
    notFound: "Sipariş bulunamadı",
    createHint: "Yeni sipariş oluşturun",
    loadError: "Yükleme hatası",
    thNumber: "Numara",
    thActions: "İşlemler",
    filterAll: "Tümü",
    tabAll: "Tümü",
    tabFrozen: "Dondurulmuş",
    overdue: "Gecikmiş",
    costOverrun: "Maliyet aşımı",
    status: {
      new: "Yeni",
      confirmed: "Onaylandı",
      "in-progress": "Devam ediyor",
      delivered: "Tamamlandı",
      cancelled: "İptal edildi",
    },
    cols: {
      sketch: "Eskiz",
      shortName: "Kısa ad",
      date: "Tarih",
      customer: "Müşteri",
      description: "Açıklama",
      folder: "Klasör",
      processes: "Süreçler",
      manager: "Proje yöneticisi",
      agreedPrice: "Anlaşılan",
      paid: "Ödenen",
      debt: "Borç",
      totalCost: "Maliyet",
      materialsCost: "Malzemeler",
      laborCost: "İşçilik",
      profit: "Kâr",
      status: "Durum",
      createdBy: "Oluşturan",
      expectedDeliveryDate: "Son tarih",
      deliveryDate: "Teslim tarihi",
      currency: "Para birimi",
    },
    colsMenu: "Sütunlar",
    colsMenuTitle: "Sütunları ayarla",
    colsAll: "Tümü",
    colsDefault: "Varsayılan",
    statAgreed: "Toplam tutar",
    filterCustomer: "Müşteri",
    filterAllCustomers: "Tüm müşteriler",
    filterAllManagers: "Tüm yöneticiler",
    filterYear: "Yıl",
    filterPeriod: "Dönem",
    filterWholeYear: "Tüm yıl",
    filterAllMonths: "Tüm aylar",
    filterClear: "Temizle",
    statPaid: "Ödenen",
    statDebt: "Borç",
    statCount: "Siparişler",
    folders: "Klasörler",
    newFolder: "Yeni klasör",
    allFolders: "Tümü",
    noFolder: "Klasör yok",
    noFolders: "Klasör yok",
    mobileAllFolders: "Tümü (klasör)",
    folderEdit: "Klasörü düzenle",
    folderNameLabel: "Ad",
    folderNamePlaceholder: "Klasör adı",
    parentFolder: "Üst klasör",
    rootFolder: "Kök klasör",
    folderDeleteTitle: "Klasörü sil",
    folderDeleteText: "klasörü silinecek. İçindeki siparişler korunur (yalnızca klasör bağlantısı kaldırılır).",
    trashTitle: "Çöp kutusuna taşı",
    trashText: "siparişi çöp kutusuna taşınacak. Hammadde stoku geri yüklenir.",
    cancel: "İptal",
    save: "Kaydet",
    add: "Ekle",
    delete: "Sil",
    toTrash: "Çöp kutusuna",
    saved: "Güncellendi",
    addedToast: "Eklendi",
    deletedToast: "Silindi",
    movedToTrash: "Çöp kutusuna taşındı",
    error: "Hata",
    resizeHint: "Boyutlandırmak için sürükleyin (sıfırlamak için çift tıklayın)",
  },
  login: "Giriş",
  register: "Kayıt ol",
  logout: "Çıkış",
  email: "Email",
  phone: "Telefon",
  password: "Şifre",
  confirmPassword: "Şifreyi onayla",
  forgotPassword: "Şifrenizi mi unuttunuz?",
  createOrganization: "Kurum oluştur",
  organizationName: "Kurum adı",
  organizationType: "Kurum türü",
  yourName: "Adınız",
  yourEmail: "E-postanız",
  yourPassword: "Şifre",
  alreadyHaveAccount: "Zaten hesabınız var mı?",
  dontHaveAccount: "Hesabınız yok mu?",
  retail: "Perakende",
  wholesale: "Toptan",
  manufacturing: "Üretim",
  service: "Hizmet",
  other: "Diğer",
  dashboard: "Kontrol paneli",
  welcome: "Hoş geldiniz",
  save: "Kaydet",
  cancel: "İptal",
  delete: "Sil",
  edit: "Düzenle",
  add: "Ekle",
  search: "Ara",
  loading: "Yükleniyor...",
  error: "Hata",
  success: "Başarılı",
  required: "Bu alan zorunludur",
  invalidEmail: "Geçersiz e-posta adresi",
  passwordMin: "Şifre en az 4 karakter olmalıdır",
  passwordMatch: "Şifreler eşleşmiyor",
  login_page: {
    server: "Şirket kodu",
    serverPlaceholder: "ör. miko",
    checking: "kontrol ediliyor...",
    serverNotFound: "Sunucu bulunamadı",
    serverNotFoundHint: "«{slug}» sunucusu mevcut değil. Adresi kontrol edin.",
    phonePlaceholder: "90 123 45 67",
    passwordPlaceholder: "••••••",
    submitting: "Giriş yapılıyor...",
    forgotPassword: "Şifrenizi mi unuttunuz?",
    rights: "© 2025 CRM Line. Tüm hakları saklıdır.",
  },
  sales: {
    dateLocale: "tr-TR",
    types: {
      orders: {
        label: "Siparişler",
        subtitle: "Müşteri siparişleri",
        docLabel: "Satış siparişi",
      },
      invoices: {
        label: "Faturalar",
        subtitle: "Satış faturaları",
        docLabel: "Satış faturası",
      },
      returns: {
        label: "İadeler",
        subtitle: "Müşteriden mal iadesi",
        docLabel: "Satış iadesi",
      },
    },
    statusDraft: "Taslak",
    statusConfirmed: "Onaylandı",
    searchPlaceholder: "Numara veya müşteri...",
    notFound: "Belge bulunamadı",
    createHint: "Yeni belge oluşturun",
    thNumber: "Numara",
    thDate: "Tarih",
    thCustomer: "Müşteri",
    thLines: "Satırlar",
    thSum: "Toplam",
    thStatus: "Durum",
    thVerified: "Doğrulandı",
    thState: "Durum",
    thCurrency: "Para birimi",
    thNote: "Not",
    thActions: "İşlemler",
    linesSuffix: "adet",
    view: "Görüntüle",
    edit: "Düzenle",
    deleteConfirmTitle: "Silmeyi onayla",
    deleteConfirmText: "silinecek.",
    deleteInvoiceExtra: " Stok ve müşteri borcu geri alınacak.",
    cancel: "İptal",
    deleteBtn: "Sil",
    deleted: "Silindi",
    loadError: "Yüklenemedi",
    error: "Hata",
  },
  purchases: {
    dateLocale: "tr-TR",
    types: {
      orders: {
        label: "Siparişler",
        subtitle: "Tedarikçilere satın alma siparişi belgeleri",
        docLabel: "Satın alma siparişi",
      },
      receipts: {
        label: "Girişler",
        subtitle: "Tedarikçi faturaları (girişler)",
        docLabel: "Giriş belgesi",
      },
      returns: {
        label: "İadeler",
        subtitle: "Tedarikçiye mal iadesi",
        docLabel: "Alış iadesi",
      },
    },
    statusDraft: "Taslak",
    statusConfirmed: "Onaylandı",
    searchPlaceholder: "Numara veya tedarikçi...",
    notFound: "Belge bulunamadı",
    createHint: "Yeni belge oluşturun",
    thNumber: "Numara",
    thDate: "Tarih",
    thSupplier: "Tedarikçi",
    thLines: "Satırlar",
    thSum: "Toplam",
    thStatus: "Durum",
    thVerified: "Doğrulandı",
    thState: "Durum",
    thCurrency: "Para birimi",
    thWarehouse: "Depo",
    thNote: "Not",
    thPayment: "Ödeme",
    payCash: "Nakit",
    payCredit: "Vadeli",
    thActions: "İşlemler",
    linesSuffix: "adet",
    view: "Görüntüle",
    edit: "Düzenle",
    deleteConfirmTitle: "Silmeyi onayla",
    deleteConfirmText: "silinecek.",
    cancel: "İptal",
    deleteBtn: "Sil",
    deleted: "Silindi",
    loadError: "Yüklenemedi",
    error: "Hata",
  },
  salesForm: {
    docTypes: {
      orders: "Satış siparişi",
      invoices: "Satış faturası",
      returns: "Satış iadesi",
    },
    back: "Geri",
    delete: "Sil",
    print: "Yazdır",
    copy: "Kopyala",
    cancel: "İptal",
    save: "Kaydet",
    add: "Ekle",
    error: "Hata",
    statusManage: "Durumları yönet",
    statusEdit: "Düzenle",
    statusNew: "Yeni durum",
    statusNamePlaceholder: "Durum adı...",
    statusAdd: "Ekle",
    productSearchPlaceholder: "Ürün ara...",
    productNotFoundCreate: "Bulunamadı. Yeni ürünü şununla oluşturun:",
    productNotFoundCreate2: ".",
    catalogEmpty: "Katalog boş — + ile ürün ekleyin",
    productTypeName: "Ürün adını yazın...",
    notFound: "Bulunamadı",
    searchPlaceholder: "Ara...",
    customerSelect: "Müşteri seçin...",
    customerAdded: "Müşteri eklendi",
    newCustomer: "Yeni müşteri",
    nameRequired: "Ad *",
    customerNamePlaceholder: "Müşteri adı",
    phone: "Telefon",
    nameRequiredToast: "Ad zorunludur",
    warehouseSelect: "Depo seçin...",
    warehouseUpdated: "Güncellendi",
    warehouseAdded: "Depo eklendi",
    editWarehouse: "Depoyu düzenle",
    newWarehouse: "Yeni depo",
    warehouseNamePlaceholder: "Depo adı",
    currency: "Para birimi",
    baseLabel: "temel",
    uploaded: "Yüklendi",
    uploadError: "Yüklenemedi",
    file: "Dosya",
    uploading: "Yükleniyor...",
    uploadFile: "Dosya yükle",
    noFiles: "Henüz dosya yüklenmedi",
    fileHint: "PDF, görsel, Word, Excel — en fazla 15MB",
    productAdded: "Ürün eklendi",
    newProduct: "Yeni ürün",
    productNamePlaceholder: "Ürün adı",
    costPrice: "Maliyet fiyatı",
    docLoadError: "Belge yüklenemedi",
    customerRequired: "Bir müşteri seçilmelidir",
    warehouseRequired: "Bir depo seçilmelidir",
    deadlineRequired: "Teslim tarihi zorunludur",
    managerRequired: "Proje yöneticisi seçilmelidir",
    agreedRequired: "Anlaşılan tutar zorunludur",
    descriptionRequired: "Açıklama zorunludur",
    currencyRequired: "Para birimi seçilmelidir",
    cashboxRequired: "Kasa seçilmelidir",
    dateInvalid: "Geçersiz tarih (GG/AA/YYYY SS:DD)",
    deliveryDateInvalid: "Geçersiz teslim tarihi (GG/AA/YYYY)",
    needQty: "En az bir kalem için miktar girin",
    saved: "Kaydedildi",
    created: "Eklendi",
    copyNeedRow: "Kopyalamak için en az bir satır gerekir",
    copyCreated: "Kopya oluşturuldu",
    deleted: "Silindi",
    productAlready: "Bu ürün zaten eklendi",
    dateLabel: "Tarih:",
    dateMaskPlaceholder: "GG/AA/YYYY SS:DD",
    statusless: "Durum yok",
    verified: "Doğrulandı",
    counterparty: "Cari hesap *",
    newCounterpartyTitle: "Cari hesap ekle",
    warehouse: "Depo",
    editWarehouseTitle: "Depoyu düzenle",
    newWarehouseTitle: "Depo ekle",
    currencyReq: "Para birimi *",
    payment: "Ödeme",
    payCredit: "Vadeli (müşteri borçlu)",
    payCreditHint: "Müşteri bakiyesine kaydedilir — sonra Gelen ödeme ile ödenir.",
    payCash: "Nakit ödeme (kasaya)",
    payCashHint: "Tutar hemen kasaya girer, müşteri bakiyesini etkilemez.",
    cashbox: "Kasa",
    selectPlaceholder: "Seçin...",
    notSelected: "— Seçilmedi —",
    arrivalDate: "Varış tarihi",
    createInvoice: "Satış oluştur",
    customerReq: "Müşteri *",
    invoiceCreated: "Satış oluşturuldu (stoktan düşüldü)",
    newCustomerTitle: "Müşteri ekle",
    priceType: "Fiyat türü",
    priceTypeDefault: "Standart (1. fiyat)",
    cashboxBalance: "bakiye",
    noCashbox: "«{currency}» cinsinden kasa bulunamadı (veya size atanmamış)",
    tabItems: "Kalemler",
    tabFiles: "Dosyalar",
    thName: "Ad",
    thSells: "Satış birimi",
    thUom: "Birim",
    uomSelect: "Birim",
    uomRequired: "Her ürün için bir birim seçin",
    overStock: "«{name}» stokta yetersiz (mevcut: {qty} {uom})",
    thAvailable: "Mevcut",
    thPrice: "Fiyat",
    thDiscount: "İndirim %",
    thSum: "Tutar",
    thVatRate: "KDV oranı",
    thVatAmount: "KDV tutarı",
    thTotal: "Toplam",
    newProductTitle: "Yeni ürün oluştur",
    total: "Ara toplam",
    totalVat: "KDV",
    grandTotal: "Toplam (KDV dahil)",
    note: "Not",
    notePlaceholder: "Not veya ek bilgi...",
    saleConfirmed: "Satış onaylandı",
    saleConfirmedHint: "Ürün stoku azaldı ve müşteri borcu arttı (+{amount}).",
    deleteConfirmTitle: "Silmeyi onayla",
    deleteConfirmText: "kalıcı olarak silinecek.",
    partyLabel: "Müşteri",
  },
  purchaseForm: {
    docTypes: {
      orders: "Satın alma siparişi",
      receipts: "Giriş belgesi",
      returns: "Alış iadesi",
    },
    back: "Geri",
    delete: "Sil",
    save: "Kaydet",
    createReceipt: "Giriş oluştur",
    cancel: "İptal",
    error: "Hata",
    statusManage: "Durumları yönet",
    statusEdit: "Düzenle",
    statusNew: "Yeni durum",
    statusNamePlaceholder: "Durum adı...",
    statusAdd: "Ekle",
    productSearchPlaceholder: "Ürün ara...",
    productNotFoundCreate: "Bulunamadı. Yeni ürünü şununla oluşturun:",
    productNotFoundCreate2: ".",
    catalogEmpty: "Katalog boş — + ile ürün ekleyin",
    productTypeName: "Ürün adını yazın...",
    notFound: "Bulunamadı",
    supplierSelect: "Tedarikçi seçin...",
    supplierAdded: "Tedarikçi eklendi",
    newSupplier: "Yeni tedarikçi",
    nameRequired: "Ad *",
    supplierNamePlaceholder: "Tedarikçi adı",
    phone: "Telefon",
    warehouseSelect: "Depo seçin...",
    warehouseUpdated: "Güncellendi",
    warehouseAdded: "Depo eklendi",
    editWarehouse: "Depoyu düzenle",
    newWarehouse: "Yeni depo",
    warehouseNamePlaceholder: "Depo adı",
    nameRequiredToast: "Ad zorunludur",
    add: "Ekle",
    currency: "Para birimi",
    uploadError: "Yüklenemedi",
    file: "Dosya",
    uploading: "Yükleniyor...",
    uploadFile: "Dosya yükle",
    uploaded: "Yüklendi",
    noFiles: "Henüz dosya yüklenmedi",
    fileHint: "PDF, görsel, Word, Excel — en fazla 15MB",
    productAdded: "Ürün eklendi",
    newProduct: "Yeni ürün",
    productNamePlaceholder: "Ürün adı",
    costPrice: "Maliyet fiyatı",
    docLoadError: "Belge yüklenemedi",
    procLoadError: "Tedarik talebi yüklenemedi",
    productAlready: "Bu ürün zaten eklendi",
    selectVariant: "Varyant seçin",
    variantRequired: "Varyantlı ürün için bir varyant seçin",
    supplierRequired: "Bir tedarikçi seçilmelidir",
    linkedProductsHint: "Yalnızca bu tedarikçinin ürünleri gösteriliyor",
    warehouseRequired: "Bir depo seçilmelidir",
    currencyRequired: "Para birimi seçilmelidir",
    cashboxRequired: "Kasa seçilmelidir",
    dateInvalid: "Geçersiz tarih (GG/AA/YYYY SS:DD)",
    deliveryDateInvalid: "Geçersiz teslim tarihi (GG/AA/YYYY)",
    needQty: "En az bir kalem için miktar girin",
    saved: "Kaydedildi",
    created: "Eklendi",
    copyNeedRow: "Kopyalamak için en az bir satır gerekir",
    copyCreated: "Kopya oluşturuldu",
    receiptCreated: "Giriş oluşturuldu ve stoka alındı",
    deleted: "Silindi",
    statusless: "Durum yok",
    dateLabel: "Tarih:",
    dateMaskPlaceholder: "GG/AA/YYYY SS:DD",
    verified: "Onaylandı",
    verifiedLockTitle: "Onaylanmış belgeyi yalnızca yönetici geri alabilir",
    counterparty: "Cari hesap *",
    newCounterpartyTitle: "Cari hesap ekle",
    editWarehouseTitle: "Depoyu düzenle",
    newWarehouseTitle: "Depo ekle",
    arrivalDate: "Varış tarihi",
    dateOnlyPlaceholder: "GG/AA/YYYY",
    currencyReq: "Para birimi *",
    paymentMode: "Ödeme yöntemi",
    payDebt: "Borç (tedarikçiye borçlu)",
    payDebtHint: "Tedarikçi bakiyesi artar — sonra Giden ödeme ile ödenir.",
    payCash: "Nakit (kasadan ödendi)",
    payCashHint: "Tutar hemen kasadan çıkar, tedarikçi bakiyesini etkilemez.",
    cashbox: "Kasa",
    selectPlaceholder: "Seçin...",
    noCashbox: "«{currency}» cinsinden kasa bulunamadı (veya size atanmamış)",
    convRate: "Çevrim kuru",
    convEdit: "Kuru düzenle",
    convDeducted: "Kasadan düşülen",
    thName: "Ad",
    thNeed: "Gerekli",
    thReceived: "Alınan",
    thOrdered: "Sipariş edilen",
    thAvailable: "Mevcut",
    thPrice: "Fiyat",
    thDiscount: "İndirim %",
    thSum: "Toplam",
    newProductTitle: "Yeni ürün oluştur",
    overReceiveError: "Gerekli miktardan fazla alınamaz",
    excludeFromReceipt: "Bu girişten çıkar",
    total: "Toplam",
    note: "Not",
    notePlaceholder: "Not veya ek bilgi...",
    receiptConfirmed: "Giriş onaylandı",
    receiptConfirmedHint: "Ürün stoku güncellendi ve tedarikçi bakiyesi arttı (+{amount}).",
    deleteConfirmTitle: "Silmeyi onayla",
    deleteConfirmText: "kalıcı olarak silinecek.",
    partyLabel: "Tedarikçi",
    warehouse: "Depo",
    warehouseNone: "— Seçilmedi —",
    baseLabel: "temel",
    print: "Yazdır",
    copy: "Kopyala",
    tabItems: "Kalemler",
    tabFiles: "Dosyalar",
    searchPlaceholder: "Ara...",
    docNumberDash: "—",
    addRow: "Satır ekle",
  },
  procEditor: {
    pageTitle: "Tedarik talebi",
    back: "Geri",
    lockedTitle: "Belge salt okunur",
    lockedText: "Bu talep geçmiş bir güne ({date}) aittir. Geçmiş günlerin belgeleri yalnızca görüntülenebilir.",
    toTrash: "Çöp kutusuna",
    createReceipt: "Giriş oluştur",
    close: "Kapat",
    cancel: "İptal",
    save: "Kaydet",
    number: "Numara",
    date: "Tarih",
    needBy: "Teslim son tarihi",
    assignee: "Satın almacı (sorumlu)",
    statusPrefix: "Durum:",
    receiptsLinked: "· {n} giriş bağlı",
    overdue: "Gecikmiş",
    neededProducts: "Gerekli ürünler",
    rowsCount: "{n} satır",
    thProduct: "Ürün",
    thImage: "Görsel",
    thNeed: "Gerekli",
    thUom: "Birim",
    thReceived: "Alınan",
    thRemaining: "Kalan",
    thNote: "Not",
    uomPlaceholder: "adet",
    optional: "İsteğe bağlı",
    addRow: "Satır ekle",
    note: "Not",
    notePlaceholder: "İsteğe bağlı...",
    attachments: "Ek (görsel/dosya)",
    trashModalTitle: "Çöp kutusuna taşı",
    trashModalText: "Talep çöp kutusuna taşınacak. Bağlı giriş belgeleri korunur.",
    needRow: "En az bir satır girin",
    assigneeRequired: "Lütfen bir satın almacı seçin",
    saved: "Kaydedildi",
    created: "Oluşturuldu",
    movedToTrash: "Çöp kutusuna taşındı",
    loadDocError: "Belge yüklenemedi",
    error: "Hata",
  },
  procurement: {
    dateLocale: "tr-TR",
    title: "Tedarik",
    countSuffix: "talep",
    newRequestShort: "Talep",
    newRequestTitle: "Yeni talep",
    searchPlaceholder: "Numara, not...",
    notFound: "Talep bulunamadı",
    unassigned: "— atanmamış",
    positionsSuffix: "kalem",
    boughtOf: "{total} kalemden {bought} alındı",
    uploadError: "Yükleme hatası",
    imgZoom: "Büyüt",
    selectVariant: "Varyant seçin",
    thDate: "Tarih",
    thProduct: "Ürün",
    thNeed: "Gerekli",
    thUom: "Birim",
    thNote: "Not",
    optional: "İsteğe bağlı...",
    thBuy: "Satın al",
    addRow: "Satır ekle",
    flatHint: "Alt satırdan ürün ekleyin — bugünün talebine girer. Gecikmiş satırlar kırmızıdır.",
    error: "Hata",
    resizeHint: "Boyutlandırmak için sürükleyin (sıfırlamak için çift tıklayın)",
    backToList: "Listeye dön",
    newDocTitle: "Yeni tedarik talebi",
    emptyTitle: "Talep seçilmedi",
    emptyHint: "Soldaki listeden seçin veya yeni talep oluşturun",
    loadError: "Yüklenemedi",
    tabs: {
      overdue: "Gecikmiş",
      new: "Yeni",
      partial: "Kısmi",
      fulfilled: "Tamamlandı",
    },
    status: {
      new: "Yeni",
      partial: "Kısmi",
      fulfilled: "Tamamlandı",
      cancelled: "İptal edildi",
    },
  },
  dashboardHome: {
    showPeriod: "Göster: {p}",
    secOverview: "İşletme şu anda",
    kpiOpenDeals: "Açık anlaşmalar",
    kpiNewContacts: "Bugünkü yeni kişiler",
    kpiUnanswered: "Yanıtlanmamış",
    kpiUnansweredSub: "Gelen kutusundaki yazışmalar",
    kpiCalls: "Bugünkü aramalar",
    kpiNewContactsSub: "Bugün eklendi",
    kpiCallsSub: "Gelen ve giden",
    dateLocale: "tr-TR",
    loadError: "Veriler yüklenemedi",
    retry: "Tekrar dene",
    overdueLabel: "Gecikmiş",
    overdueSubAlert: "Acil ilgi gerekiyor",
    overdueSubOk: "Hepsi zamanında",
    completedLabel: "Tamamlandı",
    completedSub: "Son aşamada",
    activeLabel: "Aktif görevler",
    activeSub: "Yapılması gereken",
    unassignedLabel: "Atanmamış",
    unassignedSubNoLeads: "Atanmamış potansiyel müşteriler",
    goalsTitle: "Hedefler",
    gaugeSum: "Tutar",
    gaugeDealCount: "Anlaşma sayısı",
    byEmployee: "Çalışana göre",
    donutSum: "Tutar",
    donutCount: "Adet",
    byManager: "Yöneticiye göre",
    dealsCountLabel: "Anlaşmalar",
    sumLabel: "Tutar",
    dealSources: "Anlaşma kaynakları",
    other: "Diğer",
    total: "Toplam",
    unit: "",
    secCalls: "Aramalar",
    secCallsSub: "Gelen ve giden, cevaplanan ve cevapsız",
    secTasks: "Görevler",
    secSales: "Satışlar",
    pToday: "Bugün",
    pWeek: "Hafta",
    pMonth: "Ay",
    allEmployees: "Tüm çalışanlar",
    noEmployee: "Çalışan yok",
    cTotal: "Toplam arama",
    cIn: "Gelen",
    cOut: "Giden",
    cMissed: "Cevapsız",
    cAvg: "Ortalama süre",
    cAnswered: "Cevaplanan {n}",
    cMissedN: "Cevapsız {n}",
    cMissedPct: "Tüm aramaların %{n}'i",
    cTalk: "Toplam konuşma süresi: {t}",
    chartTitle: "Arama etkinliği",
    legIn: "Gelen",
    legOut: "Giden",
    legMissed: "Cevapsız",
    empTitle: "Çalışana göre",
    thEmployee: "Çalışan",
    thTotal: "Toplam",
    thIn: "Gelen",
    thOut: "Giden",
    thMissed: "Cevapsız",
    thTalk: "Konuşma süresi",
    noCalls: "Seçilen dönemde arama yok",
    callsLoadError: "Arama istatistikleri yüklenemedi",
    openCalls: "Tüm aramalar",
    cNoAnswerN: "Yanıt yok {n}",
  },
  nav: {
 education: "Eğitim", "education-groups": "Eğitim: gruplar ve ayarlar",
    integrations: "Entegrasyonlar",
    dashboard: "Kontrol paneli",
    contacts: "Kişiler",
    tasks: "Görevler",
    inbox: "Gelen kutusu",
    calls: "Aramalar",
    reviews: "Yorumlar",
    funnels: "Huniler",
    purchases: "Satın alma",
    "purchases-procurement": "Tedarik",
    "purchases-orders": "Siparişler",
    "purchases-receipts": "Girişler",
    "purchases-returns": "İadeler",
    sales: "Satışlar",
    "sales-orders": "Siparişler",
    "sales-invoices": "Faturalar",
    "sales-returns": "İadeler",
    "job-orders": "Siparişler",
    "job-orders-proposals": "Ticari teklif",
    "job-orders-orders": "Siparişler",
    inventory: "Ürünler",
    counterparties: "Cari hesaplar",
    "counterparties-list": "Cari hesaplar",
    "counterparties-contracts": "Sözleşmeler",
    "counterparties-aktsverka": "Mutabakat",
    sklad: "Depo",
    "sklad-balances": "Stok bakiyeleri",
    "sklad-valuation": "Değerleme",
    "sklad-transfers": "Transferler",
    "sklad-warehouses": "Depolar",
    "sklad-lowstock": "Düşük stok",
    finance: "Finans",
    "finance-balance": "Şirket bakiyesi",
    "finance-pnl": "Kâr ve zarar",
    "finance-analysis": "Analiz",
    "finance-payments": "Ödemeler",
    "finance-requests": "Talepler",
    "finance-debts": "Borçlar",
    "finance-conversions": "Döviz çevirme",
    "finance-cashboxes": "Kasalar",
    "finance-scheduled": "Planlı ödemeler",
    "finance-assets": "Varlıklar",
    production: "Üretim",
    "production-orders": "Üretim",
    "production-packaging": "Paketleme",
    "production-bom": "Reçeteler (BOM)",
    analytics: "Analitik",
  },
  analysis: {
    title: "Analiz",
    subtitle: "Gelen fonların gider normlarına aylık dağılımı",
    income: "Gelir",
    allocated: "Ayrılan",
    spent: "Harcanan",
    available: "Kullanılabilir",
    carryIn: "Önceki aydan",
    normSum: "Normların toplamı",
    normHint: "Normların toplamının %100 olması önerilir.",
    empty: "Gider kategorisi yok.",
    remain: "Kalan",
    over: "Bütçe aşıldı",
    toNextMonth: "Sonraki aya devreder",
    loadError: "Veriler yüklenemedi",
    error: "Bir hata oluştu",
    date: "Tarih",
    total: "Toplam",
    noSpend: "Bu ay gider yok.",
    spentTotal: "Toplam harcanan",
    allocatedRow: "Kullanılabilir (norm)",
    carryShort: "(önceki ay)",
    diffRow: "Fark → sonraki ay",
    diffHint: "Pozitif fark kalanı sonraki aya taşır; negatif, bütçenin aşıldığı anlamına gelir.",
    readonly: "Salt okunur",
    noCounterparty: "Cari hesap yok",
    unitK: "B",
    unitM: "Mn",
    unitB: "Mr",
    configNorms: "Yüzdeleri ayarla",
    normsTitle: "Kategori yüzdeleri (norm)",
    normsHint: "Aylık gelirin yüzde kaçının her kategoriye ayrılacağını belirleyin.",
    normsSaved: "Yüzdeler kaydedildi",
    byCategoryTitle: "Kategoriye göre (aylık)",
    colName: "Ad",
    colSumma: "Tutar",
    colNorma: "Norm",
    colReal: "Gerçek %",
    colResult: "Sonuç",
    resultHint: "Sonuç = Norm − Gerçek. Pozitif (yeşil) — normun altında harcandı; negatif (kırmızı) — bütçe aşıldı.",
    save: "Kaydet",
    cancel: "İptal",
  },
  account: {
    title: "Hesap ayarları",
    subtitle: "Kişisel bilgilerinizi düzenleyin",
    personalInfo: "Kişisel bilgiler",
    name: "Ad",
    email: "Email",
    emailHint: "(şifre kurtarma için)",
    emailPlaceholder: "ornek@mail.com",
    phone: "Telefon",
    phoneHint: "Telefon numarası değiştirilemez",
    save: "Kaydet",
    saving: "Kaydediliyor...",
    profileUpdated: "Profil güncellendi",
    genericError: "Bir hata oluştu",
    changePassword: "Şifre değiştir",
    currentPassword: "Mevcut şifre",
    newPassword: "Yeni şifre",
    confirmPassword: "Yeni şifreyi onayla",
    passwordMismatch: "Yeni şifreler eşleşmiyor",
    passwordTooShort: "Şifre en az 4 karakter olmalıdır",
    passwordChanged: "Şifre başarıyla değiştirildi",
    changePasswordBtn: "Şifre değiştir",
    namePlaceholder: "Ad soyad",
    role: "Rol",
    hide: "Gizle",
    show: "Göster",
  },
  settings: {
    title: "Ayarlar",
    back: "Geri",
    tabs: {
      general: "Genel ayarlar",
      branding: "Marka",
      modules: "Menü",
      users: "Kullanıcılar",
      workers: "Çalışanlar",
      roles: "Roller",
      currencies: "Para birimleri",
      uom: "Ölçü birimleri",
      company: "Şirket",
      assets: "Varlıklar",
      trash: "Çöp kutusu",
      funnels: "Huniler",
      tasks: "Görevler",
      "deal-sources": "Anlaşma kaynakları",
      "close-reasons": "Kapanış nedenleri",
      "lead-forms": "Formlar",
      goals: "Hedefler",
      integrations: "Entegrasyonlar",
      inbox: "Gelen kutusu",
      atc: "Telefon santrali (ATC)",
      "ai-calls": "Yapay zekâ ile arama analizi",
      "api-keys": "API anahtarları",
      "google-sheets": "Google Sayfaları",
      "owner-bot": "Yönetici botu",
      education: "Eğitim",
      "lead-fields": "Potansiyel müşteri alanları",
      audit: "Denetim günlüğü",
    },
    groups: {
      team: "Ekip",
      general: "Genel",
      crm: "CRM",
      channels: "Entegrasyonlar",
      system: "Sistem",
    },
    atc: {
      title: "Santral / IP telefon entegrasyonu",
      subtitle: "Mediateka (Sarkor Telekom), Sipuni veya Utel santrali için webhook ayarları",
      connected: "Bağlı",
      notConnected: "Bağlı değil",
      provider: "Santral sağlayıcısı",
      callBtn: "«Ara» butonu",
      modeAtc: "Yalnızca santral",
      modePersonal: "Yalnızca kişisel telefon",
      modeBoth: "İkisi de — çalışan seçer",
      callBtnHint: "Kişiler, Potansiyel müşteriler ve Aramalar sayfalarındaki tüm «Ara» butonları için geçerlidir. Santral bağlı değilse bu ayardan bağımsız olarak her zaman kişisel telefon kullanılır.",
      popupTitle: "Gelen arama bildirimini kim görür (sağ üst köşe)",
      popupHint: "Hiçbiri seçilmezse herkes görür (varsayılan). Sahip/yönetici her zaman görür.",
      popupNoRoles: "Özel rol oluşturulmadı — şimdilik bu ayar herkese uygulanır",
      crmToken: "CRM Token",
      tokenPlaceholder: "Gizli bir token girin...",
      tokenHint: "Santral webhook URL'sine eklenir. Herhangi bir değer olabilir.",
      webhookTitle: "Santralde ayarlanacak webhook URL'si:",
      copied: "Kopyalandı!",
      copy: "Kopyala",
      sipuniWebhookHint: "Sipuni panelinde: Ayarlar → API → «Call event» (PBX Events) bölümü.",
      utelDomain: "Utel alan adı",
      utelDomainHint: "Santralinizin alt alan adı, örn. cc999 (adres cc999.utel.uz).",
      utelEmail: "Utel e-postası",
      utelPassword: "Utel şifresi",
      utelPasswordHint: "Şifre token almak için bir kez kullanılır ve CRM’de saklanmaz.",
      utelConnect: "Utel’i bağla",
      utelReconnect: "Yeniden bağla",
      utelConnecting: "Bağlanıyor…",
      utelConnectedTo: "Bağlı: {domain}",
      utelConnectedOk: "Utel bağlandı",
      utelNeedConnect: "Önce Utel’i bağlayın (panel kullanıcı adı ve şifresi).",
      utelCheck: "Bağlantıyı kontrol et",
      utelTokenOk: "Utel API erişimi çalışıyor",
      utelTokenBad: "Utel token’ı kabul etmedi: yeniden bağlayın",
      utelWebhookFound: "Webhook Utel’de tanımlı",
      utelWebhookMissing: "Utel’de bizim adresimizle webhook bulunamadı: ekleyin (aşağıya bakın)",
      utelEventsOn: "Açık olaylar",
      utelEventsOff: "Kapalı",
      utelExtensions: "Utel dahili numaraları",
      utelNoExtensions: "Numara listesi alınamadı",
      utelSync: "Son 3 günün aramalarını yükle",
      utelSynced: "Yüklenen arama: {n}",
      utelSyncFailed: "Arama geçmişi yüklenemedi",
      utelWebhookHint: "Utel panelinde: Entegrasyon → Webhook bölümüne bu adresi yapıştırın ve call_started, dial_answered, call_ended, call_saved olaylarını açın (dial_started isteğe bağlı).",
      utelNoClickToCall: "Ara düğmesi Utel yöntemiyle (services/originate) çalışır. İstek alanları belgelenmediği için ilk aramada CRM olası biçimleri kendisi dener: bir deneme araması yapıp kontrol edin.",
      unknownTitle: "Bilinmeyen numaralardan aramalar",
      unknownHint: "Eşleşen kişi bulunamazsa otomatik olarak kişi oluşturulur. Potansiyel müşterinin de otomatik oluşturulmasını istiyorsanız nereye gideceğini seçin (isteğe bağlı).",
      noLead: "— Potansiyel müşteri oluşturma —",
      noStage: "— Aşama seçilmedi —",
      apiToken: "API Token (Click-to-call için)",
      apiTokenHint: "Mediateka santrali (ibrat.sip.uz) yönetim API tokeni (arama başlatmak için)",
      sipDomainHint: "Yalnızca alan adı. Click-to-call için:",
      sipuniUser: "Sipuni hesap numarası (user)",
      sipuniUserHint: "Sipuni panelinizdeki hesap numarası",
      sipuniSecret: "Sipuni Secret Key",
      sipuniSecretHint: "Sipuni → Ayarlar → API'den gizli anahtar (click-to-call için)",
      save: "Kaydet",
      saved: "Kaydedildi",
      error: "Hata",
    },
    branding: {
      title: "Marka",
      subtitle: "Kurum adı, logo ve marka rengi — uygulama bu görünümle açılır",
      orgName: "Kurum adı",
      orgNamePlaceholder: "Şirket adı",
      logo: "Logo",
      upload: "Yükle",
      removeLogo: "Kaldır",
      brandColor: "Marka rengi",
      defaultGreen: "Varsayılan (yeşil)",
      customColor: "Özel renk",
      solidTitle: "Kenar çubuğu/üst çubuk orijinal renkte",
      solidHint: "Açıkken kenar çubuğu ve üst çubuk seçilen rengi aynen gösterir (koyulaştırma yok). Kapalı — mevcut koyu ton.",
      preview: "Önizleme",
      primaryBtn: "Birincil buton",
      badge: "Etiket",
      linkText: "Bağlantı metni",
      save: "Kaydet",
      imageOnly: "Yalnızca görsel dosyası",
      uploadError: "Yükleme başarısız",
      nameRequired: "Kurum adı zorunludur",
      saved: "Marka kaydedildi",
      error: "Hata",
    },
    users: {
      countPrefix: "Toplam",
      countSuffix: "kullanıcı",
      searchPlaceholder: "Ad veya telefon...",
      noResults: "Hiçbir şey bulunamadı",
      seats: "Tarifenizdeki koltuk: {total} içinden {used}",
      add: "Ekle",
      thUser: "Kullanıcı",
      thPhone: "Telefon",
      thRole: "Rol",
      thDept: "Departman",
      noDept: "Departman yok",
      thStatus: "Durum",
      you: "Siz",
      userType: "Çalışan türü",
      userTypeNone: "Normal çalışan",
      userTypeHint: "Bir rol seçin: satın almacı / süreç çalışanı / proje yöneticisi (isteğe bağlı)",
      snabjenist: "Satın almacı",
      active: "Aktif",
      inactive: "Pasif",
      editTitle: "Düzenle",
      changePasswordTitle: "Şifre değiştir",
      deleteTitle: "Sil",
      newUser: "Yeni kullanıcı",
      editUser: "Kullanıcıyı düzenle",
      name: "Ad",
      namePlaceholder: "Ad soyad",
      role: "Rol",
      position: "Unvan",
      dept: "Departman",
      deptNone: "— Seçilmedi —",
      deptMulti: "Departmanlar (birden fazla)",
      noDeptsYet: "Henüz departman yok",
      cpFolders: "Cari hesap klasörleri (erişim)",
      cpFoldersHint: "Satın alma sorumlusu yalnızca işaretlenen klasörlerdeki cari hesapları görür. Hiçbiri işaretlenmezse — tümü.",
      noFoldersYet: "Henüz klasör yok",
      snabjenistHint: "Açıksa Tedarik formundaki «Sorumlu» listesinde görünür",
      customRole: "Rol (RBAC)",
      customRoleNone: "— Sınırsız (tam) —",
      customRoleHint: "Özel rol atanırsa kullanıcı onun yetkileriyle sınırlanır. Sahip/yönetici her zaman tam yetkilidir.",
      roleHint: "Yönetici — tam erişim (RBAC atlanır). Kullanıcı — sınırlı; aşağıdan özel rol seçebilirsiniz.",
      adminFullHint: "Yönetici tüm modüllere erişebilir — özel rol (RBAC) gerekmez.",
      processWorker: "Süreç çalışanı",
      processWorkerHint: "Sipariş süreçlerine atanabilir ve onları başlatıp bitirip duraklatabilir",
      projectManager: "Proje yöneticisi",
      cashier: "Kasiyer",
      projectManagerHint: "Siparişte sorumlu yönetici olarak seçilebilir (sipariş oluştururken listede görünür)",
      permissions: "Yetkiler",
      cashboxes: "Bağlı kasalar (satın almacı için)",
      cashboxesHint: "Nakit girişte kullanıcı yalnızca bu kasaları seçebilir. Boş bırakılırsa kullanıcı nakit giriş yapamaz.",
      phone: "Telefon",
      phonePlaceholder: "90 123 45 67",
      email: "Email",
      emailHint: "(şifre kurtarma için)",
      emailPlaceholder: "ornek@mail.com",
      password: "Şifre",
      passwordPlaceholder: "En az 6 karakter",
      newPassword: "Yeni şifre",
      passwordModalTitle: "Şifre —",
      cancel: "İptal",
      save: "Kaydet",
      saving: "Kaydediliyor...",
      change: "Değiştir",
      deleteUser: "Kullanıcıyı sil",
      deleteConfirmPrefix: "Silmeyi onaylayın:",
      deleteConfirmSuffix: "? Bu işlem geri alınamaz.",
      deleteBtn: "Sil",
      deleting: "Siliniyor...",
      accountOwner: "Hesap sahibi",
      loadError: "Kullanıcılar yüklenemedi",
      updated: "Kullanıcı güncellendi",
      passwordChanged: "Şifre değiştirildi",
      deleted: "Kullanıcı silindi",
      added: "Kullanıcı eklendi",
      genericError: "Bir hata oluştu",
      passwordTooShort: "Şifre en az 4 karakter olmalıdır",
      roles: {
        owner: "Sahip",
        admin: "Yönetici",
        user: "Kullanıcı",
        cashier: "Kasiyer",
      },
      perms: {
        products: "Ürünler",
        clients: "Müşteriler",
        suppliers: "Tedarikçiler",
        sales: "Satışlar",
        purchases: "Satın alma",
        reports: "Raporlar",
      },
    },
    currencies: {
      baseTitle: "Temel para birimi",
      baseSubtitle: "Tüm fiyatlar bu para biriminde gösterilir",
      change: "Değiştir",
      baseTag: "Temel",
      basePickTitle: "Temel para birimini seçin",
      basePickHint: "Seçtiğiniz ilk para birimi temel olur",
      addTitle: "Ek para birimleri",
      addSubtitle: "Kur temel para birimine göre gösterilir",
      add: "Ekle",
      empty: "Henüz ek para birimi eklenmedi",
      pickBaseModal: "Temel para birimini seçin",
      pickAddModal: "Bir para birimi seçin",
      searchPlaceholder: "Ara (USD, dolar...)",
      notFound: "Bulunamadı",
      rateModalTitle: "Kur —",
      editRateModalTitle: "Kuru düzenle —",
      editRateTooltip: "Kuru düzenle",
      bankRate: "Banka kuru:",
      useBankRate: "Banka kuru",
      bankRateHint: "Açıkken kur Merkez Bankası'ndan (CBU) alınır ve kaydederken yenilenir.",
      bankRateOn: "Banka kuru kullanılıyor",
      bankSource: "Merkez Bankası kuru, tarih:",
      bankError: "Banka kuru alınamadı (manuel girebilirsiniz).",
      ratePlaceholder: "ör. 12700",
      rateHint: "1 {code} kaç {base} eder, girin",
      cancel: "İptal",
      save: "Kaydet",
      saving: "Kaydediliyor...",
      addBtn: "Ekle",
      rateInvalid: "Geçerli bir kur girin",
      baseFirst: "Önce temel para birimini seçin",
      saved: "Para birimi ayarları kaydedildi",
      error: "Bir hata oluştu",
      names: {
        UZS: "Özbek somu",
        USD: "ABD doları",
        EUR: "Euro",
        RUB: "Rus rublesi",
        KZT: "Kazak tengesi",
        GBP: "İngiliz sterlini",
        JPY: "Japon yeni",
        CNY: "Çin yuanı",
        TRY: "Türk lirası",
        AED: "BAE dirhemi",
        KGS: "Kırgız somu",
        TJS: "Tacik somonisi",
        TMT: "Türkmen manatı",
        AZN: "Azerbaycan manatı",
        GEL: "Gürcü larisi",
        UAH: "Ukrayna grivnası",
        BYN: "Belarus rublesi",
        SAR: "Suudi riyali",
        CAD: "Kanada doları",
        AUD: "Avustralya doları",
        CHF: "İsviçre frangı",
        INR: "Hindistan rupisi",
        KRW: "Güney Kore wonu",
        SEK: "İsveç kronu",
        NOK: "Norveç kronu",
        DKK: "Danimarka kronu",
        PLN: "Polonya zlotisi",
        CZK: "Çek korunası",
        HUF: "Macar forinti",
        RON: "Romen leyi",
      },
    },
    general: {
      saved: "Kaydedildi",
      error: "Hata",
      soonBadge: "(yakında)",
      businessTitle: "İşletme türü",
      businessSubtitle: "Kurumunuzun ihtiyaç duyduğu modülleri seçin — kenar çubuğu buna göre kısaltılır",
      businessNote: "Mod yalnızca arayüzü etkiler — veriler her zaman korunur. Bir modülü yeniden göstermek için «Tümü»nü seçin.",
      skladTitle: "Depo",
      skladSubtitle: "Satış ve stok ayarları",
      jobFoldersSectionTitle: "Siparişler — klasörler",
      jobFoldersTitle: "Klasörleri göster",
      jobFoldersHint: "Siparişler modülünde klasör düzenini (klasör ağacı) açar. Varsayılan olarak kapalı.",
      paymentsTitle: "Ödemeler",
      paymentsSubtitle: "Gelen/giden ödeme belgeleri ayarları.",
      paymentStatusesTitle: "Ödeme durumları",
      paymentStatusesHint: "Açıkken gelen ve giden ödemelerde durum alanı görünür — durumlar eklenip kaldırılabilir. Kapalıyken durum alanı gizlenir.",
      purchasesTitle: "Satın alma",
      purchasesSubtitle: "Kenar çubuğundaki «Satın alma» bölümünde hangi alt menünün görüneceğini seçin",
      purchaseReturnsTitle: "Alış iadeleri",
      salesTitle: "Satış bölümleri",
      salesSubtitle: "Satış menüsünde hangi alt bölümlerin görüneceğini seçin.",
      salesOrders: "Siparişler",
      salesInvoices: "Satışlar (faturalar)",
      salesReturns: "İadeler",
      salesSectionsHint: "Kapalı bölüm kenar çubuğunda gizlenir. Hepsi kapalıysa Satış grubu gösterilmez.",
      salesProductFolder: "Ürün klasörü",
      salesProductFolderHint: "Satış formunda yalnızca bu klasördeki (ve alt klasörlerdeki) ürünler gösterilir. Boş = tümü.",
      purchaseReturnsHint: "Açıkken Satın alma bölümünde «İadeler» görünür. Kapalıyken gizlenir.",
      discountFieldTitle: "İndirim alanı",
      discountFieldHint: "Açıkken alış girişlerinde ve satış faturalarında indirim (%) sütunu görünür. Varsayılan olarak kapalı.",
      purchaseDefaultWarehouse: "Varsayılan depo",
      purchaseDefaultWarehouseHint: "Alış girişi oluştururken otomatik seçilen depo. Boş = ayarlanmadı.",
      productionDefaultWarehouses: "Varsayılan depolar",
      productionDefaultWarehousesHint: "Üretim emri oluştururken otomatik seçilen depolar.",
      productionDefaultRawWarehouse: "Hammadde deposu",
      productionDefaultFinishedWarehouse: "Mamul deposu",
      jobProcLaborTitle: "Süreç işçilik maliyeti",
      jobProcLaborHint: "Sipariş süreçlerinde işçilik maliyeti alanını gösterir. Kapalıyken gizlenir.",
      jobProcAllocatedTitle: "Süreç ayrılan tutarı",
      jobProcAllocatedHint: "Sipariş süreçlerinde ayrılan tutar alanını gösterir. Kapalıyken gizlenir.",
      sketchRequiredTitle: "Eskiz zorunlu",
      sketchRequiredHint: "Açıkken sipariş oluştururken eskiz (görsel/PDF) yüklemek zorunludur. Kapalıyken (varsayılan) isteğe bağlıdır.",
      sketchInListTitle: "Sipariş listesinde eskiz",
      sketchInListHint: "Açıkken 1. görsel (eskiz) sipariş listesinde (#'den sonra) görünür — tam boyut için büyütece tıklayın. Görsel yoksa boş kare. Varsayılan olarak kapalı.",
      costWarnTitle: "Maliyet uyarı yüzdesi",
      costWarnHint: "Bir siparişin maliyeti anlaşılan fiyatın bu yüzdesini aşarsa listede kırmızı uyarı görünür (devam eden ve tamamlanan siparişler için). Ör. %50 — maliyet fiyatın yarısını aştı. Varsayılan %50.",
      ndsTitle: "Vergi (KDV)",
      ndsSubtitle: "Kurum KDV mükellefiyse açın — satış faturalarında KDV sütunları görünür.",
      hasNdsTitle: "KDV mükellefi kurum",
      hasNdsHint: "Açıkken satış faturalarında MKIX kodu, KDV oranı, KDV tutarı ve Toplam (KDV dahil) sütunları görünür.",
      negCashboxTitle: "Eksi kasa bakiyesine izin ver",
      negCashboxHint: "Açıkken gider kasa bakiyesini aşabilir ve eksiye düşebilir. Kapalıyken (varsayılan) bakiyenin üzerindeki giderler engellenir.",
      cashierTitle: "Kasiyer",
      cashierSubtitle: "Kasiyer türündeki çalışanlara hangi kasaların görüneceği.",
      cashierNoCashboxes: "Kasa yok.",
      cashierHint: "Kasiyere yalnızca işaretlenen kasalar görünür. Hiçbiri işaretlenmezse — hiçbiri.",
      cashierCpTitle: "Kasiyer — cari hesap klasörleri",
      cashierCpSubtitle: "Kasiyere girişte hangi klasörlerin cari hesapları görünür.",
      cashierNoFolders: "Klasör yok.",
      cashierCpHint: "Kasiyere yalnızca işaretlenen klasörlerdeki cari hesaplar görünür. Hiçbiri işaretlenmezse — hiçbiri.",
      snabjenistCpTitle: "Satın alma sorumlusu — tedarikçi klasörleri",
      snabjenistCpSubtitle: "Satın alma sorumlusuna tedarikçileri görüntülerken hangi klasörlerin görüneceği.",
      snabjenistCpHint: "Satın alma sorumlusuna yalnızca işaretlenen klasörlerdeki cari hesaplar görünür. Hiçbiri işaretlenmezse — tümü gösterilir.",
      catCpTitle: "Kategori — cari hesap klasörü",
      catCpSubtitle: "Ödemede bir kategori seçildiğinde cari hesap listesi bu klasöre göre filtrelenir.",
      catCpEmpty: "Kategori yok.",
      catCpHint: "«Cari hesap yok» olarak ayarlanan kategori için (ör. Market) cari hesap sorulmaz.",
      catCpAll: "Tüm cari hesaplar",
      catCpNone: "Cari hesap yok",
      catCpIncoming: "gelir",
      catCpOutgoing: "gider",
      negStockTitle: "Eksi stoka izin ver",
      negStockHint: "Açıksa stokta olmayan malı satabilirsiniz (bakiye eksiye düşer). Kapalıysa yeterli stok yokken satış faturası engellenir.",
      servSellTitle: "Hizmet sat",
      servSellHint: "Açıksa stokta «+ Hizmet» butonu ve «Hizmet» filtresi görünür — hizmet türünde kalem ekleyip satabilirsiniz. Kapalıysa yalnızca ürünler işlenir.",
      purchasesNote: "Mod yalnızca arayüzü etkiler — mevcut veriler korunur.",
      costingTitle: "Maliyet muhasebesi (COGS)",
      costingSubtitle: "Kâr ve stok değerinin hangi yöntemle hesaplanacağı",
      costingNote: "Not: maliyet satış anında «dondurulur» — yöntemi değiştirmek mevcut belgelerin kârını değiştirmez.",
      cpSectionTitle: "Cari hesaplar",
      cpStatusTitle: "Cari hesap durumu",
      cpStatusHint: "Cari hesaplar için durum alanını açar. Kapalıyken durum sütunu/filtresi/alanı gizlenir.",
      cpFolderTitle: "Cari hesap filtresi",
      cpFolderSubtitle: "Formlarda cari hesapları klasöre göre filtrele",
      cpFolderAll: "Tümü (filtre yok)",
      cpSupplierFolder: "Satın alma / Tedarik klasörü",
      cpSupplierFolderHint: "Satın alma ve tedarik formlarında yalnızca bu klasördeki tedarikçiler gösterilir",
      cpCustomerFolder: "Satış / Sipariş klasörü",
      cpCustomerFolderHint: "Satış ve sipariş formlarında yalnızca bu klasördeki müşteriler gösterilir",
      cpFolderNone: "Klasör yok",
      cpJobOrderNewCustomerFolder: "Siparişlerdeki yeni müşteriler için klasör",
      cpJobOrderNewCustomerFolderHint: "Sipariş formundan eklenen yeni müşteri bu klasöre gider",
      prodFolderTitle: "Üretim — ürün klasörleri",
      prodFolderSubtitle: "Üretim formunda hammadde ve mamul seçicileri bu klasörlere (alt klasörler dahil) göre filtrelenir.",
      prodRawFolder: "Hammadde klasörü",
      prodRawFolderHint: "Üretim bileşenlerinde (hammaddeler) yalnızca bu klasördeki ürünler gösterilir. Boş = tümü.",
      prodFinishedFolder: "Mamul klasörü",
      prodFinishedFolderHint: "Üretim çıktılarında (mamuller) yalnızca bu klasördeki ürünler gösterilir. Boş = tümü.",
      prodOutputBatchTitle: "Mamul partisi ve son kullanma tarihi",
      prodOutputBatchHint: "Açıkken üretimde mamuller için parti numarası ve son kullanma alanları görünür. Varsayılan olarak kapalı.",
      navOrderTitle: "Kenar çubuğu sırası",
      navOrderSubtitle: "Kenar çubuğundaki bölümlerin sırasını ayarlayın.",
      navOrderReset: "Varsayılana sıfırla",
      costing: {
        average: {
          label: "Ağırlıklı ortalama (AVCO)",
          hint: "Ortalama maliyet girişlerden otomatik hesaplanır",
        },
        manual: {
          label: "Manuel (ürün maliyeti)",
          hint: "Ürüne manuel girilen maliyeti kullanır",
        },
        fifo: {
          label: "FIFO (ilk giren ilk çıkar)",
          hint: "Katmanlı maliyet: önce en eski parti satılır",
        },
        batch: {
          label: "Partiye göre (lot)",
          hint: "Satışta son kullanma tarihli parti seçilir",
        },
      },
      business: {
        retail: {
          label: "Mağaza (satış)",
          hint: "Perakende mağaza — malı depoda tutar ve müşterilere satar. Siparişler ve Üretim modülleri gizlenir.",
        },
        "job-order": {
          label: "Atölye (siparişler)",
          hint: "Müşteri siparişine göre çalışır — mamuller stoklanmaz, doğrudan müşteriye teslim edilir. Satış ve Üretim modülleri gizlenir.",
        },
        production: {
          label: "Üretim",
          hint: "Hammaddeden mamul üretir ve satar. Üretim bölümü gösterilir, Siparişler modülü gizlenir.",
        },
        all: {
          label: "Tümü (karma)",
          hint: "Satış, Siparişler ve Üretim — hepsi görünür. En esnek seçenek.",
        },
      },
      procurement: {
        orders: {
          label: "Siparişler",
          hint: "Tedarikçiye doğrudan satın alma siparişi (PO) — basit iş akışı.",
        },
        procurement: {
          label: "Tedarik",
          hint: "İç tedarik süreci: talep edenin talebi → depo girişi. Büyük ekipler için.",
        },
        both: {
          label: "İkisi de",
          hint: "Siparişler ve Tedarik — iki alt menü de görünür.",
        },
        none: {
          label: "Yalnızca girişler",
          hint: "Siparişleri ve Tedariki gizler — yalnızca Girişler (ve İadeler).",
        },
      },
    },
  },
  settingsExtra: {
    uom: {
      customTitle: "Ölçü birimlerim",
      customSubtitle: "Sizin eklediğiniz, silinebilir",
      add: "Ekle",
      customEmpty: "Henüz özel biriminiz yok",
      thShort: "Kısa",
      thFull: "Tam ad",
      deleteTitle: "Sil",
      systemTitle: "Sistem ölçü birimleri",
      systemSubtitle: "Tüm kurumlarda ortak, silinemez",
      systemBadge: "Sistem",
      thVisible: "Görünür",
      visibleHint: "İşaretliyse sistem genelinde (formlar ve listeler) gösterilir",
      addDisabled: "Şimdilik kapalı",
      newUnit: "Yeni ölçü birimi",
      shortName: "Kısa ad",
      shortNamePlaceholder: "ör. kg, adet, m²",
      shortNameHint: "Ürün kartında gösterilen kısa etiket",
      fullName: "Tam ad",
      fullNamePlaceholder: "ör. Kilogram, Adet, Metrekare",
      cancel: "İptal",
      saving: "Kaydediliyor...",
      addBtn: "Ekle",
      added: "Ölçü birimi eklendi",
      deleted: "Ölçü birimi silindi",
      loadError: "Ölçü birimleri yüklenemedi",
      error: "Bir hata oluştu",
      groups: {
        count: "Adet",
        weight: "Ağırlık",
        length: "Uzunluk",
        areaVol: "Alan ve hacim",
        liquid: "Sıvı",
        packaging: "Ambalaj ve kaplar",
        time: "Zaman",
        service: "Hizmet",
        other: "Diğer",
      },
    },
    trash: {
      retentionLabel: "Saklama süresi",
      never: "Asla silme",
      neverMark: "Saklanır",
      retentionSaved: "Süre kaydedildi",
      subtitleNever: "kayıtlar asla otomatik silinmez. Geri yükleme ilgili verileri de (notlar, bağlantılar) geri getirir.",
      title: "Çöp kutusu",
      subtitlePrefix: "Silinen kayıtlar",
      subtitleSuffix: "bu kadar gün sonra kalıcı olarak silinir. Geri yükleme ilgili verileri de (notlar, bağlantılar) geri getirir.",
      searchPlaceholder: "Ad, telefon...",
      empty: "Çöp kutusu boş",
      thType: "Tür",
      thDetails: "Ayrıntılar",
      thName: "Ad",
      thDeletedBy: "Silen",
      allTypes: "Tüm türler",
      allUsers: "Tüm kullanıcılar",
      kinds: {
        Contact: "Kişi",
        Deal: "Anlaşma",
        Task: "Görev",
        Funnel: "Huni",
      },
      thDate: "Tarih",
      thLeft: "Kalan",
      daysSuffix: "gün",
      restoreTitle: "Geri yükle",
      permDeleteTitle: "Kalıcı olarak sil",
      modalTitle: "Kalıcı olarak sil",
      confirmSuffix: "— kalıcı olarak silinsin mi? Bu geri alınamaz — kayıt ve ekli dosyalar kaldırılır. Huni için anlaşmaları da kaldırılır.",
      cancel: "İptal",
      deleting: "Siliniyor...",
      permDeleteBtn: "Kalıcı olarak sil",
      restored: "Geri yüklendi",
      restoreError: "Geri yükleme başarısız",
      permDeleted: "Kalıcı olarak silindi",
      deleteError: "Silme başarısız",
      loadError: "Yüklenemedi",
    },
    audit: {
      title: "Denetim günlüğü",
      subtitle: "Kim, ne zaman, ne yaptı",
      empty: "Kayıt yok",
      thTime: "Zaman",
      thUser: "Kullanıcı",
      thAction: "İşlem",
      thBranch: "Departman",
      thObject: "Nesne",
      thIp: "IP",
      view: "Görüntüle",
      detailTitle: "Kayıt ayrıntıları",
      fResource: "Departman / kaynak",
      fId: "Nesne ID",
      fMethod: "Yöntem",
      fPath: "Yol",
      fStatus: "Durum",
      allUsers: "Tüm kullanıcılar",
      dateFrom: "Başlangıç",
      dateTo: "Bitiş",
      thModule: "Modül",
      modules: {
        trash: "Çöp kutusu",
        organization: "Ayarlar",
        uom: "Birimler",
        inventory: "Ürünler",
        counterparty: "Cari hesaplar",
        warehouse: "Depolar",
        purchases: "Satın alma",
        sales: "Satışlar",
        payments: "Ödemeler",
        "payment-requests": "Ödeme talepleri",
        integrations: "Entegrasyonlar",
        cashbox: "Kasalar",
        conversions: "Döviz çevirme",
        transfers: "Transferler",
        reports: "Raporlar",
        upload: "Dosyalar",
        export: "Dışa aktarma",
        production: "Üretim",
        departments: "Departmanlar",
        branches: "Şubeler",
        "job-orders": "Siparişler",
        proposals: "Teklifler",
        "job-order-folders": "Sipariş klasörleri",
        contracts: "Sözleşmeler",
        "akt-sverka": "Mutabakat tutanağı",
        procurement: "Tedarik",
        contacts: "Kişiler",
        funnels: "Huniler",
        tasks: "Görevler",
        "lead-forms": "Potansiyel müşteri formları",
        inbox: "Gelen kutusu",
        instagram: "Instagram",
        facebook: "Facebook",
        whatsapp: "WhatsApp",
        atc: "IP telefon",
        "lead-journey": "Müşteri yolculuğu",
        email: "Email",
        push: "Push bildirimleri",
        reviews: "Yorumlar",
        yandex: "Yandex",
        "organization-users": "Kullanıcılar",
        "organization-roles": "Roller",
        "organization-currencies": "Para birimi ayarları",
        "organization-settings": "Genel ayarlar",
        "organization-contact-fields": "Kişi alanları",
        "organization-deal-fields": "Anlaşma alanları",
        "organization-task-stages": "Görev aşamaları",
        "organization-deal-sources": "Anlaşma kaynakları",
        "organization-close-reasons": "Kapanış nedenleri",
        "organization-goals": "Hedefler",
        "organization-sticker-packs": "Çıkartma paketleri",
        "organization-telegram-bot": "Telegram botu",
        "organization-telegram-accounts": "Telegram hesabı",
        "funnels-deals": "Anlaşmalar",
        "funnels-deal-activities": "Anlaşma yorumları",
        "funnels-deal-files": "Anlaşma dosyaları",
        "call-analysis": "Yapay zekâ ile arama analizi",
        "contacts-activities": "Kişi yorumları",
      },
      actions: {
        create: "Oluşturuldu",
        update: "Güncellendi",
        delete: "Silindi",
        login: "Giriş yaptı",
        logout: "Çıkış yaptı",
        register: "Kayıt oldu",
        password_change: "Şifre değiştirdi",
        profile_update: "Profili güncelledi",
        view: "Görüntüledi",
      },
      loadError: "Yüklenemedi",
    },
    company: {
      subBranches: "Şubeler",
      subDepartments: "Departmanlar",
      branches: {
        title: "Şubeler",
        subtitle: "Kurum şubeleri — departmanlar bu şubelere bağlanabilir",
        add: "Ekle",
        empty: "Şube yok",
        thName: "Ad",
        thActions: "İşlemler",
        newBranch: "Yeni şube",
        editBranch: "Şubeyi düzenle",
        name: "Ad",
        namePlaceholder: "Merkez ofis, Çilonzor şubesi...",
        nameRequired: "Ad zorunludur",
        cancel: "İptal",
        save: "Kaydet",
        deleteTitle: "Şubeyi sil",
        deleteSuffix: "— bu şube silinsin mi? Bu şubedeki departmanların şube bağlantısı kaldırılır (departmanlar korunur).",
        deleteBtn: "Sil",
        added: "Eklendi",
        updated: "Güncellendi",
        deleted: "Silindi",
        loadError: "Yüklenemedi",
        error: "Hata",
      },
      departments: {
        title: "Departmanlar (üretim süreçleri)",
        subtitle: "Sipariş içindeki süreçler bu departmanlardan seçilir (kesim, yapıştırma, boyama...)",
        add: "Ekle",
        empty: "Departman yok",
        thName: "Ad",
        thBranch: "Şube",
        thActions: "İşlemler",
        newDept: "Yeni departman",
        editDept: "Departmanı düzenle",
        name: "Ad",
        namePlaceholder: "Kesim, Boyama...",
        branch: "Şube",
        branchNone: "— Seçilmedi —",
        thType: "Tür",
        type: "Departman türü",
        typeProcess: "Süreç (iş akışı)",
        typeManagement: "Yönetim",
        typeHint: "Sipariş süreci eklerken yalnızca «süreç» departmanları gösterilir (yönetim değil).",
        cancel: "İptal",
        save: "Kaydet",
        deleteTitle: "Departmanı sil",
        deleteSuffix: "— bu departman silinsin mi? Kullanıcılardaki ilgili bağlantı kaldırılır (kullanıcılar korunur).",
        deleteBtn: "Sil",
        added: "Departman eklendi",
        updated: "Güncellendi",
        deleted: "Silindi",
        loadError: "Yüklenemedi",
        error: "Hata",
      },
    },
  },
  units: {
    billion: "Mr",
    million: "Mn",
    thousand: "B",
  },
  analytics: {
    title: "Analitik",
    subtitle: "Satış, arama, kişi ve kanal istatistiklerinin tamamı tek yerde",
    tabs: {
      director: "Yönetici",
      sales: "Satışlar",
      calls: "Aramalar",
      funnels: "Huniler",
      journey: "Müşteri yolculuğu",
      quality: "Arama kalitesi",
      contacts: "Kişiler",
      inbox: "Gelen kutusu",
      reviews: "Yorumlar",
    },
    period: {
      "7d": "7 gün",
      "30d": "30 gün",
      "90d": "90 gün",
      month: "Bu ay",
      custom: "Özel",
    },
    director: {
      reportFor: "Rapor kapsamı",
      allStaff: "Tüm çalışanlar",
      staffN: "Çalışanlar: {n}",
      period: {
        today: "Bugün",
        yesterday: "Dün",
        thisWeek: "Bu hafta",
        lastWeek: "Geçen hafta",
        thisMonth: "Bu ay",
        lastMonth: "Geçen ay",
        quarter: "Bu çeyrek",
        year: "Bu yıl",
        custom: "Özel aralık",
      },
      sum: {
        dealsInWork: "Devam eden anlaşmalar",
        notes: "Eklenen notlar",
        tasksInWork: "Devam eden görevler",
        purchases: "Başarılı anlaşmalar (satın alma toplamı)",
      },
      deals: {
        title: "Anlaşmalar",
        inWork: "Devam ediyor",
        new: "Yeni",
        lost: "Kaybedilen",
        won: "Başarılı",
        note: "«Devam ediyor» — şu anda açık anlaşmalar. «Yeni» — dönemde oluşturulanlar. «Kaybedilen» ve «Başarılı» — dönemde kapananlar. Yüzde, başarılı anlaşmaların tüm anlaşmalar içindeki payıdır.",
      },
      contacts: {
        title: "Kişiler",
        total: "Toplam",
        new: "Dönemde yeni",
      },
      events: {
        title: "Olaylar",
        dealsCreated: "Oluşturulan anlaşmalar",
        contactsCreated: "Oluşturulan kişiler",
        stageChanges: "Aşama değişiklikleri",
        tasksCompleted: "Tamamlanan görevler",
        withResult: "sonuçlu: {n}",
        notes: "Eklenen notlar",
        files: "Eklenen dosyalar",
        callsIn: "Gelen aramalar",
        callsOut: "Giden aramalar",
      },
      tasks: {
        title: "Görevler",
        type: {
          call: "İletişim",
          meeting: "Toplantı",
          other: "Diğer",
        },
        new: "Yeni",
        overdue: "Gecikmiş",
        done: "Tamamlandı",
        completion: "Tamamlanma oranı",
        avgTime: "Ortalama tamamlanma süresi",
        hours: "sa",
        days: "g",
        dueToday: "Bugün bitecek",
        unassigned: "Atanmamış",
      },
      staff: {
        title: "Çalışanlar: genel tablo",
        employee: "Çalışan",
        dealsCreated: "Anlaşmalar",
        contactsCreated: "Kişiler",
        stageChanges: "Aşama değişiklikleri",
        notes: "Notlar",
        tasksCompleted: "Biten görevler",
        tasksOpen: "Açık görevler",
        tasksOverdue: "Gecikmiş",
        callsIn: "Gelen",
        callsOut: "Giden",
      },
    },
    loadError: "Veriler yüklenemedi",
    empty: "Seçilen dönem için veri yok",
    sales: {
      created: "Yeni anlaşmalar",
      won: "Kazanılan",
      lost: "Kaybedilen",
      conversion: "Dönüşüm",
      cycle: "Anlaşma döngüsü",
      days: "g",
      avgDeal: "Ortalama anlaşma {v}",
      activeNow: "Şu anda devam eden: {n}",
      dynamics: "Anlaşma dinamiği",
      lostReasons: "Kayıp nedenleri",
      noReason: "Neden belirtilmedi",
      byManager: "Yöneticiye göre",
      thManager: "Yönetici",
      thSum: "Satış tutarı",
      noManager: "Atanmamış",
      ownership: "Çalışanlara atanmış",
      ownLeads: "Aktif potansiyel müşteriler",
      ownLeadsShared: "bunlardan ortak",
      ownContacts: "Kişiler",
      ownContactsShared: "bunlardan ortak",
      ownershipNote: "Bir potansiyel müşterinin veya kişinin birden fazla sorumlusu varsa her biri için sayılır.",
      bySource: "Kaynaklar: gelen → kazanılan",
      noSource: "Kaynak yok",
      allFunnels: "Tüm hunilar",
      allManagers: "Tüm yöneticiler",
      pipeline: "Şu anki huni",
    },
    funnels: {
      view_intake: "Potansiyel müşteri girişi",
      view_staff: "Çalışana göre",
      noFunnels: "Henüz huni yok",
      total: "Toplam potansiyel müşteri",
      assigned: "Yöneticiye atanmış",
      notAssigned: "Atanmamış",
      assignRate: "Atanma oranı",
      noLeads: "Bu dönemde potansiyel müşteri yok",
      staffHint: "Her çalışanın bu hunide kaç potansiyel müşteri oluşturduğu ve mevcut durumları (diğer hunilere taşınanlar dahil).",
      thEmployee: "Çalışan",
      thTotal: "Toplam",
      thActive: "Aktif",
      thWon: "Kazanılan",
      thLost: "Kaybedilen",
    },
    reviews: {
      scans: "QR taramaları",
      clicks: "Yorum tıklamaları",
      conversion: "Dönüşüm",
      pending: "Yeni şikâyetler",
      newReviews: "Yeni harita yorumları",
    },
  },
  ui: {
    filters: "Filtreler",
    reset: "Sıfırla",
    done: "Tamam",
    more: "Daha fazla",
    clearAll: "Tümünü temizle",
    search: "Ara",
    sort: "Sırala",
    assignee: "Sorumlu",
    source: "Kaynak",
    created: "Oluşturulma tarihi",
    dateFrom: "Başlangıç",
    dateTo: "Bitiş",
    all: "Tümü",
    none: "Belirtilmedi",
    back: "Geri",
    cancel: "İptal",
    save: "Kaydet",
    delete: "Sil",
    selected: "Seçilen: {n}",
  },
  loc: {
    registerPage: {
      thisSlugIsTakenChoose: "Bu kısa ad alınmış. Başka birini seçin",
      takeYourBusiness: "İşletmenizi",
      digital: "dijitale taşıyın",
      warehouseSalesCustomersAndFinance: "Depo, satış, müşteriler ve finans — hepsi tek sistemde.",
      whatIsASlug: "Kısa ad nedir?",
      aSlugIsYourOrganization: "Kısa ad, kurumunuzun sistemdeki benzersiz tanımlayıcısıdır. Örneğin:",
      youWillUseThisSlug: ". Giriş yaparken bu kısa adı kullanacaksınız.",
      "2025CrmLineAllRights": "© 2025 CRM Line. Tüm hakları saklıdır.",
      createAnOrganization: "Kurum oluşturun",
      createAnAccountAndGet: "Hesap oluşturun ve hemen başlayın",
      organization: "Kurum",
      organizationName: "Kurum adı",
      eGBarakaSavdo: "Ör.: Baraka Savdo",
      organizationSlug: "Kurum kısa adı",
      uniqueIdInTheSystem: "(sistemdeki benzersiz ID)",
      thisSlugIsTakenChoose2: "Bu kısa ad alınmış. Başka bir ad seçin",
      thisSlugIsAvailable: "✓ Bu kısa ad uygun",
      forSignIn: "Giriş için:",
      organizationType: "Kurum türü",
      adminAccount: "Yönetici hesabı",
      yourName: "Adınız",
      firstLastName: "Ad Soyad",
      phone: "Telefon",
      forSignIn2: "(giriş için)",
      email: "Email",
      forPasswordRecovery: "(şifre kurtarma için)",
      password: "Şifre",
      confirm: "Onayla",
      loading: "Yükleniyor...",
      alreadyHaveAnAccount: "Zaten hesabınız var mı?",
      signIn: "Giriş yap",
    },
    callButton: {
      startingCall: "Arama başlatılıyor...",
      noExtensionIsAssignedTo: "Size dahili numara atanmamış. Yöneticinize başvurun.",
      pbx: "{title} (santral)",
      viaPbx: "Santral üzerinden",
      fromPersonalPhone: "Kişisel telefondan",
    },
    callRecordingPlayer: {
      download: "Kaydı indir",
      downloadFailed: "Kayıt indirilemedi",
      couldNotLoadTheCall: "Arama kaydı yüklenemedi",
      couldNotLoadTheRecording: "Kayıt yüklenemedi",
      speed: "Hız",
    },
    categoryProductPicker: {
      selected: "{size} seçildi",
      nothingSelected: "Hiçbir şey seçilmedi",
      done: "Tamam",
    },
    incomingCallModal: {
      incomingCall: "Gelen arama",
      outgoingCall: "Giden arama",
      crmContact: "CRM kişisi",
      assignee: "Sorumlu:",
      openContact: "Kişiyi aç",
      unknownNumber: "Bilinmeyen numara",
      notFoundInCrm: "CRM'de bulunamadı",
      extension: "Dahili:",
      close: "Kapat",
      contact: "Kişi",
    },
    lockScreen: {
      opened: "Açıldı",
      wrongPassword: "Yanlış şifre",
      signOutOfTheAccount: "Hesaptan tamamen çıkılsın mı?",
      user: "Kullanıcı",
      passwordToUnlockTheScreen: "Ekran kilidini açmak için şifre",
      password: "Şifre",
      unlock: "Kilidi aç",
      signInWithAnotherAccount: "Başka bir hesapla giriş yap",
    },
    accountPage: {
      saved: "Kaydedildi",
      somethingWentWrong: "Bir şeyler ters gitti",
      extension: "Dahili numara",
      notAssigned: "Atanmadı",
      yourPbxExtensionSipuniIbrat: "Santral dahili numaranız (Sipuni/ibrat.sip.uz) — yalnızca yönetici Ayarlar → Çalışanlar bölümünden atayabilir veya değiştirebilir.",
      thisNumberIsAlsoUsed: "Bu numara giriş için de kullanılır — yalnızca yönetici Ayarlar → Çalışanlar bölümünden değiştirebilir.",
      email: "Email",
      atLeast4Characters: "en az 4 karakter",
    },
    callsPage: {
      error: "Hata",
      linkCall: "Aramayı bağla",
      number: "Numara:",
      contact: "Kişi",
      searchForAContact: "Kişi ara...",
      remove: "Kaldır",
      deal: "Anlaşma",
      enterDealTitle: "Anlaşma başlığını girin...",
      cancel: "İptal",
      save: "Kaydet",
      failedToLoad: "Yüklenemedi",
      selected: "{size} seçildi",
      changeTheFilterOrSearch: "Filtreyi veya aramayı değiştirin",
      link: "Bağla",
      callBack: "Geri ara",
      delete: "Sil",
      previous: "Önceki",
      next: "Sonraki",
    },
    contactAnalyticsPage: {
      text: "{count} · {date}",
      newContactsInPeriod: "Dönemdeki yeni kişiler",
      totalContacts: "Toplam kişi",
      allTime: "Tüm zamanlar",
      newContactsPerDay: "Günlük yeni kişiler ({from} — {to})",
      byChannelViaInbox: "Kanala göre (Gelen kutusu üzerinden)",
      noData: "Veri yok",
      byOperator: "Operatöre göre",
      noPhoneNumbers: "Telefon numarası yok",
    },
    contactFormPage: {
      select: "— Seçin",
      notSaved: "Kaydedilmedi",
      chooseFile: "Dosya seç",
      call: "arama",
      outgoing: "Giden",
      incoming: "Gelen",
      ext: "· Dahili: {ext}",
      contactNotFound: "Kişi bulunamadı",
      nameIsRequired: "Ad zorunludur",
      contactAdded: "Kişi eklendi",
      saved: "Kaydedildi",
      somethingWentWrong: "Bir şeyler ters gitti",
      fileUploaded: "Dosya yüklendi",
      uploadFailed: "Yükleme başarısız",
      deleteTheFile: "Dosya silinsin mi?",
      fileDeleted: "Dosya silindi",
      deleteFailed: "Silme başarısız",
      blockRemoved: "Engel kaldırıldı",
      contactBlocked: "Kişi engellendi",
      contactDeleted: "Kişi silindi",
      phone: "Telefon",
      format998xxxxxxxxx: "Biçim: +998XXXXXXXXX",
      email: "Email",
      assignee: "Sorumlu",
      notAssigned: "Atanmadı",
      loading: "Yükleniyor...",
      uploadFile: "+ Dosya yükle",
      saveTheContactFirstTo: "Dosya yüklemek için önce kişiyi kaydedin",
      noFilesYet: "Henüz dosya yok",
      download: "İndir",
      sections: "Bölümler",
      main: "Ana",
      phoneEmailResponsiblePerson: "Telefon · E-posta · Sorumlu kişi",
      fields: "{length} alan",
      sectionName: "Bölüm adı...",
      addNewSection: "Yeni bölüm ekle",
      fields2: "Alanlar",
      noFieldsYet: "Henüz alan yok",
      fieldName: "Alan adı...",
      options: "Seçenekler",
      atLeast1: "(en az 1)",
      optionName: "Seçenek adı...",
      save: "Kaydet",
      cancel: "İptal",
      add: "Ekle",
      addField: "Alan ekle",
      shiftEnterNewLine: "Shift+Enter — yeni satır",
    },
    contactsPage: {
      deleteContact: "Kişiyi sil",
      thisActionCannotBeUndone: "Bu işlem geri alınamaz.",
      contactsWillBeDeleted: "kişi silinecek.",
      text: "{count}",
      willBeDeleted: "silinecek.",
      cancel: "İptal",
      delete: "Sil",
      onlyCsvFilesAreAccepted: "Yalnızca CSV dosyaları kabul edilir",
      importError: "İçe aktarma hatası",
      csvImport: "CSV içe aktarma",
      importComplete: "İçe aktarma tamamlandı!",
      contactsAdded: "kişi eklendi,",
      skippedExistingOrEmpty: "atlandı (mevcut veya boş).",
      text2: "{created}",
      text3: "{skipped}",
      close: "Kapat",
      csvFileFormat: "CSV dosya biçimi:",
      theFirstRowMustContain: "İlk satır sütun adlarını içermelidir.",
      dropTheCsvFileHere: "CSV dosyasını buraya bırakın",
      orClickToChoose: "veya seçmek için tıklayın",
      rows: "{v} — {length} satır",
      clear: "Temizle",
      more: "… daha fazla",
      rows2: "satır",
      import: "İçe aktar (",
      text4: ")",
      failedToLoad: "Yüklenemedi",
      merged: "Birleştirildi",
      error: "Hata",
      duplicateContacts: "Mükerrer kişiler",
      noDuplicates: "Mükerrer yok",
      allGood: "Her şey yolunda!",
      duplicateNumbers: "{count} mükerrer numara",
      merge: "Birleştir",
      created: "Oluşturuldu: {toLocaleDateString}",
      willBeSaved: "Kaydedilecek",
      failedToLoadContacts: "Kişiler yüklenemedi",
      convertAllContactPhoneNumbers: "Tüm kişi telefon numaraları +998XXXXXXXXX biçimine dönüştürülsün mü?",
      numbersNormalized: "{updated} numara düzenlendi",
      somethingWentWrong: "Bir şeyler ters gitti",
      csvDownloaded: "CSV indirildi",
    },
    dealDetailPage: {
      call: "arama",
      outgoing: "Giden",
      incoming: "Gelen",
      ext: "· Dahili: {ext}",
      select: "— Seçin",
      noOptions: "Seçenek yok",
      failedToLoad: "Yüklenemedi",
      titleIsRequired: "Başlık zorunludur",
      saved: "Kaydedildi",
      assignedToYou: "Size atandı",
      error: "Hata",
      deleted: "Silindi",
      archived: "Arşivlendi",
      restoredFromArchive: "Arşivden geri yüklendi",
      closedAsWon: "Kazanıldı olarak kapatıldı",
      closedAsLost: "Kaybedildi olarak kapatıldı",
      reopened: "Yeniden açıldı",
      fileUploaded: "Dosya yüklendi",
      uploadFailed: "Yükleme başarısız",
      newRequest: "Yeni anlaşma",
      newDeal: "Yeni anlaşma",
      request: "Lid",
      won: "Kazanıldı",
      lost: "Kaybedildi",
      reopen: "Yeniden aç",
      closeAsWon: "Kazanıldı olarak kapat",
      closeAsLost: "Kaybedildi olarak kapat",
      restoreFromArchive: "Arşivden geri yükle",
      archive: "Arşivle",
      reasonOptional: "Neden (isteğe bağlı)",
      whyWasItLost: "— neden kaybedildi?",
      noReasonSelected: "— Neden seçilmedi —",
      eGTheClientSigned: "Ör.: müşteri sözleşmeyi imzaladı",
      eGThePriceDid: "Ör.: fiyat uymadı",
      close: "Kapat",
      reasonComment: "Neden (yorum) *",
      whyIsItBeingArchived: "Neden arşivleniyor?",
      clientName: "Müşteri adı...",
      dealTitle: "Anlaşma başlığı...",
      source: "Kaynak",
      notSelected: "— Seçilmedi —",
      note: "Not",
      noNotes: "Not yok",
      notFound: "Bulunamadı",
      loading: "Yükleniyor...",
      contact: "Kişi",
      blocked: "Engellendi",
      phone: "Telefon",
      email: "Email",
      reminder: "Hatırlatıcı",
      overdue: "Gecikmiş",
      openContact: "Kişiyi aç",
      notSelected2: "— Seçilmedi",
      takeIt: "Üstlen",
      created: "Oluşturuldu",
      days: "gün",
      call2: "Ara",
      inOut: "Gelen/Giden",
      missedCalls: "Cevapsız aramalar",
      activityOverTheLast14: "Son 14 gündeki etkinlik",
      callHistory: "Arama geçmişi",
      noCallsYet: "Henüz arama yok",
      uploadFile: "+ Dosya yükle",
      saveFirstToUploadFiles: "Dosya yüklemek için önce kaydedin",
      noFilesYet: "Henüz dosya yok",
      download: "İndir",
      sections: "Bölümler",
      main: "Ana",
      stageAmountSourceContactAssignee: "Aşama · Tutar · Kaynak · Kişi · Sorumlu",
      fields: "{length} alan",
      sectionName: "Bölüm adı...",
      addNewSection: "Yeni bölüm ekle",
      fields2: "Alanlar",
      noFieldsYet: "Henüz alan yok",
      fieldName: "Alan adı...",
      options: "Seçenekler",
      atLeast1: "(en az 1)",
      optionName: "Seçenek adı...",
      save: "Kaydet",
      cancel: "İptal",
      add: "Ekle",
      addField: "Alan ekle",
      shiftEnterNewLine: "Shift+Enter — yeni satır",
    },
    forgotPasswordPage: {
      serverAndPhoneAreRequired: "Sunucu ve telefon zorunludur",
      error: "Hata",
      check: "Kontrol edin",
      ifSuchAUserExists: "Böyle bir kullanıcı varsa e-postaya şifre sıfırlama bağlantısı gönderildi. Bağlantı 1 saat geçerlidir.",
      backToSignIn: "Girişe dön",
      resetPassword: "Şifreyi sıfırla",
      enterYourServerAndPhone: "Sunucunuzu ve telefon numaranızı girin — sıfırlama bağlantısı e-postanıza gönderilecek.",
      server: "Şirket kodu",
      phone: "Telefon",
      sendLink: "Bağlantı gönder",
      sending: "Gönderiliyor...",
    },
    funnelPage: {
      age: "{days} g önce oluşturuldu",
      dealsLabel: "Anlaşmalar:",
      archive: "Arşiv",
      request: "Lid",
      d: "{days} g",
      takeIt: "Üstlen",
      reactivate: "Yeniden etkinleştir",
      deal: "anlaşma",
      empty: "Boş",
      selectEverythingInThisStage: "Bu aşamadaki her şeyi seç",
      quickAdd: "Hızlı ekle",
      request2: "Lidler:",
      source: "Kaynak",
      notSelected: "— Seçilmedi —",
      titleStageContactPhoneSource: "Başlık, Aşama, Kişi, Telefon, Kaynak, Tutar, Durum, Not",
      failedToLoad: "Yüklenemedi",
      restoredFromArchive: "Arşivden geri yüklendi",
      error: "Hata",
      deleted: "Silindi",
      archive2: "Arşiv",
      theArchiveIsEmpty: "Arşiv boş",
      openDeal: "Anlaşmayı aç",
      restore: "Geri yükle",
      closedAsWon: "Kazanıldı olarak kapatıldı",
      closedAsLost: "Kaybedildi olarak kapatıldı",
      assignedToYou: "Size atandı",
      reactivated: "Yeniden etkinleştirildi",
      leadAdded: "Lid eklendi",
      selected: "{size} seçildi",
      moveToStage: "Aşamaya taşı...",
      toAnotherFunnel: "Başka huniye",
      assign: "Ata...",
      unassign: "— Atamayı kaldır —",
      deletePermanently: "Kalıcı olarak silinsin mi?",
      no: "Hayır",
      yesDelete: "Evet, sil",
      delete: "Sil",
      close: "Kapat",
      thisFunnelHasNoStages: "Bu huninin aşaması yok",
      addStagesInSettingsFunnels: "Aşamaları Ayarlar → Huniler bölümünden ekleyin",
      won: "Kazanıldı",
      lost: "Kaybedildi",
      chooseAnAssignee: "Sorumlu seçin",
      dealsSelected: "{size} anlaşma seçildi",
      chooseAnEmployee: "Çalışan seçin...",
      cancel: "İptal",
      confirm: "Onayla",
      closeAsWon: "Kazanıldı olarak kapat",
      closeAsLost: "Kaybedildi olarak kapat",
      reasonOptional: "Neden (isteğe bağlı)",
      whyWasItLost: "— neden kaybedildi?",
      noReasonSelected: "— Neden seçilmedi —",
      eGTheClientSigned: "Ör.: müşteri sözleşmeyi imzaladı",
      eGThePriceDid: "Ör.: fiyat uymadı",
      responsibleEmployee: "Sorumlu çalışan",
      moveToAnotherFunnel: "Başka huniye taşı",
      selected2: "seçildi",
      leads: "{size} lid",
      willBeArchived: "arşivlenecek",
      leads2: "{length} lid",
      reasonComment: "Neden (yorum) *",
      whyIsItBeingArchived: "Neden arşivleniyor?",
    },
    inboxAnalyticsPage: {
      previousPeriod: "%{pct} (önceki dönem: {prevValue})",
      conversationsPerDay: "Günlük yazışmalar",
      days: "{length} gün",
      text: "{count} · {date}",
      inbox: "Gelen kutusu",
      totalConversations: "Toplam yazışma",
      unanswered: "Yanıtlanmamış",
      closed: "Kapatıldı",
      avgResponseTime: "Ort. yanıt süresi",
      comparePeriods: "Dönemleri karşılaştır",
      total: "Toplam",
      resolved: "Çözülen, %",
      conversationsPerDay2: "Günlük yazışmalar ({from} — {to})",
      byChannel: "Kanala göre",
      noData: "Veri yok",
      agents: "Temsilciler",
      labels: "Etiketler",
      noLabels: "Etiket yok",
      reportByEmployee: "Çalışana göre rapor",
      downloadCsv: "CSV indir",
      employee: "Çalışan",
      conversations: "Yazışmalar",
      closed2: "Kapatılan, %",
      avgReply: "Ort. yanıt",
      call: "Ara",
    },
    inboxPage: {
      anonymous: "Anonim",
      comment: "Yorum",
      loading: "Yükleniyor...",
      file: "Dosya",
      openFile: "Dosyayı aç",
      post: "Gönderi",
      instagramPost: "Instagram gönderisi",
      internalNote: "İç not",
      replyToThisComment: "Bu yoruma yanıt ver",
      failedToLoad: "Yüklenemedi",
      error: "Hata",
      chatClosed: "Sohbet kapatıldı",
      chatReopened: "Sohbet yeniden açıldı",
      failedToLoadData: "Veriler yüklenemedi",
      thisContactAlreadyExists: "Bu kişi zaten mevcut",
      contactCreated: "Kişi oluşturuldu",
      agentAssigned: "Temsilci atandı",
      agentRemoved: "Temsilci kaldırıldı",
      deleteThisChatAllMessages: "Bu sohbet silinsin mi? Tüm mesajlar da silinecek.",
      deleteFailed: "Silme başarısız",
      inbox: "Gelen kutusu",
      search: "Ara...",
      conversations: "{convTotal} yazışma",
      previous: "← Önceki",
      next: "Sonraki →",
      back: "Geri",
      searchMessages: "Mesajlarda ara",
      changeAgent: "Temsilciyi değiştir",
      chooseAnAgent: "Temsilci seçin",
      remove: "Kaldır",
      labels: "Etiketler",
      availableLabels: "Kullanılabilir etiketler",
      newLabel: "Yeni etiket...",
      reopenChat: "Sohbeti yeniden aç",
      contactInfo: "Kişi bilgileri",
      commentsUnderThePostClick: "Gönderi altındaki yorumlar · yanıtlamak istediğiniz yoruma tıklayın",
      pressTheButton: "butona basın",
      searchInMessages: "Mesajlarda ara...",
      results: "{length} sonuç",
      replyToTheSelectedComment: "Seçilen yoruma yanıt ver",
      replyToTheLatestComment: "Son yoruma yanıt ver",
      cancel: "İptal",
      addAStickerPackIn: "Ayarlardan çıkartma paketi ekleyin",
      sticker: "Çıkartma",
      sendFile: "Dosya gönder",
      status: "Durum",
      call: "Ara",
      phone: "Telefon",
      email: "Email",
      noPacks: "Paket yok",
      noStickersFound: "Çıkartma bulunamadı",
      selectAConversation: "Bir yazışma seçin",
      openAConversationFromThe: "Soldaki listeden bir yazışma açın",
    },
    resetPasswordPage: {
      passwordMustBeAtLeast: "Şifre en az 6 karakter olmalıdır",
      passwordsDoNotMatch: "Şifreler eşleşmiyor",
      passwordChangedYouCanSign: "Şifre değiştirildi. Artık giriş yapabilirsiniz.",
      error: "Hata",
      newPassword: "Yeni şifre",
      theLinkIsInvalidPlease: "Bağlantı geçersiz. Lütfen şifre sıfırlamayı yeniden başlatın.",
      tryAgain: "Tekrar dene",
      enterYourNewPassword: "Yeni şifrenizi girin.",
      confirmPassword: "Şifreyi onayla",
      changePassword: "Şifre değiştir",
      saving: "Kaydediliyor...",
    },
    reviewsPage: {
      uploadFailed: "Yükleme başarısız",
      failedToLoadReviews: "Yorumlar yüklenemedi",
      deleteThisPage: "Bu sayfa silinsin mi?",
      error: "Hata",
      newReviewsCollected: "{added} yeni yorum toplandı",
      noNewReviews: "Yeni yorum yok",
      collectionFailed: "Toplama başarısız",
      reviews: "Yorumlar",
      collectCustomerReviewsViaQr: "QR ile müşteri yorumları toplayın",
      newPage: "Yeni sayfa",
      scans: "Taramalar",
      reviewClicks: "Yorum tıklamaları",
      conversion: "Dönüşüm",
      newComplaints: "Yeni şikâyetler",
      googleReviews: "Google yorumları",
      edit: "Düzenle",
      delete: "Sil",
      totalReviews: "Toplam: {collectedTotal} yorum",
      collectNow: "Şimdi topla",
      noMapReviewsCollectedYet: "Henüz harita yorumu toplanmadı. Sayfada Google/Yandex bağlıysa yorumlar otomatik toplanır (birkaç saatte bir).",
      anonymous: "Anonim",
      loadMore: "Daha fazla yükle ({length}/{collectedTotal})",
      noInternalFeedbackYet: "Henüz iç geri bildirim yok",
      contact: "İletişim",
      complaint: "Şikâyet",
      reviewed: "İncelendi",
      saved: "Kaydedildi",
      saveFailed: "Kaydetme başarısız",
      testMessageSent: "Test mesajı gönderildi ✅",
      testWasNotSent: "Test gönderilmedi",
      telegramNotifications: "Telegram bildirimleri",
      newGoogleYandexReviewsAre: "Yeni Google/Yandex yorumları Telegram grubunuza/kanalınıza otomatik gönderilir.",
      notificationsEnabled: "Bildirimler açık",
      botToken: "Bot tokeni",
      savedEnterANewOne: "•••••• (kaydedildi — değiştirmek için yenisini girin)",
      createABotInBotfather: "@BotFather'da bot oluşturun ve tokenini girin.",
      chatId: "Chat ID",
      "1001234567890OrChannelName": "-1001234567890 veya @kanal_adi",
      addTheBotToThe: "Botu gruba ekleyin. Grubun chat_id'sini @getidsbot ile alabilirsiniz.",
      saving: "Kaydediliyor...",
      save: "Kaydet",
      test: "Test",
      noPagesYet: "Henüz sayfa yok",
      createYourFirstReviewPage: "İlk yorum sayfanızı oluşturun",
      failedToDownloadQr: "QR indirilemedi",
      downloadQr: "QR indir",
      printItAndPlaceIt: "Yazdırın ve masaya koyun",
      googlePlaceLinkedTheReview: "Google yeri bağlandı — yorum bağlantısı otomatik dolduruldu",
      linkingFailed: "Bağlama başarısız",
      updated: "Güncellendi",
      updateFailed: "Güncelleme başarısız",
      unlinkGoogle: "Google bağlantısı kaldırılsın mı?",
      unlinked: "Bağlantı kaldırıldı",
      googleReviews2: "Google yorumları — {name}",
      findYourBusinessOnGoogle: "İşletmenizi Google Haritalar'da bulun ve bağlayın — puan ve yorumlar burada görünecek.",
      eGCaffeBahorChilanzar: "Ör.: Caffe Bahor, Çilonzor Taşkent",
      nothingFoundRefineTheName: "Hiçbir şey bulunamadı — adı netleştirin",
      reviews2: "{toFixed} · {total} yorum",
      onTheMap: "Haritada",
      reviews3: "yorum",
      updated2: "Güncellendi: {syncedLabel}",
      inMin: "{cooldownMin} dk sonra",
      refresh: "Yenile",
      unlink: "Bağlantıyı kaldır",
      reviewTextNotFound: "Yorum metni bulunamadı",
      user: "Kullanıcı",
      googlePlacesApiReturnsOnly: "Google Places API yalnızca son ~5 yorumu döndürür.",
      googleApiKeyIsNot: "Google API anahtarı yapılandırılmamış",
      searchError: "Arama hatası",
      yandexApiKeyIsNot: "Yandex API anahtarı yapılandırılmamış",
      "2gisConnectedReviewsCollected": "2GIS bağlandı — yorumlar toplandı",
      "2gisConnectionError": "2GIS bağlantı hatası",
      "2gisDisconnected": "2GIS bağlantısı kesildi",
      enterAName: "Bir ad girin",
      editing: "Düzenleniyor",
      newReviewPage: "Yeni yorum sayfası",
      nameBranch: "Ad (şube)",
      chilanzarBranch: "Çilonzor şubesi",
      titleVisibleToTheCustomer: "Başlık (müşteriye görünür)",
      reviews4: "{toFixed}★ · {total} yorum",
      change: "Değiştir",
      googleReviewLinkFilledIn: "Google yorum bağlantısı otomatik dolduruldu",
      linkAGoogleMapsPlace: "Google Haritalar yeri bağlayın (URL otomatik doldurulur)",
      enterTheBusinessName: "İşletme adını girin...",
      notFoundRefineYourQuery: "Bulunamadı — sorgunuzu netleştirin",
      yandexReviewLinkFilledIn: "Yandex yorum bağlantısı otomatik dolduruldu",
      linkAYandexMapsPlace: "Yandex Haritalar yeri bağlayın (URL otomatik doldurulur)",
      "2gisBranch": "2GIS şubesi",
      review: "yorum",
      toLink2gisSaveThe: "2GIS'i bağlamak için önce sayfayı kaydedin, sonra yeniden açın.",
      "2gisLink2gisUzTashkent": "2GIS bağlantısı: 2gis.uz/tashkent/firm/70000...",
      link: "Bağla",
      platformsAndLinks: "Platformlar ve bağlantılar",
      filledInAutomaticallyWhenA: "Google yeri bağlandığında otomatik doldurulur",
      reviewLinkUrl: "Yorum bağlantısı (URL)",
      smartRoutingGating: "Akıllı yönlendirme (gating)",
      highRatingMapLowRating: "Yüksek puan → harita; düşük puan → iç geri bildirim",
      publishingThreshold: "Yayın eşiği:",
      "4AndAbove": "4★ ve üzeri",
      "5Only": "Yalnızca 5★",
      "3AndAbove": "3★ ve üzeri",
      googleProhibitsReviewGatingTurn: "⚠️ Google «review gating»i yasaklar — gerekmiyorsa kapatın.",
      cancel: "İptal",
    },
    settingsPage: {
      main: "Ana",
      contactDetails: "İletişim bilgileri",
      appearance: "Görünüm",
      baseCurrency: "Temel para birimi",
      allDealsAndLeadsAre: "Tüm anlaşmalar ve potansiyel müşteriler bu para biriminde gösterilir.",
      directorSFullName: "Müdürün adı soyadı",
      eGAliyevJasurAkhmadovich: "Ör.: Aliyev Jasur Ahmadoviç",
      officeNumber: "Ofis numarası",
      address: "Adres",
      eGTashkentChilanzarDistrict: "Ör.: Taşkent, Çilonzor ilçesi, 12",
      website: "Web sitesi",
      usernameOrFullLink: "@kullanıcı_adı veya tam bağlantı",
      usernameOr998: "@kullanıcı_adı veya +998...",
      funnelNameIsRequired: "Huni adı zorunludur",
      saved: "Kaydedildi",
      funnelCreated: "Huni oluşturuldu",
      error: "Hata",
      deleted: "Silindi",
      funnels: "Huniler",
      configureDealAndLeadStages: "Anlaşma ve potansiyel müşteri aşamalarını ayarlayın",
      newFunnel: "Yeni huni",
      noFunnelsYet: "Henüz huni yok",
      createANewFunnelAnd: "Yeni bir huni oluşturun ve aşamalar ekleyin",
      noStages: "Aşama yok",
      editFunnel: "Huniyi düzenle",
      funnelName: "Huni adı",
      eGMainSalesB2b: "Ör.: Ana satış, B2B, Premium...",
      stages: "Aşamalar",
      add: "Ekle",
      color: "Renk",
      aDealReachingThisStage: "Bu aşamaya ulaşan anlaşma otomatik olarak Kazanıldı (satış) olarak işaretlenir",
      won: "Kazanıldı",
      aDealReachingThisStage2: "Bu aşamaya ulaşan anlaşma otomatik olarak Kaybedildi olarak işaretlenir",
      lost: "Kaybedildi",
      choosingAnAssigneeIsRequired: "Bu aşamaya taşırken sorumlu seçmek zorunludur (ör. resepsiyondan yöneticiye devir)",
      assigneeRequired: "Sorumlu zorunlu",
      staysInThisFunnel: "Bu hunide kalır",
      moveTo: "«{name}» hunisine taşı",
      chooseAStage: "Bir aşama seçin",
      whichRolesCanSeeIt: "Hangi roller görebilir",
      ifNoneIsSelectedVisible: "Hiçbiri seçilmezse herkes görür (varsayılan).",
      noCustomRolesCreated: "Özel rol oluşturulmadı",
      cancel: "İptal",
      save: "Kaydet",
      create: "Oluştur",
      failedToLoad: "Yüklenemedi",
      taskStages: "Görev aşamaları",
      configureTheKanbanColumnsTasks: "Kanban sütunlarını ayarlayın. «Tamamlandı» olarak işaretlenen aşamadaki görevler tamamlanmış sayılır.",
      done: "Tamamlandı:",
      notCompleted: "Tamamlanmadı:",
      doneStage: "«Tamamlandı» aşaması",
      done2: "Tamamlandı",
      addStage: "Aşama ekle",
      salesSources: "Satış kaynakları",
      sourcesThatCanBeChosen: "Satış eklerken seçilebilecek kaynaklar",
      addSource: "Kaynak ekle",
      addReason: "Neden ekle",
      closingReasons: "Kapanış nedenleri",
      whenADealIsClosed: "Bir anlaşma Kazanıldı veya Kaybedildi olarak kapatıldığında çalışan bu listeden bir neden seçer — serbest metin yerine, böylece istatistikler tutarlı değerler kullanır.",
      whenWon: "Kazanıldığında",
      whenLost: "Kaybedildiğinde",
      formNameIsRequired: "Form adı zorunludur",
      selectAFunnel: "Bir huni seçin",
      selectAStage: "Bir aşama seçin",
      formUpdated: "Form güncellendi",
      formCreated: "Form oluşturuldu",
      somethingWentWrong: "Bir şeyler ters gitti",
      editForm: "Formu düzenle",
      newForm: "Yeni form",
      formName: "Form adı",
      eGWebsiteContactForm: "Ör.: Web sitesi iletişim formu",
      funnel: "Huni",
      stage: "Aşama",
      titleOnTheFormPage: "Başlık (form sayfasında)",
      additionalDescription: "Ek açıklama",
      optional: "İsteğe bağlı...",
      formColor: "Form rengi",
      organizationBrandColor: "Kurum marka rengi",
      customColor: "Özel renk",
      everyFormAlways: "Her form her zaman",
      and: "ve",
      fieldsRequired: "alanlarını içerir (zorunlu).",
      name: "Ad",
      phone: "Telefon",
      extraQuestions: "Ek sorular",
      required: "Zorunlu",
      noExtraQuestionsYet: "Henüz ek soru yok",
      questionText: "Soru metni...",
      options: "Seçenekler",
      atLeast1: "(en az 1)",
      optionName: "Seçenek adı...",
      addQuestion: "Soru ekle",
      uploadFailed: "Yükleme başarısız",
      linkCopied: "Bağlantı kopyalandı",
      couldNotCopy: "Kopyalanamadı",
      formDeleted: "Form silindi",
      leadForms: "Potansiyel müşteri formları",
      placeOnYourWebsiteOr: "Web sitenize veya sosyal medyanıza yerleştirin — gönderilen talepler seçilen huniye gider.",
      firstCreateAFunnelIn: "Önce «Huniler» bölümünde bir huni oluşturun.",
      inactive: "Pasif",
      requests: "talep",
      delete: "Sil",
      enable: "Etkinleştir",
      noFormsYet: "Henüz form yok",
      deleteForm: "Formu sil",
      willBeDeletedTheLink: "silinecek. Bağlantı çalışmayı durduracak.",
      moduleVisibility: "Modül görünürlüğü",
      whichModulesToShowOr: "Üst çubukta ve menüde hangi modüllerin gösterileceği veya gizleneceği — tüm kullanıcılar için geçerlidir.",
      hidden: "Gizli",
      visible: "Görünür",
      goals: "Hedefler",
      setSalesGoalsOverallAnd: "Satış hedefleri belirleyin — genel ve çalışan bazında",
      overallGoal: "Genel hedef",
      amountUzs: "Tutar (UZS)",
      numberOfSales: "Satış sayısı",
      byEmployee: "Çalışana göre",
      amountGoal: "Tutar hedefi",
      countGoal: "Adet hedefi",
      pushNotificationsEnabled: "Push bildirimleri açıldı!",
      permissionDeniedOrTheBrowser: "İzin reddedildi veya tarayıcı desteklemiyor",
      anErrorOccurred: "Bir hata oluştu",
      pushNotificationsDisabled: "Push bildirimleri kapatıldı",
      instagramConnectedSuccessfully: "Instagram başarıyla bağlandı!",
      connectionError: "Bağlantı hatası",
      facebookConnectedSuccessfully: "Facebook başarıyla bağlandı!",
      facebookConnectionError: "Facebook bağlantı hatası",
      failedToStartOauth: "OAuth başlatılamadı",
      disconnectInstagram: "Instagram bağlantısı kesilsin mi?",
      instagramDisconnected: "Instagram bağlantısı kesildi",
      facebookDisconnected: "Facebook bağlantısı kesildi",
      enterThePhoneNumberId: "Phone Number ID ve Access Token girin",
      whatsappConnected: "WhatsApp bağlandı!",
      connectionError2: "Bağlantı hatası",
      disconnectWhatsapp: "WhatsApp bağlantısı kesilsin mi?",
      whatsappDisconnected: "WhatsApp bağlantısı kesildi",
      thisPackHasAlreadyBeen: "Bu paket zaten eklendi",
      stickerPacksSaved: "Çıkartma paketleri kaydedildi",
      botTokenIsRequired: "Bot tokeni zorunludur",
      connected: "@{botUsername} bağlandı",
      connectionCancelled: "Bağlantı iptal edildi",
      disconnectTheBot: "Bot bağlantısı kesilsin mi?",
      botDisconnected: "Bot bağlantısı kesildi",
      enterAPhoneNumber: "Bir telefon numarası girin",
      theCodeWasSentTo: "Kod Telegram uygulamanıza gönderildi",
      couldNotSendTheCode: "Kod gönderilemedi",
      enterTheCode: "Kodu girin",
      enterThePassword: "Şifreyi girin",
      telegramAccountConnected: "Telegram hesabı bağlandı",
      signInFailed: "Giriş başarısız",
      disconnectTheAccountConversationsWill: "{label} hesabının bağlantısı kesilsin mi? Yazışmalar kapatılacak.",
      accountDisconnected: "Hesap bağlantısı kesildi",
      emailSettingsSaved: "E-posta ayarları kaydedildi",
      testFailed: "Test başarısız",
      socialNetworks: "Sosyal ağlar",
      email: "Email",
      notifications: "Bildirimler",
      integrations: "Entegrasyonlar",
      connectExternalChannelsToThe: "Harici kanalları CRM'e bağlayın",
      telegramBot: "Telegram Bot",
      superchatAllMessagesArriveIn: "Superchat — tüm mesajlar Gelen kutusuna gelir",
      connected2: "Bağlı",
      active: "aktif",
      notConfigured: "yapılandırılmadı",
      theBotWorksViaWebhook: "Bot webhook ile çalışır. Kullanıcılar bota yazdığında mesajlar Gelen kutusu sayfasına gelir.",
      disconnect: "Bağlantıyı kes",
      botToken: "Bot Token",
      createANewBotAnd: "yeni bir bot oluşturun ve tokenini girin",
      connect: "Bağla",
      telegramAccounts: "Telegram hesapları",
      personalProfileTheCustomerWrites: "Kişisel profil — müşteri bota değil, gerçek bir kişiye yazar",
      text: "{length}",
      anEmployeeSPersonalTelegram: "Bir çalışanın kişisel Telegram hesabı bağlanır — yazışmaları Gelen kutusunda görünür ve CRM'den yanıt verildiğinde müşteri mesajı o profilden alır.",
      addAccount: "Hesap ekle",
      automatingAPersonalAccountViolates: "Kişisel hesabı otomatikleştirmek Telegram kurallarını ihlal eder — spam gönderilirse hesap engellenebilir.",
      connectATelegramAccount: "Telegram hesabı bağla",
      phoneNumber: "Telefon numarası",
      telegramWillSendAConfirmation: "Telegram bu numaraya onay kodu gönderecek (kod uygulamanın içine gelir).",
      sendCode: "Kod gönder",
      verificationCode: "Doğrulama kodu",
      codeSentTo: "Kod {phone} numarasına gönderildi",
      confirm: "Onayla",
      "2faPassword": "2FA şifresi",
      cloudPassword: "Bulut şifresi",
      twoStepVerificationIsEnabled: "Hesapta iki adımlı doğrulama açık",
      signIn: "Giriş yap",
      stickerPacks: "Çıkartma paketleri",
      stickerSetsForInboxChat: "Gelen kutusu sohbeti için çıkartma setleri",
      add2: "Ekle",
      view: "görüntüle",
      noStickerPacksAddedYet: "Henüz çıkartma paketi eklenmedi",
      instagramDm: "Instagram DM",
      connectDirectMessagesToInbox: "Direct mesajlarını Gelen kutusuna bağlayın",
      instagramBusinessAccountConnected: "Instagram Business hesabı bağlandı",
      instagramDmMessagesArriveOn: "Instagram DM mesajları Gelen kutusu sayfasına otomatik gelir.",
      connectYourInstagramBusinessOr: "Instagram Business veya Creator hesabınızı bağlayın. Yetkilendirme Facebook sayfanız üzerinden OAuth ile yapılır.",
      connectViaFacebook: "Facebook ile bağla",
      metaDeveloperAppIdAnd: "Meta Developer App ID ve Secret .env içinde yapılandırılmalıdır",
      emailImapSmtp: "E-posta (IMAP/SMTP)",
      receiveAndReplyToEmail: "E-posta mesajlarını Gelen kutusunda alın ve yanıtlayın",
      imapIncomingMessages: "IMAP — gelen mesajlar",
      passwordAppPassword: "Şifre / Uygulama şifresi",
      useTlsSslPort993: "TLS/SSL kullan (port 993)",
      smtpOutgoingMessages: "SMTP — giden mesajlar",
      senderNameEmailFrom: "Gönderen adı/e-postası (From)",
      useSslPort465: "SSL kullan (port 465)",
      imap: "IMAP:",
      success: "Başarılı",
      smtp: "SMTP:",
      test: "Test",
      forGmailEnableAppPasswords: "Gmail için «Uygulama şifreleri»ni açın. IMAP istemcisi yeni mesajları otomatik çeker ve Gelen kutusuna ekler.",
      pushNotifications: "Push bildirimleri",
      aNotificationIsSentTo: "Yeni mesaj geldiğinde cihazınıza bildirim gönderilir",
      yourBrowserDoesNotSupport: "Tarayıcınız push bildirimlerini desteklemiyor",
      browserPermissionWasDeniedAllow: "Tarayıcı izni reddedildi. Tarayıcı ayarlarından bildirimlere izin verin.",
      notificationsEnabled: "✓ Bildirimler açık",
      notificationsDisabled: "Bildirimler kapalı",
      facebookMessenger: "Facebook Messenger",
      connectPageMessagesToInbox: "Sayfa mesajlarını Gelen kutusuna bağlayın",
      facebookPageConnected: "Facebook sayfası bağlandı",
      reallyDisconnect: "Gerçekten bağlantı kesilsin mi?",
      cancel2: "İptal",
      yesDisconnect: "Evet, bağlantıyı kes",
      targetLeadAdsLeads: "Hedefli (Lead Ads) potansiyel müşteriler",
      leadsFromInstagramFacebookAds: "Instagram/Facebook reklamlarından (Lead Ads formu ile) gelen potansiyel müşteriler otomatik olarak bu huni ve aşamaya düşer.",
      noFunnelSelected: "— Huni seçilmedi —",
      noStageSelected: "— Aşama seçilmedi —",
      untilAFunnelIsSelected: "Huni seçilene kadar hedefli potansiyel müşteriler CRM'e ulaşmaz.",
      connectYourFacebookBusinessPage: "Facebook işletme sayfanızı bağlayın. Sayfaya gönderilen Messenger mesajları Gelen kutusuna gelir.",
      whatsappBusiness: "WhatsApp Business",
      connectViaCloudApi: "Cloud API ile bağla",
      whatsappCloudApiConnected: "WhatsApp Cloud API bağlandı",
      enterTheMetaCloudApi: "Meta Cloud API bilgilerini girin (Meta paneli → WhatsApp → API Setup).",
      whatsappBusinessAccountIdOptional: "WhatsApp Business Account ID (isteğe bağlı)",
      phoneNumberEG998: "Telefon numarası (ör. +998...)",
      accessTokenPermanent: "Access Token (kalıcı)",
      orders: "Siparişler",
      salesPurchases: "Satış ve satın alma",
      cashier: "Kasiyer",
      other: "Diğer",
      employeeReportPhotoVideoLocation: "Çalışan raporu (fotoğraf/video/konum)",
      employeeCreatesASupplyRequest: "Çalışan tedarik talebi oluşturur",
      enterStartDate: "Başlangıç tarihini girin",
      createEstimatesInJobOrders: "Siparişlerde keşif oluştur",
      showEstimatesToEmployees: "Keşifleri çalışanlara göster",
      showPricesToEmployees: "Fiyatları çalışanlara göster",
      colourWarningAsTheDeadline: "Son tarih yaklaştıkça renkli uyarı",
      colourRules: "Renk kuralları",
      ifTheDeadlineIsToday: "Son tarih bugünse — her zaman kırmızı. Aşağıda: X gün kaldığında hangi rengin kullanılacağı.",
      addRule: "+ Kural ekle",
      noRulesYetClickAdd: "Henüz kural yok. «+ Kural ekle»ye tıklayın.",
      daysLeft: "{daysLeft} gün kaldı",
      days: "Gün:",
      background: "Arka plan:",
      text2: "Metin:",
      overdue: "Gecikmiş",
      alwaysRedCannotBeChanged: "Her zaman kırmızı — değiştirilemez",
      tvModeButton: "TV modu butonu",
      freezePauseOption: "Dondurma (duraklatma) seçeneği",
      accountingTriggers: "Muhasebe tetikleyicileri",
      whenMovingToTheStatus: "Aşağıda seçilen duruma geçildiğinde ilgili işlem otomatik çalışır. Boş bırakılırsa eski «Onaylandı» butonu ile yönetilir.",
      stockTrigger: "Stok tetikleyicisi",
      inWhichStatusToDeduct: "— hangi durumda ürün stokundan düşülecek",
      notSetLegacy: "— Ayarlanmadı (eski) —",
      debtTrigger: "Borç tetikleyicisi",
      inWhichStatusToRecord: "— cari hesabın borcunun hangi durumda kaydedileceği",
      noFolders: "— Klasör yok —",
      noneSelectedAllFoldersAre: "Hiçbiri seçilmedi — tüm klasörler görünür",
      hideWarehouseSelectionInThe: "Formda depo seçimini gizle",
      whichModulesAndSubmodulesTo: "Kenar çubuğunda hangi modül ve alt modüllerin gösterileceği veya gizleneceği",
      extensionPbx: "Dahili numara (santral)",
      eG209: "Ör.: 209",
      pbxExtensionSipuniIbratSip: "Santral dahili numarası (Sipuni/ibrat.sip.uz) — çalışan santral üzerinden ararken kullanılır.",
      nameIsRequired: "Ad zorunludur",
      error2: "Hata",
      confirmDeletion: "Silme onaylansın mı?",
      failedToLoad2: "Yüklenemedi",
      titleAndTextAreRequired: "Başlık ve metin zorunludur",
      updated: "Güncellendi",
      added: "Eklendi",
      quickReplies: "Hızlı yanıtlar",
      whenTypingInAChat: "Sohbette yazarken",
      pressAndChooseAQuick: "basın ve hızlı yanıt seçin",
      editing: "Düzenleniyor",
      addNew: "Yeni ekle",
      title: "Başlık *",
      eGHello: "ör.: merhaba",
      shortcut: "Kısayol",
      text3: "Metin *",
      replyText: "Yanıt metni...",
      noQuickReplies: "Hızlı yanıt yok",
    },
    tasksPage: {
      error: "Hata",
    },
    userProfilePage: {
      userNotFound: "Kullanıcı bulunamadı",
      nameIsRequired: "Ad zorunludur",
      phoneNumberIsRequired: "Telefon numarası zorunludur",
      saved: "Kaydedildi",
      error: "Hata",
      imageWasNotUploaded: "Görsel yüklenmedi",
      filesUploaded: "{length} dosya yüklendi",
      uploadFailed: "Yükleme başarısız",
      passwordMustBeAtLeast: "Şifre en az 4 karakter olmalıdır",
      passwordChanged: "Şifre değiştirildi",
      userProfile: "Kullanıcı profili",
      user: "Kullanıcı",
      password: "Şifre",
      save: "Kaydet",
      you: "Siz",
      active: "Aktif",
      inactive: "Pasif",
      basicInformation: "Temel bilgiler",
      name: "Ad *",
      phoneNumber: "Telefon numarası *",
      signInIsDoneWith: "Giriş bu numarayla yapılır.",
      extensionPbx: "Dahili numara (santral)",
      eG209: "Ör.: 209",
      eMail: "E-mail",
      dateOfBirth: "Doğum tarihi",
      ddMmYyyy: "GG/AA/YYYY",
      homeAddress: "Ev adresi",
      cityStreetHouse: "Şehir, sokak, ev...",
      additionalPhoneNumbers: "Ek telefon numaraları",
      add: "Ekle",
      noAdditionalNumbers: "Ek numara yok",
      homeWork: "Ev / İş",
      positionAndPermissions: "Unvan ve yetkiler",
      position: "Unvan",
      organizationOwner: "Kurum sahibi",
      administrator: "Yönetici",
      employee: "Çalışan",
      department: "Departman",
      noDepartment: "Departman yok",
      customRole: "Özel rol",
      noRoleDefault: "Rol yok (varsayılan)",
      passportAndDocuments: "Pasaport ve belgeler",
      uploadFile: "Dosya yükle",
      imagesAndPdfFilesAre: "Görseller ve PDF dosyaları kabul edilir. En fazla 15 MB.",
      noDocumentsUploaded: "Belge yüklenmedi",
      passportScanPhotoProofOf: "Pasaport taraması/fotoğrafı, ikamet belgesi ve diğer belgeler",
      changePassword: "Şifre değiştir",
      newPassword: "Yeni şifre",
      atLeast4Characters: "En az 4 karakter",
      cancel: "İptal",
    },
  },
  shared: {
    fieldTypes: {
      text: "Metin",
      textarea: "Uzun metin",
      number: "Sayı",
      phone: "Telefon",
      email: "Email",
      url: "URL",
      date: "Tarih",
      boolean: "Evet / Hayır",
      dropdown: "Liste (tek seçim)",
      multiselect: "Liste (çoklu seçim)",
      file: "Dosya",
    },
    callStatus: {
      ringing: "Çalıyor",
      active: "Görüşmede",
      completed: "Cevaplandı",
      missed: "Cevapsız",
      cancelled: "İptal edildi",
    },
    dateFilters: {
      all: "Tümü",
      today: "Bugün",
      week: "Bu hafta",
      month: "Bu ay",
    },
    profileTabs: {
      info: "Ayrıntılar",
      docs: "Belgeler",
    },
    fileN: "Dosya {n}",
    stageN: "Aşama {n}",
    sourceN: "Kaynak {n}",
    reasonN: "Neden {n}",
    created: "Oluşturuldu",
    user: "Kullanıcı",
    dealTabs: {
      main: "Ana",
      stats: "İstatistik",
      files: "Dosyalar",
      settings: "Ayarlar",
    },
    reviewTabs: {
      pages: "Sayfalar",
      collected: "Harita yorumları",
      feedback: "İç geri bildirim ({n})",
    },
    noLinkedPages: "Google/Yandex'e bağlı sayfa yok",
    googleKeyMissing: "Google API anahtarı henüz yapılandırılmadı (GOOGLE_PLACES_API_KEY)",
    searchError: "Arama hatası",
    save2gisFirst: "Önce sayfayı kaydedin, sonra 2GIS'i bağlayın",
    hoursN: "{n} sa",
    loadFailed: "Yüklenemedi",
    resolvedN: "Çözülen: %{n}",
    firstReply: "İlk yanıt",
    genericError: "Bir şeyler ters gitti",
    error: "Hata",
    justNow: "Şimdi",
    minShort: "{n} dk",
    regFeatures: {
      f1: "Depo ve ürün muhasebesi",
      f2: "Satış ve satın alma iş akışları",
      f3: "Müşteriler ve tedarikçiler",
      f4: "Finansal raporlar",
    },
    contactCreated: "Kişi oluşturuldu",
    fileUploadFailed: "Dosya yüklenemedi: {name}",
    yes: "Evet",
    no: "Hayır",
    fileLabel: "📎 Dosya",
    callAction: "Arama",
    roles: {
      owner: "Sahip",
      admin: "Yönetici",
      user: "Kullanıcı",
    },
    sumSymbol: "UZS",
    hourShort: "{n} sa",
    dayShort: "{n} g",
  },
  assignees: {
    none: "Atanmamış",
    hint: "Birden fazla seçebilirsiniz. İlki birincil olur",
    clear: "Temizle",
    primary: "birincil",
  },
  contactHistory: {
    fromDeal: "Anlaşma",
    dealCreated: "«{deal}» anlaşması oluşturuldu",
    dealWon: "«{deal}» anlaşması kazanıldı",
    dealLost: "«{deal}» anlaşması kaybedildi",
    nobody: "kimse",
    assigned: "{who}: sorumlular {from} → {to}",
    assignedViaDeal: "{who}: «{deal}» anlaşması üzerinden sorumlular: {from} → {to}",
    dealAssigned: "Sorumlular: {from} → {to}",
    merged: "{who} kişileri birleştirdi: {names}",
  },
  merge: {
    title: "Kişileri birleştir",
    subtitle: "Nelerin taşınacağını inceleyin. Siz onaylayana kadar hiçbir şey değişmez.",
    mainContact: "Ana kişi (korunur)",
    removedContacts: "Birleştirilip kaldırılacak",
    deals: "Anlaşmalar",
    tasks: "Görevler",
    calls: "Aramalar",
    chats: "Sohbetler",
    history: "Geçmiş",
    files: "Dosyalar",
    dealsHint: "İşaretlenen anlaşmalar ana kişiye taşınır. İşaretlenmeyen anlaşmaların kişiyle bağı kaldırılır (anlaşmalar silinmez).",
    noDeals: "Birleştirilen kişilerin anlaşması yok",
    possibleDup: "olası mükerrer",
    selectAll: "Tümünü seç",
    clearAll: "Tümünü temizle",
    fromContact: "{name} kişisinden",
    alsoMove: "Bunu da taşı",
    fillEmpty: "Ana kişinin boş alanlarını birleştirilenlerin verileriyle doldur",
    conflicts: "Değerler farklı (ana kişinin değerleri korunur)",
    field: {
      name: "Ad",
      email: "Email",
    },
    owners: "Sorumlular",
    ownersKeep: "Ana kişinin sorumlularını koru",
    ownersUnion: "Tüm sorumluları birleştir",
    status: {
      active: "Aktif",
      won: "Kazanıldı",
      lost: "Kaybedildi",
    },
    summary: "Taşınacak anlaşmalar: {n}",
    confirm: "Birleştir",
    cancel: "İptal",
    success: "Kişiler birleştirildi",
    error: "Birleştirilemedi",
    loadError: "Önizleme yüklenemedi",
  },
  quickTask: {
    typeLabel: "Görev türü",
    tab: "Görev",
    type: {
      call: "İletişime geç",
      meeting: "Toplantı",
      other: "Diğer",
    },
    on: "için",
    for: "sorumlu:",
    today: "Bugün",
    tomorrow: "Yarın",
    week: "Bir hafta sonra",
    placeholder: "Ne yapılması gerekiyor…",
    place: "Oluştur",
    cancel: "İptal",
    created: "Görev oluşturuldu",
    badDate: "Tarih ve saat girin",
  },
  callAI: {
    badge: {
      analyze: "Yapay zekâ analizi",
      queued: "Sırada",
      processing: "Analiz ediliyor…",
      failed: "Analiz başarısız",
      problem: "Sorunlu arama",
      tooShort: "Çok kısa",
    },
    modal: {
      title: "Yapay zekâ arama değerlendirmesi",
      notAnalyzed: "Bu arama henüz analiz edilmedi",
      notAnalyzedHint: "Analizi başlatın: sistem kaydı yazıya döker ve kontrol listesi raporu hazırlar.",
      analyze: "Analiz et",
      starting: "Başlatılıyor…",
      disabled: "Yapay zekâ ile arama analizi kapalı. Ayarlar → Entegrasyonlar → Yapay zekâ ile arama analizi bölümünden açın.",
      noEngine: "Sunucuda yazıya dökme veya analiz bağlı değil — arama bağlanana kadar bekleyecek.",
      tabReport: "Rapor",
      tabTranscript: "Döküm",
      retry: "Tekrar dene",
      reanalyze: "Yeniden çalıştır",
      delete: "Sil",
      deleteConfirm: "Döküm, puanlar ve kayıt kopyası silinsin mi?",
      close: "Kapat",
      summary: "Özet",
      intent: "Müşteri ne istedi",
      outcome: "Sonuç",
      checklist: "Kontrol listesi puanı",
      redFlags: "İhlaller ve riskler",
      noRedFlags: "İhlal bulunamadı",
      actions: "Aramadan sonraki adımlar",
      coaching: "Temsilciye öneri",
      metrics: "Arama metrikleri",
      topics: "Konular",
      noTranscript: "Döküm henüz mevcut değil",
      rolesInferred: "Temsilci ve müşteri rolleri bağlamdan çıkarıldı",
      tooShortNote: "Arama puanlanamayacak kadar kısa: yalnızca metrikler hesaplandı.",
      error: "Hata",
      agent: "Temsilci",
      client: "Müşteri",
      unknown: "Bilinmiyor",
      audioError: "Kayıt yüklenemedi",
      score: "Puan",
      clientSentiment: "Müşteri tonu",
      agentSentiment: "Temsilci tonu",
      notApplicable: "yok",
      createTask: "Görev oluştur",
    },
    status: {
      queued: "Sırada",
      downloading: "Kayıt indiriliyor…",
      downloaded: "Kayıt kaydedildi, yazıya dökme bekleniyor",
      transcribing: "Yazıya dökülüyor…",
      transcribed: "Yazıya döküldü, analiz bekleniyor",
      analyzing: "Analiz ediliyor…",
      done: "Tamamlandı",
      failed: "Başarısız",
      skipped: "Atlandı",
    },
    sentiment: {
      positive: "Olumlu",
      neutral: "Nötr",
      negative: "Olumsuz",
    },
    outcome: {
      sale: "Satış",
      agreed_next_step: "Sonraki adım kararlaştırıldı",
      callback_requested: "Geri aranmak istedi",
      info_given: "Bilgi verildi",
      no_interest: "İlgilenmiyor",
      complaint: "Şikâyet",
      other: "Diğer",
    },
    flag: {
      rude: "Kabalık",
      no_next_step: "Sonraki adım yok",
      false_promise: "Gerçekçi olmayan vaat",
      complaint: "Müşteri şikâyeti",
      competitor: "Rakipten bahsedildi",
      price_unhandled: "Fiyat itirazı karşılanmadı",
      data_leak: "Gereğinden fazla veri paylaşıldı",
      other: "Diğer",
    },
    severity: {
      low: "Düşük",
      medium: "Orta",
      high: "Yüksek",
    },
    item: {
      greeting: "Selamlama ve tanıtım",
      needs: "İhtiyaç analizi",
      presentation: "Ürün/hizmet bilgisi",
      objections: "İtiraz yönetimi",
      next_step: "Sonraki adım kararlaştırıldı",
      politeness: "Nezaket ve ton",
      closing: "Aramanın kapanışı",
    },
    metric: {
      agentTalkPct: "Temsilcinin konuşma payı",
      silencePct: "Sessizlik",
      interruptions: "Söz kesme",
      avgResponseGapSec: "Konuşmalar arası duraklama, sn",
      agentWpm: "Dakikadaki kelime (temsilci)",
      longestAgentMonologueSec: "Temsilcinin en uzun monoloğu, sn",
      durationSec: "Süre, sn",
      words: "Toplam kelime",
    },
    lang: {
      auto: "Otomatik",
      uz: "Özbekçe",
      ru: "Rusça",
      tg: "Tacikçe",
      en: "İngilizce",
    },
    analytics: {
      analyzed: "Analiz edilen aramalar",
      avgScore: "Ortalama puan",
      problem: "Sorunlu aramalar",
      talkMinutes: "Konuşma dakikası",
      cost: "Maliyet, $",
      pending: "İşleniyor: {n}",
      failedN: "Hatalar: {n}",
      tooShortN: "Çok kısa: {n}",
      byAgent: "Çalışanlar",
      thAgent: "Çalışan",
      thCalls: "Aramalar",
      thScore: "Puan",
      thProblem: "Sorunlu",
      thFlags: "İhlaller",
      thTalk: "Konuşma payı",
      checklist: "Kontrol listesi maddesine göre puan",
      outcomes: "Arama sonuçları",
      sentiment: "Müşteri duygu durumu",
      trend: "Puan eğilimi",
      topFlags: "Sık ihlaller",
      topTopics: "Konuşma konuları",
      worst: "En düşük puanlı aramalar",
      empty: "Bu dönemde analiz edilmiş arama yok",
      disabledTitle: "Yapay zekâ ile arama analizi kapalı",
      disabledText: "Ayarlardan açın, sistem yeni görüşmeleri yazıya dökmeye ve puanlamaya başlasın.",
      goSettings: "Ayarları aç",
      allAgents: "Tüm çalışanlar",
      noAgent: "Bilinmiyor",
      open: "Aç",
      allDirections: "Tüm aramalar",
      incoming: "Gelen",
      outgoing: "Giden",
      truncated: "Dönemin ilk 5000 araması gösteriliyor",
    },
    settings: {
      title: "Yapay zekâ ile arama analizi",
      subtitle: "Sistem müşterilerle yapılan kayıtlı görüşmeleri yazıya döker ve rapor hazırlar: özet, kontrol listesi puanı, ihlaller ve öneriler.",
      enable: "Yapay zekâ analizini aç",
      enableHint: "Yalnızca yeni aramalar analiz edilir — açtıktan sonra. Eski kayıtlar işlenmez.",
      auto: "Otomatik analiz et",
      autoHint: "Kapalıysa analiz aramadaki butonla manuel başlatılır.",
      minTalk: "Minimum konuşma süresi, dk",
      minTalkHint: "Konuşma süresi cevaplandığı andan itibaren sayılır (çalma süresi sayılmaz). Bazı işletmelere 2 dakika gerekir, bazıları için 15 bile az. 0 — sınır yok.",
      maxTalk: "Maksimum süre, dk",
      maxTalkHint: "Tasarruf için çok uzun aramalar atlanabilir. 0 — sınır yok.",
      directions: "Hangi aramalar analiz edilsin",
      in: "Gelen",
      out: "Giden",
      language: "Konuşma dili",
      languageHint: "«Otomatik» Özbekçe, Rusça ve Tacikçe karışımı için çalışır.",
      vocabulary: "Kuruluş sözlüğü",
      vocabularyHint: "Markalar, modeller, ürün ve çalışan adları virgülle. Analiz sırasında yapay zeka yanlış tanınan kelimeleri (ör. «lifis» → LI 9) düzeltir ve raporda doğru yazar.",
      vocabularyPlaceholder: "Li Auto, LI 7, LI 9, Li Avto Buxoro, taksit, Rosa",
      reportLanguage: "Rapor dili",
      retention: "Kayıtları saklama, gün",
      retentionHint: "Bu süreden sonra ses kopyası silinir; döküm ve puanlar kalır. 0 — sonsuza kadar sakla.",
      managerOnly: "Raporlar yalnızca yöneticilere görünür",
      managerOnlyHint: "Çalışan yalnızca kendi aramalarının değerlendirmelerini görür.",
      checklist: "Puanlama kontrol listesi",
      checklistHint: "Sistem her aramayı bu maddelere göre puanlar. Ağırlık, maddenin toplam puandaki önemidir.",
      usingDefault: "Varsayılan kontrol listesi kullanılıyor",
      customize: "Özelleştir",
      resetDefault: "Varsayılana dön",
      addItem: "Madde ekle",
      itemTitle: "Başlık",
      itemDescription: "Ne yapılmış sayılır",
      itemWeight: "Ağırlık",
      save: "Kaydet",
      saved: "Ayarlar kaydedildi",
      saveError: "Kaydedilemedi",
      engine: "Bağlantı",
      engineStt: "Konuşmayı yazıya dökme",
      engineLlm: "Metin analizi",
      engineOn: "bağlı",
      engineOff: "bağlı değil",
      onlyAdmin: "Bu ayarları yalnızca sahip veya yönetici değiştirebilir.",
      consentTitle: "Önemli: müşterilerinizi bilgilendirin",
      consentText: "Müşterilere görüşmelerin kaydedildiğini ve otomatik analiz edilebileceğini bildirin (örneğin santralin sesli karşılamasında). Bu, kişisel verilerin korunması mevzuatının gereğidir.",
      consentCheck: "Müşterilerin aramalarının kaydedildiğinden ve otomatik analiz edildiğinden haberdar olduğunu onaylıyorum",
      consentRequired: "Analizi açmak için müşterilerin bilgilendirildiğini onaylayın",
      consentAt: "{date} tarihinde onaylandı",
      maskPii: "Kişisel verileri harici modelden gizle",
      maskPiiHint: "Telefon numaraları, kart numaraları, pasaportlar ve e-postalar metin analize gönderilmeden önce yer tutucularla değiştirilir. Veritabanınızdaki döküm olduğu gibi kalır.",
      eraseTitle: "Müşteri verilerini sil",
      eraseHint: "Müşterinin talebi üzerine numarasına bağlı tüm dökümleri, puanları ve kayıt kopyalarını silebilirsiniz. Aramaların kendisi arama kaydında kalır.",
      erasePhone: "Müşteri telefon numarası",
      eraseBtn: "Verileri sil",
      eraseConfirm: "{phone} için tüm yapay zekâ analizi verileri silinsin mi? Bu geri alınamaz.",
      erased: "Silinen değerlendirmeler: {n}",
      eraseBadPhone: "Bir telefon numarası girin",
      minutesShort: "dk",
      unlimited: "sınır yok",
      queue: "Kuyruk",
    },
  },
  leadMap: {
    autoCreate: "Her yeni soru için otomatik alan oluştur",
    autoCreateHint: "Yeni bir soru içeren potansiyel müşteri geldiğinde CRM onun için bir anlaşma alanı oluşturur («Potansiyel müşteri formu» bölümünde) ve yanıtı oraya koyar. Manuel eşleştirme gerekmez.",
    autoOn: "Otomatik alanlar açık",
    autoOff: "Otomatik alanlar kapalı",
    title: "Potansiyel müşteri alanları",
    subtitle: "Facebook/Instagram formlarından ve API'den gelen yanıtların anlaşma kartına nasıl yerleştirileceği. Eşleştirmediğiniz her şey eskisi gibi yoruma gider.",
    hintStandard: "Standart form sorularındaki ad, telefon ve e-posta otomatik olarak kişiye gider. Diğer sorular ve reklam verileri burada ayarlanır.",
    question: "Form sorusu",
    sample: "Örnek yanıt",
    count: "Potansiyel müşteriler",
    target: "Kaydedilecek yer",
    toNote: "Yorum (varsayılan)",
    createField: "«{name}» alanını oluştur",
    dealFields: "Anlaşma alanı",
    contact: "Kişi",
    contactName: "Kişi adı",
    contactPhone: "Kişi telefonu",
    contactEmail: "Kişi e-postası",
    ignore: "Kaydetme",
    importMeta: "Soruları Meta formundan yükle",
    imported: "Eklenen sorular: {n}",
    importFail: "Sorular Meta'dan yüklenemedi",
    empty: "Sorular ilk potansiyel müşteriden sonra burada görünür. Ya da yukarıdaki butonla Meta formundan yükleyin.",
    emptyNoFb: "Sorular Facebook/Instagram'dan veya API ile gelen ilk potansiyel müşteriden sonra burada görünür.",
    saved: "Kaydedildi",
    fieldCreated: "Alan oluşturuldu: {name}",
    loadError: "Ayarlar yüklenemedi",
  },
  apiKeys: {
    title: "API anahtarları",
    subtitle: "Harici sistemlerden potansiyel müşteri alın: CRM Line, Zapier, Make, web sitesi formları. Her anahtar potansiyel müşterileri seçilen huni ve aşamaya koyar.",
    create: "Anahtar oluştur",
    createTitle: "Yeni API anahtarı",
    editTitle: "Anahtarı düzenle",
    name: "Ad",
    namePh: "ör. CRM Line (li-buxoro)",
    funnel: "Huni",
    stage: "Aşama",
    source: "Kaynak",
    sourceHint: "Anlaşmadaki kaynak etiketi. İsteğin kendisinde değiştirilebilir.",
    save: "Kaydet",
    cancel: "İptal",
    nameRequired: "Bir ad girin",
    error: "İşlem başarısız",
    saved: "Kaydedildi",
    empty: "Henüz anahtar yok",
    destination: "Potansiyel müşterilerin gittiği yer",
    lastUsed: "Son istek",
    neverUsed: "Hiç kullanılmadı",
    leadsCount: "potansiyel müşteri: {n}",
    edit: "Düzenle",
    revoke: "Anahtarı iptal et",
    revokeConfirm: "«{name}» anahtarı iptal edilsin mi? Hemen çalışmayı durdurur ve bu geri alınamaz.",
    revoked: "Anahtar iptal edildi",
    createdTitle: "«{name}» anahtarı oluşturuldu",
    shownOnce: "Anahtarı şimdi kopyalayın: yalnızca bir kez gösterilir. Kaybederseniz iptal edip yenisini oluşturun.",
    copy: "Kopyala",
    copied: "Kopyalandı",
    done: "Tamam",
    docsTitle: "Potansiyel müşteriler nasıl gönderilir",
    endpoint: "Uç nokta",
    example: "Örnek istek",
    docAuth: "Anahtarı Authorization: Bearer … başlığında (veya X-API-Key) gönderin.",
    docRequired: "Zorunlu: telefon veya e-posta. Ad isteğe bağlıdır.",
    docExternal: "external_id (ör. Meta lead id) mükerrerleri önler: yeniden gönderim ikinci bir anlaşma oluşturmaz.",
    docOptional: "İsteğe bağlı: source, funnel_id, stage_id, notes, answers {field: value}, campaign, ad_name, form_name, page_name, platform.",
    docLimit: "Sınır: anahtar başına dakikada 120 istek.",
  },
  callPanel: {
    initiatedSoftphone: "MicroSIP açılıyor ve numara çevriliyor…",
    noStartSoftphone: "Arama başlamadı. MicroSIP'in çalıştığını, {ext} dahilisi olarak kayıtlı olduğunu ve tel: bağlantıları için uygulama olarak ayarlandığını kontrol edin.",
    initiated: "Komut santrale gönderildi…",
    ringing: "Santral aramasını MicroSIP'te yanıtlayın (dahili {ext}) — sonra santral müşteriyi arayacak",
    ringingDirect: "Müşteri aranıyor…",
    active: "Görüşme devam ediyor",
    completed: "Görüşme bitti",
    missed: "Bağlanamadı",
    noStart: "Santral henüz aramayı başlatmadı. MicroSIP'in çalıştığını ve {ext} dahilisi olarak kayıtlı olduğunu kontrol edin.",
    retry: "Tekrar ara",
    openCard: "Kartı aç",
    close: "Kapat",
    noExt: "Size santral dahili numarası atanmamış. Bir yöneticiye başvurun (Ayarlar → Çalışanlar).",
    viaPbx: "Santral üzerinden (dahili {ext})",
    viaPbxNoExt: "Santral üzerinden — dahili yok",
    menuHint: "MicroSIP'iniz çalacak — yanıtlayın, santral müşteriyi arayacak",
    startFailed: "Komut santrale gönderilemedi",
    duration: "Süre {d}",
    reason: {
      no_answer: "Müşteri yanıt vermedi",
      busy: "Meşgul",
      cancelled: "Yanıtlanmadan iptal edildi",
      failed: "Hat hatası",
      unknown: "Neden bilinmiyor",
    },
    stats: {
      title: "Giden arama sonuçları",
      connected: "Bağlandı",
      fromCrm: "CRM butonundan: {n}, bağlanan {c}",
      empty: "Bu dönemde giden arama yok",
    },
  },
  ownerBot: {
    title: "İşletme yöneticisi için Telegram botu",
    subtitle: "Yalnızca işletme yöneticisine özel raporlar ve anlık uyarılar.",
    notConfigured: "Bot sunucuda henüz yapılandırılmadı. Miko ile iletişime geçin.",
    noPhone: "Yönetici numarası girilmemiş. Bunu Miko yöneticisi girer: destekle iletişime geçin.",
    phone: "Yönetici numarası",
    phoneHint: "Yalnızca bu numaranın sahibi Telegram’dan bağlanabilir.",
    connect: "Telegram’ı bağla",
    connecting: "Bağlantı oluşturuluyor…",
    linkReady: "Bağlantı linki (tek kullanımlık, 15 dakika geçerli)",
    open: "Telegram’da aç",
    copy: "Kopyala",
    copied: "Kopyalandı",
    linkSteps: "Linki yöneticinin telefonunda açın, Başlat’a basın ve bottaki düğmeyle numaranızı gönderin.",
    devices: "Bağlı cihazlar",
    noDevices: "Henüz kimse bağlı değil.",
    linkedAt: "bağlandı",
    sendReport: "Şimdi rapor",
    reportSent: "Rapor gönderildi",
    disconnect: "Bağlantıyı kes",
    disconnectConfirm: "Bu cihazın bot bağlantısı kesilsin mi?",
    times: "Rapor saatleri",
    evening: "Bugünün akşam raporu",
    morning: "Dünün sabah raporu",
    quiet: "Anlık mesaj gönderme",
    quietFrom: "başlangıç",
    quietTo: "bitiş",
    save: "Kaydet",
    saved: "Kaydedildi",
    attempts: "Bağlantı denemeleri",
    rejected: "Reddedildi: numara eşleşmedi",
    linked: "Bağlandı",
    whatTitle: "Bot neler gönderir",
    what1: "Her akşam ve sabah: talepler, aramalar (cevapsızlar dahil), kazanılan ve kaybedilen satışlar, görevler (tamamlanan ve geciken).",
    what2: "Uygulamada kim ne yaptı ve ne zaman: önemli değişiklikler (silmeler, ayarlar, personel, entegrasyonlar).",
    what3: "Anında: cevapsız gelen arama, kazanılan satış, önemli değişiklik.",
    what4: "Bot komutları: Bugün, Dün, Ayarlar.",
  },
  notifCenter: {
    title: "Bildirimler",
    empty: "Henüz yeni bir şey yok",
    message: "Yeni mesaj",
    lead: "Yeni lead",
    call: "Cevapsız arama",
    media: "Ek",
    missedCallText: "Müşteriyi geri arayın",
    now: "şimdi",
    min: "dk",
    hour: "sa",
    clear: "Temizle",
    soundOn: "Sesi aç",
    soundOff: "Sesi kapat",
    unreadInbox: "Gelen kutusunda okunmamış",
  },
  topbar: {
    hotkeysHint: "bölümlere git, N — yeni anlaşma",
    cmdGo: "Git", cmdFunnel: "Huni", cmdTheme: "Temayı değiştir", cmdGroup: "Komutlar", recent: "Son kullanılanlar",
    appearance: "Görünüm", themeLight: "Açık", themeDark: "Koyu", themeAuto: "Otomatik",
    liteMode: "Sade görünüm", liteHint: "Bulanıklık ve animasyon yok: yavaş cihazlarda daha hızlı",
    searchNavigate: "seç",
    searchOpen: "aç",
    search: "Ara",
    searchPlaceholder: "Müşteri, anlaşma veya komut…",
    searchContacts: "Kişiler",
    searchDeals: "Anlaşmalar",
    searchEmpty: "Hiçbir şey bulunamadı",
    searchHint: "En az 2 karakter yazın",
    create: "Oluştur",
    createDeal: "Yeni anlaşma",
    createContact: "Yeni kişi",
    funnels: "Huniler",
    close: "Kapat",
    accountSettings: "Hesap ayarları",
    settings: "Ayarlar",
    refresh: "Yenile",
    lockScreen: "Ekranı kilitle",
    fullscreen: "Tam ekran",
    exitFullscreen: "Tam ekrandan çık",
    roles: {
      owner: "Sahip",
      admin: "Yönetici",
      manager: "Satış temsilcisi",
      cashier: "Kasiyer",
      warehouse: "Depo",
      viewer: "İzleyici",
    },
    hidePanel: "Üst çubuğu gizle",
    showPanel: "Üst çubuğu göster",
    language: "Dil",
  },
  assets: {
    pageTitle: "Şirket varlıkları",
    pageSubtitle: "Ekipman, mobilya ve diğer duran varlıklar",
    addBtn: "Varlık ekle",
    searchPlaceholder: "Ad veya envanter ID...",
    statTotal: "Toplam varlık",
    statUnit: "adet",
    statCost: "İlk maliyet",
    statAccDep: "Amortisman",
    statBookValue: "Defter değeri",
    currency: "UZS",
    catAll: "Tüm kategoriler",
    cat_furniture: "Mobilya",
    cat_electronics: "Elektronik",
    cat_computer: "Bilgisayar ve teknoloji",
    cat_vehicle: "Araçlar",
    cat_equipment: "Üretim ekipmanı",
    cat_office: "Ofis ekipmanı",
    cat_other: "Diğer",
    statusAll: "Tüm durumlar",
    statusActive: "Aktif",
    statusDisposed: "Elden çıkarıldı",
    status_active: "Aktif",
    status_disposed: "Elden çıkarıldı",
    thInventoryId: "Env. ID",
    thName: "Ad",
    thCategory: "Kategori",
    thCost: "İlk maliyet",
    thAccDep: "Amortisman",
    thBookValue: "Defter değeri",
    thStatus: "Durum",
    thActions: "İşlemler",
    noItems: "Varlık bulunamadı",
    deleteConfirm: "Bu varlık silinsin mi?",
    deleteHint: "Tüm amortisman kayıtları da silinecek.",
    deleteBtn: "Sil",
    cancel: "İptal",
    deleted: "Varlık silindi",
    saved: "Kaydedildi",
    created: "Varlık oluşturuldu",
    formTitleNew: "Yeni varlık",
    formTitleEdit: "Varlığı düzenle",
    saveBtn: "Kaydet",
    backBtn: "Geri",
    sectionMain: "Genel bilgiler",
    sectionFinance: "Finansal veriler",
    sectionDepreciation: "Amortisman",
    sectionHistory: "Amortisman geçmişi",
    nameLabel: "Ad",
    namePlaceholder: "ör. HP EliteBook 840",
    categoryLabel: "Kategori",
    statusLabel: "Durum",
    descriptionLabel: "Açıklama",
    descriptionPlaceholder: "Ek bilgi...",
    locationLabel: "Konum / Departman",
    locationPlaceholder: "ör. Finans dept.",
    responsibleLabel: "Sorumlu kişi",
    responsiblePlaceholder: "Ad soyad",
    purchaseDateLabel: "Satın alma tarihi",
    purchaseCostLabel: "İlk maliyet (UZS)",
    disposalDateLabel: "Elden çıkarma tarihi",
    disposalNoteLabel: "Elden çıkarma nedeni",
    disposalNotePlaceholder: "Eskidi, satıldı...",
    depMethodLabel: "Amortisman yöntemi",
    depMethodNone: "Amortisman yok",
    depMethodStraightLine: "Doğrusal",
    usefulLifeLabel: "Faydalı ömür (ay)",
    monthlyDepLabel: "Aylık amortisman",
    annualDepLabel: "Yıllık amortisman",
    accDepLabel: "Birikmiş amortisman",
    bookValueLabel: "Defter (kalan) değeri",
    noteLabel: "Notlar",
    notePlaceholder: "Not...",
    addDepBtn: "Amortisman kaydet",
    depModalTitle: "Amortisman kaydet",
    depDateLabel: "Tarih",
    depAmountLabel: "Tutar",
    depNoteLabel: "Not",
    depNotePlaceholder: "ör. Haziran 2026 amortismanı",
    depSaveBtn: "Kaydet",
    depAdded: "Amortisman kaydedildi",
    depDeleted: "Kayıt silindi",
    suggestedDep: "Önerilen tutar",
    depAmountRequired: "Tutar zorunludur",
    noDepHistory: "Amortisman kaydı yok",
    nameRequired: "Ad zorunludur",
    categoryRequired: "Kategori zorunludur",
    thDepDate: "Tarih",
    thDepAmount: "Tutar",
    thDepNote: "Not",
    catNone: "Kategori yok",
    catEmpty: "Kategori yok — Ayarlar'dan ekleyin",
    statusNone: "Durum yok",
    statusEmpty: "Durum yok — Ayarlar'dan ekleyin",
    statusAllFilter: "Tüm durumlar",
    depMethodStraightLineHint: "Eşit aylık tutar",
    monthsSuffix: "ay",
  },
  settingsAssets: {
    tabLabel: "Varlıklar",
    title: "Varlık ayarları",
    catTitle: "Kategoriler",
    catSubtitle: "Varlıkları gruplamak ve filtrelemek için kategoriler",
    statusTitle: "Durumlar",
    statusSubtitle: "Her varlık için mevcut durum etiketleri",
    addCatBtn: "Kategori ekle",
    addStatusBtn: "Durum ekle",
    namePlaceholder: "Ad...",
    colorLabel: "Renk",
    saveBtn: "Kaydet",
    cancelBtn: "İptal",
    noCats: "Henüz kategori yok",
    noStatuses: "Henüz durum yok",
    deleted: "Silindi",
    saved: "Kaydedildi",
    created: "Oluşturuldu",
    dupError: "Bu ad zaten var",
  },
  crmDashboard: {
    greeting: "Hoş geldiniz, {name}!",
    loadError: "Veriler yüklenemedi",
    reload: "Yeniden yükle",
    kpiCalls: "Bugünkü aramalar",
    kpiContacts: "Yeni kişiler",
    kpiDeals: "Açık anlaşmalar",
    kpiUnanswered: "Yanıt bekliyor",
    kpiSubToday: "bugün",
    kpiSubTodayAdded: "bugün eklendi",
    kpiSubTotal: "toplam",
    kpiSubUnanswered: "yanıtlanmamış",
    missedTitle: "Cevapsız aramalar",
    missedEmpty: "Cevapsız arama yok",
    allCalls: "Tüm aramalar →",
    allTasks: "Tüm görevler →",
    overdueTitle: "Gecikmiş görevler",
    dueDate: "Son tarih:",
    activityTitle: "Son etkinlik",
    activityEmpty: "Etkinlik yok",
    funnelTitle: "Huni istatistikleri",
    funnelEmpty: "Huni yok",
    noDeal: "Anlaşma yok",
    quickLinks: "Hızlı bağlantılar",
    addContact: "Kişi ekle",
    callHistory: "Arama geçmişi",
    incoming: "Gelen",
    outgoing: "Giden",
  },
  tasks: {
    title: "Görevler",
    newTask: "Yeni görev",
    editTask: "Görevi düzenle",
    viewTask: "Görevi görüntüle",
    close: "Kapat",
    noStagesTitle: "Görevler",
    noStages: "Aşama ayarlanmadı. Aşama eklemek için Ayarlar → Görevler'e gidin.",
    search: "Ara...",
    filter: "Filtre",
    clearFilters: "Temizle",
    allPriorities: "Tümü",
    allAssignees: "Tüm üyeler",
    assignedToMe: "Bana atanan",
    createdByMe: "Benim oluşturduğum",
    overdue: "gecikmiş",
    totalNote: "Toplam {total} — ilk {shown} gösteriliyor",
    deleteConfirm: "Bu görev silinsin mi?",
    prioLow: "Düşük",
    prioMedium: "Orta",
    prioHigh: "Yüksek",
    modalTitle: "Başlık *",
    titlePlaceholder: "Ne yapılması gerekiyor...",
    titleRequired: "Başlık zorunludur",
    description: "Açıklama / notlar",
    descPlaceholder: "Ayrıntılı açıklama...",
    priority: "Öncelik",
    stage: "Aşama",
    assignee: "Sorumlu",
    additionalAssignees: "Ek sorumlular",
    unassigned: "Atanmamış",
    dueDate: "Son tarih",
    contact: "Kişi",
    contactSearch: "Kişi ara...",
    contactNotFound: "Kişi bulunamadı",
    contactCreate: "\"{q}\" kişisini oluştur",
    contactNew: "Yeni kişi",
    contactName: "Ad",
    contactPhone: "Telefon",
    contactSave: "Oluştur",
    contactCreated: "Kişi oluşturuldu ve bağlandı",
    contactExisting: "Bu telefonla bir kişi zaten var: {name}. Bağlandı",
    contactCreateError: "Kişi oluşturulamadı",
    linked: "Bağlı",
    files: "Dosyalar",
    uploadFile: "+ Dosya yükle",
    uploading: "Yükleniyor...",
    tags: "Etiketler",
    tagsPlaceholder: "Etiket ekleyin, Enter'a basın...",
    createdByPrefix: "Ekleyen:",
    historyTitle: "Değişiklik geçmişi",
    histUnknownUser: "Bilinmiyor",
    histCreated: "görevi oluşturdu",
    histStageChanged: "aşamayı değiştirdi",
    histAssigned: "atadı",
    histUnassigned: "atamayı kaldırdı",
    histArchived: "arşivledi",
    histUnarchived: "arşivden çıkardı",
    histCompleted: "tamamlandı olarak işaretledi",
    archive: "Arşiv",
    archived: "Görev arşivlendi",
    archiveEmpty: "Arşivlenmiş görev yok",
    restore: "Geri yükle",
    restored: "Görev geri yüklendi",
    assignedToPrefix: "Atanan:",
    cancel: "İptal",
    save: "Kaydet",
    create: "Oluştur",
    saved: "Kaydedildi",
    created: "Oluşturuldu",
    deleted: "Silindi",
    loadError: "Yükleme hatası",
    error: "Hata",
    viewKanban: "Kanban",
    viewDue: "Son tarih",
    viewCalendar: "Takvim",
    viewDay: "Gün",
    viewWeek: "Hafta",
    viewMonth: "Ay",
    noDateBucket: "Tarih yok",
    colOverdue: "Gecikmiş",
    colToday: "Bugün",
    colTomorrow: "Yarın",
    colThisWeek: "Bu hafta",
    colNextWeek: "Gelecek hafta",
    completeTitle: "Görevi tamamla",
    outcomeNotePlaceholder: "Sonuç: ne konuşuldu, ne kararlaştırıldı...",
    logToDeal: "Anlaşma akışına kaydet",
    createFollowUp: "Takip görevi oluştur",
    followUpTitle: "Takip görevinin başlığı",
    followUpDue: "Takip görevinin son tarihi",
    followUpAssignee: "Sorumlu (isteğe bağlı)",
    completeConfirm: "Tamamla",
    completeSuccess: "Görev tamamlandı",
    markDone: "Tamamladım",
    noDoneStage: "«Tamamlandı» aşaması ayarlanmadı",
    doneBadge: "Tamamlandı",
    archiveAction: "Arşivle",
    callTitle: "Ara",
    noDealAccess: "Bu anlaşmaya erişiminiz yok",
    authorTitle: "Yazar: {name}",
    assigneeTitle: "Sorumlu: {name}",
    viewAction: "Aç",
    editAction: "Düzenle",
    deleteAction: "Sil",
    scopeMine: "Benimkiler",
  },
  calls: {
    fPeriod: "Dönem",
    fStatus: "Durum",
    fDirection: "Yön",
    resetFilters: "Filtreleri sıfırla",
    title: "Aramalar",
    all: "Tümü",
    incoming: "Gelen",
    outgoing: "Giden",
    missed: "Cevapsız",
    completed: "Tamamlandı",
    ringing: "Çalıyor",
    busy: "Meşgul",
    search: "Telefon veya kişi...",
    dateFrom: "Başlangıç",
    dateTo: "Bitiş",
    noResults: "Arama bulunamadı",
    emptyHint: "İlk aramalarınız burada görünecek",
    deleteSelected: "Seçilenleri sil",
    selectAll: "Tümünü seç",
    deselectAll: "Seçimi kaldır",
    deleteConfirm: "Seçilen {n} arama silinsin mi?",
    deleted: "Silindi",
    loadError: "Yükleme hatası",
    thDate: "Tarih / saat",
    thDirection: "Yön",
    thPhone: "Telefon",
    thContact: "Kişi",
    thDuration: "Süre",
    thStatus: "Durum",
    thRecord: "Kayıt",
    thExt: "Dahili",
    statsTotal: "Toplam",
    statsMissed: "Cevapsız",
    statsDuration: "Toplam süre",
    linkContact: "Bağla",
    linked: "Bağlı",
    viewContact: "Kişiyi görüntüle",
    analytics: "Analitik",
    noContact: "Kişi yok",
    unknown: "Bilinmiyor",
    colExt: "Dahili",
    secShort: "{n} sn",
  },
  contacts: {
    thAssignee: "Sorumlu",
    colAssignee: "Sorumlu",
    colCreated: "Eklenme tarihi",
    sortBy: "Sırala",
    title: "Kişiler",
    reminderOverdue: "Hatırlatıcı gecikti",
    newContact: "Yeni kişi",
    search: "Ad, telefon, e-posta...",
    noContacts: "Kişi bulunamadı",
    emptyHint: "İlk kişinizi ekleyin",
    import: "İçe aktar",
    export: "Dışa aktar",
    columns: "Sütunlar",
    deleteSelected: "Sil ({n})",
    deleteConfirm: "Seçilen {n} kişi silinsin mi?",
    deleted: "Silindi",
    loadError: "Yükleme hatası",
    importTitle: "CSV içe aktarma",
    importHint: "Bir CSV dosyası yükleyin. İlk satır — sütun adları.",
    importBtn: "Yükle",
    importPreview: "Önizleme",
    importSave: "Kaydet",
    importCancel: "İptal",
    importSuccess: "{n} kişi eklendi",
    importError: "İçe aktarma hatası",
    exportSuccess: "Dışa aktarma başladı",
    selectFile: "CSV dosyası seçin",
    mapping: "Sütunları eşleştirin",
    analytics: "Analitik",
    thName: "Ad",
    thPhone: "Telefon",
    thEmail: "Email",
    thSource: "Kaynak",
    thCreated: "Tarih",
    thActions: "İşlemler",
    filterSource: "Kaynağa göre filtrele",
    allSources: "Tüm kaynaklar",
    yes: "Evet",
    no: "Hayır",
    fileAttached: "📎 Dosya",
    columnsTitle: "Sütun seçin",
    blocked: "Engellendi",
    noResults: "Hiçbir şey bulunamadı",
    addFirst: "İlk kişinizi ekleyin",
    add: "Ekle",
    duplicates: "Mükerrerler",
    duplicatesTitle: "Mükerrer numaraları bul",
    normalizeAll: "Numaraları +998'e dönüştür",
    normalizeTitle: "Tüm numaraları +998 biçimine dönüştür",
    selectedN: "Seçilen: {n}",
    colContact: "Kişi",
    colPhone: "Telefon",
    colEmail: "Email",
    extraFields: "Ek alanlar",
    exportError: "Dışa aktarma başarısız",
    searchPlaceholder: "Ad, telefon, e-posta...",
  },
  contactForm: {
    phoneInvalid: "Numarayı kontrol edin, ör. +998 90 123 45 67",
    phoneHint: "Örnek: +998 90 123 45 67",
    newTitle: "Yeni kişi",
    editTitle: "Kişiyi düzenle",
    back: "Geri",
    save: "Kaydet",
    saving: "Kaydediliyor...",
    delete: "Sil",
    deleteConfirm: "Bu kişi silinsin mi?",
    deleted: "Silindi",
    saved: "Kaydedildi",
    created: "Oluşturuldu",
    loadError: "Yükleme hatası",
    tabGeneral: "Genel",
    tabActivity: "Etkinlik geçmişi",
    tabDeals: "Anlaşmalar",
    name: "Ad *",
    namePlaceholder: "Ad soyad...",
    nameRequired: "Ad zorunludur",
    phone: "Telefon",
    phonePlaceholder: "+998 XX XXX XX XX",
    email: "Email",
    emailPlaceholder: "ornek@mail.com",
    source: "Kaynak",
    sourcePlaceholder: "Telegram, web sitesi...",
    notes: "Notlar",
    notesPlaceholder: "Notlar...",
    activityEmpty: "Henüz etkinlik yok",
    activityCall: "Arama",
    activityNote: "Not",
    dealsEmpty: "Anlaşma yok",
    dealAdd: "Anlaşma ekle",
    error: "Bir hata oluştu",
    cancel: "İptal",
    blocked: "Engellendi",
    reminder: "Hatırlatıcı",
    reminderOverdue: "Hatırlatıcı gecikti",
    block: "Engelle",
    unblock: "Engeli kaldır",
    tabFiles: "Dosyalar",
    tabSettings: "Ayarlar",
    activitySub: "Notlar, aramalar ve değişiklikler",
    activityHint: "Not ve kayıt eklemek için kişiyi kaydedin",
    activityEmptyHint: "İlk notu yazın",
  },
  inbox: {
    title: "Gelen kutusu",
    search: "Ara...",
    tabUnanswered: "Yanıtlanmamış",
    tabAccepted: "Kabul edildi",
    tabClosed: "Kapalı",
    noUnanswered: "Yanıtlanmamış mesaj yok",
    noUnansweredHint: "Yeni mesajlar burada görünecek",
    noClosed: "Kapalı sohbet yok",
    noClosedHint: "Kapatılan görüşmeler burada görünecek",
    noAccepted: "Kabul edilmiş sohbet yok",
    noConvsTotal: "Görüşme yok",
    selectConv: "Bir görüşme seçin",
    selectConvHint: "Listeden bir görüşme seçin",
    convCount: "{n} görüşme",
    sendPlaceholder: "Bir mesaj yazın...",
    emailPlaceholder: "E-posta yanıtı yazın...",
    notePlaceholder: "Dahili not yazın...",
    noteMode: "Dahili not modu — yalnızca ekip görür",
    deleteConv: "Görüşmeyi sil",
    deleteMsg: "Mesajı sil",
    markAnswered: "Yanıtlandı olarak işaretle",
    markUnanswered: "Yanıtlanmadı olarak işaretle",
    closeConv: "Görüşmeyi kapat",
    openConv: "Görüşmeyi yeniden aç",
    reassign: "Ata",
    reassignTitle: "Üyeye ata",
    reassignNone: "Atanmamış",
    labelTitle: "Etiket",
    addLabel: "Etiket ekle...",
    convInfo: "Bilgi",
    goToContact: "Kişiye git",
    createContact: "Kişi oluştur",
    loadError: "Yükleme hatası",
    sendError: "Gönderilemedi",
    deleteError: "Silinemedi",
    analytics: "Analitik",
    back: "Geri",
    noSubject: "(Konu yok)",
    from: "Kimden:",
    to: "Kime:",
    noAcceptedHint: "Kabul edilen sohbetler burada görünür",
    delete: "Sil",
    msgNotFound: "Mesaj bulunamadı",
    noMsgs: "Mesaj yok",
    captionPlaceholder: "Açıklama ekleyin (isteğe bağlı)...",
    allConvs: "Tüm görüşmeler",
    assignedAgent: "Atanan temsilci",
    linkedContact: "Bağlı kişi",
    contactName: "Ad *",
    cancel: "İptal",
    save: "Kaydet",
    noData: "Veri yok",
  },
  funnel: {
    journeyAnalytics: "Potansiyel müşteri yolculuğu",
    newDeal: "Yeni anlaşma",
    addQuick: "Hızlı ekle",
    dealSearch: "Anlaşma, kişi adı veya numara...",
    sortLabel: "Sırala",
    sortManual: "Varsayılan (elle sıralama)",
    sortCreatedAsc: "Eskiden yeniye (oluşturma tarihine göre)",
    sortCreatedDesc: "Yeniden eskiye (oluşturma tarihine göre)",
    sortUpdatedAsc: "Eskiden yeniye (durum değişikliğine göre)",
    sortUpdatedDesc: "Yeniden eskiye (durum değişikliğine göre)",
    sortTitleAsc: "A - Z",
    sortTitleDesc: "Z - A",
    dateFrom: "Oluşturma tarihi — başlangıç",
    dateTo: "Oluşturma tarihi — bitiş",
    showClosed: "Kapalı",
    bulkSelectTitle: "Toplu seçim",
    select: "Seç",
    selectCancel: "İptal",
    archiveBtn: "Arşiv",
    statsBtn: "İstatistik",
    noDeals: "Anlaşma yok",
    totalDeals: "anlaşma",
    totalValue: "toplam değer",
    loadError: "Yükleme hatası",
    deleteConfirm: "Bu anlaşma silinsin mi?",
    deleted: "Silindi",
    edit: "Düzenle",
    newLead: "Yeni anlaşma",
    leadNameLabel: "Müşteri adı *",
    contactOpt: "Kişi (isteğe bağlı)",
    noContact: "— Kişi yok",
    createContact: "+ Yeni kişi oluştur",
    contactNamePh: "Ad *",
    contactPhonePh: "Telefon",
    contactEmailPh: "Email",
    contactCreated: "Kişi oluşturuldu",
    contactExists: "Kişi zaten var",
    responsibleLabel: "Atanan",
    unassigned: "— Atanmamış",
    notesPlaceholder: "Ek bilgi...",
    addBtn: "Ekle",
    titleRequired: "Başlık zorunludur",
    searchPlaceholder: "Ara...",
    noFunnel: "Huni bulunamadı",
    stagePlaceholder: "Aşama adı...",
    moveTitle: "Anlaşma değeri",
    moveHint: "Tutar girin (isteğe bağlı)",
    moveSave: "Taşı",
    moveCancel: "İptal",
    export: "Dışa aktar",
    import: "İçe aktar",
    exportDone: "Excel indirildi",
    exportError: "Dışa aktarma hatası",
    importTitle: "Excel içe aktarma",
    importDone: "İçe aktarma tamamlandı!",
    importCreated: "potansiyel müşteri eklendi",
    importSkipped: "atlandı",
    importFormat: "Excel (.xlsx) sütunları:",
    importHint: "İlk satır — sütun adları. Yalnızca «Sarlavha» sütunu zorunludur.",
    downloadTemplate: "Şablonu indir",
    templateError: "Şablon indirilemedi",
    importBtn: "İçe aktar",
    importError: "İçe aktarma hatası",
    onlyXlsx: "Yalnızca .xlsx dosyaları kabul edilir",
    dropXlsx: "Excel (.xlsx) dosyasını buraya bırakın",
    orClick: "veya seçmek için tıklayın",
    clear: "Temizle",
    cancel: "İptal",
    close: "Kapat",
    dealsCount: "{n} anlaşma",
    dealsCountFiltered: "{shown} / {total}",
    viewActive: "Aktif",
    viewClosed: "Kapalı",
    allSources: "Tüm kaynaklar",
    noSource: "Kaynak yok",
    cfAll: "{name}: tümü",
    cfNone: "{name} yok",
    chipSearch: "“{q}”",
    chipDates: "{from} — {to}",
    bulkMoved: "{n} potansiyel müşteri taşındı",
    bulkTransferred: "{n} potansiyel müşteri aktarıldı",
    bulkDeleted: "{n} potansiyel müşteri silindi",
    bulkArchived: "{n} potansiyel müşteri arşivlendi",
    bulkAssigned: "{n} potansiyel müşteri atandı",
    bulkSkipped: ", {n} atlandı",
  },
  deals: {
    moveStage: "Aşama", moveStageTitle: "Aşamaya taşı", showMore: "{count} tane daha göster",
    nextStep: "Sonraki adım",
    noNextStep: "Sonraki adım yok: anlaşma kaybolmasın diye bir görev ekleyin",
    setNextStep: "Görev ekle",
    back: "Geri",
    newDeal: "Yeni anlaşma",
    editDeal: "Anlaşmayı düzenle",
    save: "Kaydet",
    cancel: "İptal",
    delete: "Sil",
    deleteConfirm: "Bu anlaşma silinsin mi?",
    deleted: "Silindi",
    saved: "Kaydedildi",
    created: "Oluşturuldu",
    loadError: "Yükleme hatası",
    titleLabel: "Başlık *",
    titlePlaceholder: "Anlaşma adı...",
    titleRequired: "Başlık zorunludur",
    contact: "Kişi",
    value: "Tutar",
    currency: "Para birimi",
    stage: "Aşama",
    moveToFunnel: "Başka huniye taşı",
    moveFunnelLabel: "Huni",
    moveFunnelPlaceholder: "Bir huni seçin...",
    moveStagePlaceholder: "Bir aşama seçin...",
    moveReasonLabel: "Neden (isteğe bağlı)",
    moveReasonPlaceholder: "Potansiyel müşteri neden başka huniye taşınıyor...",
    moveSubmit: "Taşı",
    moveSuccess: "Başka huniye taşındı",
    assignee: "Sorumlu",
    dueDate: "Son tarih",
    notes: "Notlar",
    notesPlaceholder: "Notlar...",
    wonTitle: "Anlaşma kazanıldı",
    lostTitle: "Anlaşma kaybedildi",
    wonReason: "Neden veya not (isteğe bağlı)",
    lostReason: "Kayıp nedeni (isteğe bağlı)",
    reasonPlaceholder: "Neden...",
    confirm: "Onayla",
    activitySub: "Notlar ve değişiklikler",
    notePlaceholder: "Bir not yazın...",
    activityEmpty: "Henüz etkinlik yok",
    activityHint: "İlk notu yazın",
    noteTab: "Not",
    communicationTab: "Kişi",
    contactTypeCall: "Arama",
    contactTypeMessage: "Mesaj",
    contactTypeMeeting: "Toplantı",
    durationLabel: "dk",
    outcomeInterested: "İlgileniyor",
    outcomeThinking: "Düşünüyor",
    outcomeDeclined: "Reddetti",
    outcomeNoAnswer: "Yanıt yok",
    outcomeOther: "Diğer",
  },
  inboxAnalytics: {
    title: "Gelen kutusu analitiği",
    back: "Gelen kutusu",
    tabGeneral: "Genel bakış",
    tabAgents: "Temsilciler",
    preset7d: "7 gün",
    presetMonth: "Bu ay",
    presetPrevMonth: "Geçen ay",
    presetQuarter: "Bu çeyrek",
    presetCustom: "Özel",
    apply: "Uygula",
    compare: "Önceki dönemle karşılaştır",
    totalConvs: "Toplam görüşme",
    unanswered: "Yanıtlanmamış",
    closed: "Kapalı",
    avgResponse: "Ort. yanıt süresi",
    firstResponse: "İlk yanıt",
    resolutionRate: "Çözüm oranı:",
    prevPeriod: "önceki dönem:",
    dailyChart: "Günlük görüşmeler",
    dayCount: "gün",
    comparison: "Dönem karşılaştırması",
    total: "Toplam",
    closedPct: "Kapalı %",
    byChannel: "Kanala göre",
    agentStats: "Temsilciler",
    labelStats: "Etiketler",
    noData: "Veri yok",
    noLabels: "Etiket yok",
    agentReport: "Temsilci raporu",
    exportCsv: "CSV dışa aktar",
    thAgent: "Temsilci",
    thTotal: "Görüşmeler",
    thClosed: "Kapalı",
    thClosedPct: "Kapanış %",
    thAvgResp: "Ort. yanıt",
    thCalls: "Aramalar",
    loadError: "Yüklenemedi",
  },
  contactAnalytics: {
    title: "Kişi analitiği",
    back: "Kişiler",
    preset30d: "30 gün",
    presetMonth: "Bu ay",
    preset90d: "90 gün",
    presetCustom: "Özel",
    apply: "Uygula",
    periodNew: "Dönemdeki yeni kişiler",
    totalAll: "Toplam kişi",
    allTime: "Tüm zamanlar",
    dailyChart: "Günlük yeni kişiler",
    byChannel: "Kanala göre (Gelen kutusu üzerinden)",
    byOperator: "Operatöre göre",
    noPhone: "Telefon numarası yok",
    noData: "Veri yok",
    loadError: "Yüklenemedi",
  },
  leadJourney: {
    title: "Potansiyel müşteri yolculuğu",
    back: "Huniler",
    preset30d: "30 gün",
    presetMonth: "Bu ay",
    preset90d: "90 gün",
    presetCustom: "Özel",
    apply: "Uygula",
    contactsWidgetTitle: "Dönemdeki temaslar",
    uniqueLeadsContacted: "temas kurulan benzersiz potansiyel müşteri",
    byType: "Türe göre",
    interactedTitle: "Etkileşim kurulan müşteriler",
    calledTitle: "Konuşulan müşteriler",
    calledHint: "Aranıp görüşülen",
    sourceFunnelChange: "Huni geçişi",
    sourceStageChange: "Aşama değişikliği",
    sourceComment: "Yorum bırakıldı",
    sourceInbox: "Mesaj (Telegram vb.)",
    transitionsWidgetTitle: "Huniler arası geçişler",
    transitionsEmpty: "Bu dönemde geçiş yok",
    snapshotWidgetTitle: "Mevcut durum — huni/aşamaya göre",
    loadError: "Yüklenemedi",
  },
  sheets: {
    title: "Google Sayfaları",
    subtitle: "Bir tablodaki potansiyel müşteriler (örneğin Meta Lead Ads’in kayıt düştüğü tablo) CRM’ye kendiliğinden gelir: her yeni satır bir anlaşma olur.",
    add: "Tablo bağla",
    empty: "Bağlı tablo yok",
    paused: "duraklatıldı",
    destination: "Müşteriler şuraya düşer",
    lastSync: "Kontrol edildi",
    neverSynced: "Henüz kontrol edilmedi",
    totalImported: "oluşturulan anlaşma: {n}",
    rows: "tablodaki satır: {n}",
    syncNow: "Şimdi kontrol et",
    pause: "Duraklat",
    resume: "Devam et",
    edit: "Düzenle",
    remove: "Bağlantıyı kes",
    removeConfirm: "«{name}» bağlantısı kesilsin mi? Oluşturulan anlaşmalar kalır.",
    removed: "Tablo bağlantısı kesildi",
    imported: "Yeni anlaşma: {n}",
    nothingNew: "Yeni satır yok",
    error: "Bir şeyler ters gitti",
    connected: "Tablo bağlandı. Yeni satırlar CRM’de kendiliğinden görünür",
    connectedImported: "Tablo bağlandı, yüklenen anlaşma: {n}",
    saved: "Kaydedildi",
    howTitle: "Nasıl çalışır",
    "how1": "CRM tabloya 2 dakikada bir bakar ve yalnızca yeni satırları alır.",
    "how2": "Bir satır, seçilen huni ve aşamada kişi ve anlaşma olur. Tekrar olmaz: her satır bir kez okunur.",
    "how3": "Telefonu ve e-postası olmayan satırlar atlanır.",
    "how4": "Form soru yanıtları anlaşma notuna düşer; «Lead alanları» bölümünde alanlara eşleyebilirsiniz.",
    addTitle: "Google tablosu bağla",
    editTitle: "Tablo ayarları",
    accessTitle: "Önce tabloya erişimi açın",
    accessHint: "Tabloda «Paylaş» → «Bağlantıya sahip olan herkes» → «Görüntüleyen» rolünü seçin. CRM tabloyu yalnızca okur, hiçbir şeyi değiştirmez.",
    link: "Tablo bağlantısı",
    check: "Kontrol et",
    tabHint: "Gerekli sekme açıkken adres çubuğundaki bağlantıyı kopyalayın: CRM tam olarak o sekmeyi okur.",
    found: "Tabloya erişilebiliyor. Veri olan satırlar: {n}",
    name: "Kaynak adı",
    namePh: "Örneğin, Meta: Kasım",
    defaultName: "Google tablosu",
    funnel: "Huni",
    stage: "Aşama",
    source: "Anlaşma kaynağı",
    sourceHint: "Anlaşmadaki kaynak etiketi (örneğin Facebook veya Instagram).",
    columns: "Hangi sütun ne anlama gelir",
    none: "— yok —",
    colIdHint: "Satırın benzersiz numarası: CRM tekrar anlaşma oluşturmaz",
    restHint: "Diğer sütunlar (form yanıtları, reklam, platform) anlaşma notuna düşer.",
    needContact: "Telefon veya e-posta sütununu seçin",
    col: {
      name: "Ad",
      phone: "Telefon",
      email: "E-posta",
      id: "Satır numarası (id)",
      createdAt: "Başvuru zamanı",
    },
    importExisting: "Tabloda zaten olan satırları da yükle ({n})",
    importExistingHint: "İşaretlenmezse yalnızca bağlandıktan sonra eklenen satırlar CRM’ye gelir.",
    cancel: "İptal",
    connect: "Bağla",
    save: "Kaydet",
    meta: {
      enable: "Meta’ya sonuçları bildir: «Kazanıldı» ve «Kaybedildi»",
      enableHint: "Reklam, satın alanlara benzeyen kişileri bulmayı öğrenir (Conversions API for CRM). Meta lead kimliği id sütunundan alınır.",
      dataset: "Veri kümesi ID",
      token: "Erişim belirteci",
      tokenSaved: "•••• kayıtlı (değiştirmek için yenisini girin)",
      tokenHint: "Her iki değeri reklam hesabı yöneticisi Meta Etkinlik Yöneticisi’nde oluşturur: veri kümesi → Ayarlar → Conversions API → «Belirteç oluştur». Belirteç yalnızca sunucuda saklanır ve gösterilmez.",
      wonEvent: "«Kazanıldı» olayı",
      lostEvent: "«Kaybedildi» olayı",
      testCode: "Test olay kodu (isteğe bağlı)",
      testCodeHint: "Kod girili olduğu sürece olaylar «Test olayları» sekmesine gider ve reklam istatistiklerine yansımaz. Gerçek gönderim için boş bırakın.",
      check: "Bağlantıyı kontrol et",
      ok: "Bağlantı var: {name}",
      checkLater: "Bağlantıyı kaydettikten sonra kontrol edebilirsiniz: kaynağı «Düzenle» ile açın.",
      badge: "Meta: sonuçlar",
    },
    err: {
      bad_url: "Bu bir Google tablosu bağlantısı değil",
      private: "Tabloya erişim yok. «Bağlantıya sahip olan herkes» ve «Görüntüleyen» rolünü açıp tekrar «Kontrol et»e basın.",
      bad_tab: "Tabloda böyle bir sekme yok. Gerekli sekmeyi açıp bağlantıyı yeniden kopyalayın.",
      not_found: "Tablo bulunamadı. Bağlantıyı kontrol edin.",
      empty: "Tablo boş",
      network: "Google’a ulaşılamadı. Daha sonra deneyin.",
      failed: "Tablo kontrol edilemedi",
    },
  },
  edu: {
    io: {
      import: "İçe aktar",
      export: "Dışa aktar",
      title: "Excel’den öğrenci içe aktarma",
      step1: "Şablonu indirin",
      step1Hint: "Çalışanlar doldurur: her öğrenci bir satır. «Yardım» sayfasında her şey anlatılır, grup listeden seçilir.",
      template: "Şablonu indir",
      step2: "Doldurulmuş dosyayı yükleyin",
      pick: "Dosya seç",
      change: "Başka dosya seç",
      drop: ".xlsx dosyasını buraya bırakın veya seçin",
      check: "Kontrol et",
      importN: "Yükle: {n}",
      cancel: "İptal",
      close: "Kapat",
      checked: "Yüklenebilir: {ok}. Düzeltilecek veya atlanacak: {bad}. Henüz hiçbir şey kaydedilmedi.",
      empty: "Dosyada dolu satır yok",
      doneTitle: "İçe aktarma tamamlandı",
      created: "eklendi",
      skipped: "atlandı",
      problems: "Sorunlu satırlar: {n}",
      row: "satır {n}",
      onlyXlsx: ".xlsx dosyası gerekli",
      templateError: "Şablon indirilemedi",
      importError: "Dosya yüklenemedi",
      exportError: "Dosya dışa aktarılamadı",
      err: { no_name: "ad eksik", no_group: "grup eksik", group_unknown: "böyle bir grup yok", group_archived: "grup arşivde", bad_date: "geçersiz tarih", bad_number: "geçersiz sayı", bad_lang: "dil uz veya ru olmalı", duplicate: "bu öğrenci grupta zaten var", group_full: "grup dolu", bad_package: "paketteki ders sayısı eksik", too_many_rows: "çok fazla satır (1000’e kadar)", failed: "kaydedilemedi" },
    },
    deal: {
      enroll: "Gruba kaydet",
      enrollAnother: "Başka bir gruba kaydet",
      enrolled: "{group}: {n} ders kaldı",
      openStudents: "Öğrencileri aç",
      noGroups: "Henüz grup yok. Önce Eğitim bölümünde bir grup oluşturun.",
      toGroups: "Gruplara",
      linkHint: "Ad, telefon ve kişi anlaşmadan alındı, yeniden girmeye gerek yok. Ödemeleri öğrenci kartına girin.",
      openDeal: "Anlaşma",
      openContact: "Kişi",
    },
    title: "Eğitim",
    add: "Ekle",
    all: "Hepsi",
    archive: "Arşivle",
    restore: "Geri al",
    cancel: "İptal",
    close: "Kapat",
    copied: "Kopyalandı",
    copy: "Kopyala",
    date: "Tarih",
    delete: "Sil",
    edit: "Düzenle",
    end: "Bitiş",
    start: "Başlangıç",
    group: "Grup",
    loading: "Yükleniyor…",
    note: "Not",
    save: "Kaydet",
    saved: "Kaydedildi",
    d1: "Pzt",
    d2: "Sal",
    d3: "Çar",
    d4: "Per",
    d5: "Cum",
    d6: "Cmt",
    d7: "Paz",
    dl1: "Pazartesi",
    dl2: "Salı",
    dl3: "Çarşamba",
    dl4: "Perşembe",
    dl5: "Cuma",
    dl6: "Cumartesi",
    dl7: "Pazar",
    status: {
      present: "Geldi",
      late: "Geç kaldı",
      absent: "Gelmedi",
      excused: "Mazeretli",
    },
    st: {
      active: "Devam ediyor",
      frozen: "Dondurulmuş",
      left: "Ayrıldı",
      completed: "Tamamladı",
    },
    method: {
      cash: "Nakit",
      card: "Kart",
      transfer: "Havale",
      other: "Diğer",
    },
    tabs: {
      today: "Bugün",
      groups: "Gruplar",
      students: "Öğrenciler",
      debts: "Borçlar",
      report: "Devamsızlık",
      settings: "Ayarlar",
    },
    sum: {
      students: "öğrenci devam ediyor",
      lessonsToday: "bugünkü ders işaretlendi",
      debt: "borç ({n} öğr.)",
      low: "paketi bitiyor",
    },
    today: {
      prev: "Önceki gün",
      next: "Sonraki gün",
      goToday: "Bugüne dön",
      noLessons: "Bu gün için ders yok",
      markAll: "Hepsi geldi",
      save: "Kaydet",
      saved: "Yoklama kaydedildi",
      progress: "{n} kişiden {m} işaretlendi",
      notMarked: "İşaretlenmedi",
      held: "Yapıldı",
      cancelled: "İptal edildi",
      cancel: "Dersi iptal et",
      reopen: "Geri al",
      cancelPrompt: "İptal nedeni (isteğe bağlı):",
      readonly: "Düzenleme kapalı: işaretler yalnızca son {n} gün içinde değiştirilebilir.",
      extra: "ek ders",
      addLesson: "Ek ders",
      left: "{n} kaldı",
      debt: "borç",
      noStudents: "Grupta öğrenci yok",
    },
    groups: {
      new: "Yeni grup",
      edit: "Grubu düzenle",
      name: "Ad",
      course: "Kurs",
      teacher: "Öğretmen",
      room: "Sınıf",
      color: "Renk",
      schedule: "Program",
      day: "Gün",
      addSlot: "Gün ekle",
      startDate: "Kurs başlangıcı",
      endDate: "Kurs bitişi",
      capacity: "Gruptaki yer",
      capacityHint: "0 — sınırsız",
      packageLessons: "Paketteki ders",
      packagePrice: "Paket fiyatı",
      showArchived: "Arşivdekileri göster",
      archiveConfirm: "“{name}” grubu arşive alınsın mı? Bu grup için yeni ders oluşturulmaz.",
      none: "Henüz grup yok",
      studentsCount: "{n} öğr.",
      frozenCount: "{n} dondurulmuş",
      packageShort: "paket {n} ders · {price}",
    },
    students: {
      new: "Yeni öğrenci",
      name: "Ad",
      phone: "Telefon",
      parent: "Veli",
      parentName: "Veli adı",
      parentPhone: "Veli telefonu",
      parentLang: "Veliye mesaj dili",
      langDefault: "Varsayılan",
      joined: "Kayıt tarihi",
      withPackage: "Ders paketiyle kaydet",
      lessons: "Ders",
      price: "Fiyat",
      paid: "Ödenen",
      contactHint: "Telefon girilirse CRM’de otomatik kişi kartı oluşturulur.",
      search: "Ad veya telefon",
      allGroups: "Tüm gruplar",
      activeFrozen: "Devam eden ve dondurulmuş",
      anyBalance: "Her bakiye",
      onlyDebt: "Yalnızca borçlular",
      onlyLow: "Paketi bitiyor",
      needGroup: "Önce “Gruplar” sekmesinde bir grup oluşturun.",
      none: "Öğrenci yok",
      leftLessons: "ders kaldı",
      debt: "borç",
      credit: "fazla ödeme",
      leftAt: "Ayrılma",
      balanceHint: "Alınan {bought}, kullanılan {used}, düzeltme {adjust}",
      packages: "Paketler ve ödemeler",
      addPackage: "Yeni paket",
      addPayment: "Ödeme",
      noPackages: "Paket yok",
      packageLine: "{n} derslik paket",
      amount: "Tutar",
      method: "Yöntem",
      deletePaymentConfirm: "Bu ödeme silinsin mi?",
      deletePackageConfirm: "Paket ödemeleriyle birlikte silinsin mi?",
      telegram: "Velinin Telegram’ı",
      noBot: "Bot bağlı değil: Ayarlar → Eğitim.",
      tgLinked: "Veli bağlandı",
      tgMuted: "bildirimler veli tarafından kapatıldı",
      tgNotLinked: "Veli henüz bağlanmadı: bağlantıyı gönderin",
      remindDebt: "Borcu hatırlat",
      remindLow: "Ödemeyi hatırlat",
      reminded: "Hatırlatma gönderildi",
      history: "Devam geçmişi",
      noHistory: "Henüz ders olmadı",
      status: "Durum",
      transfer: "Grup",
      transferConfirm: "Öğrenci başka bir gruba taşınsın mı?",
      adjust: "Ders düzeltmesi",
      adjustHint: "+N veya −N: telafi, aktarım vb.",
      leftReasonPrompt: "Neden (isteğe bağlı):",
      delete: "Öğrenciyi sil",
      deleteConfirm: "Öğrenci silinsin mi? Yalnızca devam kaydı yoksa mümkündür.",
    },
    debts: {
      total: "Toplam borç",
      count: "Öğrenci: {n}",
      none: "Borç veya bitmek üzere olan paket yok",
      remind: "Hatırlat",
    },
    report: {
      from: "Başlangıç",
      to: "Bitiş",
      rate: "Devam",
      lessons: "yapılan ders: {n}",
      none: "Bu dönemde işaret yok",
    },
    settings: {
      open: "Ayarlar",
      charge: "Hangi durum paketten ders düşer",
      chargeHint: "İşaretli durumlar öğrencinin kalan derslerini azaltır. Bakiye her seferinde yeniden hesaplanır; kuralı değiştirmek tüm bakiyeleri günceller.",
      rules: "Kurallar ve eşikler",
      lowBalance: "Kalan ders şu kadar olunca uyar",
      lowBalanceHint: "0 — uyarma",
      absentStreak: "Yöneticiye görev için üst üste devamsızlık",
      absentStreakHint: "0 — görev oluşturma",
      assignee: "Görev kime atansın",
      assigneeAuto: "Grubu oluşturana",
      editDays: "Resepsiyon kaç gün öncesine kadar düzenleyebilir",
      editDaysHint: "Sahip ve yönetici her günü düzenleyebilir.",
      defaultPackage: "Varsayılan paket",
      defaultPackageHint: "Grupta paket belirtilmemişse kullanılır.",
      regional: "Saat ve dil",
      timezone: "Saat dilimi",
      parentLang: "Velilere mesaj dili",
      bot: "Veliler için Telegram botu",
      botHint: "Her eğitim merkezinin kendi botu vardır: veliler adını ve görselini görür.",
      botStep1: "Telegram’da @BotFather’ı açın ve /newbot gönderin.",
      botStep2: "Ad ve kullanıcı adı belirleyin (örneğin “Rustamov Academy” ve rustamov_academy_bot).",
      botStep3: "Aldığınız token’ı kopyalayıp buraya yapıştırın.",
      botConnect: "Bağla",
      botConnected: "Bot bağlandı",
      botDisconnect: "Ayır",
      botDisconnectConfirm: "Bot ayrılsın mı? Veliler mesaj almayı bırakır.",
      notify: "Veli bildirimleri",
      notifyHint: "Mesajlar yalnızca öğrenci kartındaki bağlantıyla bağlanan velilere gider.",
      notifyEnabled: "Bildirim gönder",
      notifyNeedBot: "Önce botu bağlayın.",
      onAbsent: "Öğrenci gelmediğinde",
      onLate: "Öğrenci geç kaldığında",
      onLow: "Paket bitmek üzereyken",
      templates: "Mesaj metinleri",
      templatesHint: "Varsayılan metin için boş bırakın. Kullanılabilir: {vars}",
    },
    tpl: {
      absent: "Gelmedi",
      late: "Geç kaldı",
      low: "Paket bitiyor",
      debt: "Borç",
    },
  },

  bottomNav: {
    more: "Daha fazla", label: "Ana gezinme",
    education: "Eğitim",
    dashboard: "Ana sayfa",
    contacts: "Kişiler",
    tasks: "Görevler",
    inbox: "Gelen kutusu",
    calls: "Aramalar",
    reviews: "Değerlendirmeler",
    funnels: "Huniler",
    analytics: "Analitik",
  },
  serverText: {
    unknownPhone: "Bilinmiyor ({phone})",
    unknown: "Bilinmiyor",
    assignedTo: "{name} kişisine atandı",
    bulk: " (toplu)",
    archived: "Arşivlendi",
    unarchived: "Arşivden geri yüklendi",
    unassigned: "Atanmamış",
    claimed: "Üstlendi",
  },
};
